(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-mv"] && !Shopify.designMode) return;
  try {
    
  // Background videos: mobile browsers often ignore the declarative `autoplay`
  // attribute, so nudge muted videos into playing (allowed without a gesture),
  // retry when they scroll into view, and fall back to a first play on the first
  // user interaction. The poster frame shows if playback is truly blocked.
  (function () {
    var vids = document.querySelectorAll('[data-about-video]');
    if (!vids.length) return;
    function play(v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    vids.forEach(function (v) {
      play(v);
      v.addEventListener('canplay', function () { play(v); }, { once: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) play(e.target); });
        }, { threshold: 0.15 }).observe(v);
      }
    });
    var kick = function () { vids.forEach(play); document.removeEventListener('touchstart', kick); document.removeEventListener('scroll', kick); };
    document.addEventListener('touchstart', kick, { passive: true, once: true });
    document.addEventListener('scroll', kick, { passive: true, once: true });
  })();

  (function () {
    var root = document.querySelector('[data-about]');
    if (!root) return;
    var items = root.querySelectorAll('.about__reveal');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers-seo"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bsseo]').forEach(function (root) {
    var btn = root.querySelector('[data-bsseo-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = root.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Read less' : 'Read more';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["build-review"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-build-review]');
    if (!root) return;

    var $ = function (sel) { return root.querySelector(sel); };

    /* ---- Full-size image lightbox (zoom + prev/next + thumbnail filmstrip),
       matching the setting details page. Reads the DOM at click-time, so it
       works with the async-populated media. The 360° cell is excluded — it
       opens the spin viewer instead. ---- */
    (function () {
      var media = $('.br__media');
      var lb = $('[data-br-lb]'), lbImg = $('[data-br-lb-img]');
      var lbPrev = $('[data-br-lb-prev]'), lbNext = $('[data-br-lb-next]'), lbThumbs = $('[data-br-lb-thumbs]');
      if (!media || !lb || !lbImg) return;
      var list = [], idx = 0, scale = 1;
      function setZoom(s, ox, oy) {
        scale = Math.max(1, Math.min(s, 3));
        lbImg.style.transformOrigin = (ox != null) ? (ox + '% ' + oy + '%') : 'center';
        lbImg.style.transform = 'scale(' + scale + ')';
        lbImg.classList.toggle('is-zoomed', scale > 1);
      }
      function show(i) {
        if (!list.length) return;
        idx = (i % list.length + list.length) % list.length;
        lbImg.src = list[idx];
        setZoom(1);
        var multi = list.length > 1;
        if (lbPrev) lbPrev.hidden = !multi;
        if (lbNext) lbNext.hidden = !multi;
        if (lbThumbs) { var t = lbThumbs.querySelectorAll('.br__lb-thumb'); for (var j = 0; j < t.length; j++) t[j].classList.toggle('is-active', j === idx); }
      }
      function buildThumbs() {
        if (!lbThumbs) return;
        lbThumbs.innerHTML = '';
        if (list.length < 2) { lbThumbs.hidden = true; return; }
        lbThumbs.hidden = false;
        list.forEach(function (src, i) {
          var btn = document.createElement('button');
          btn.type = 'button'; btn.className = 'br__lb-thumb';
          var im = document.createElement('img'); im.src = src; im.alt = '';
          btn.appendChild(im);
          btn.addEventListener('click', function (e) { e.stopPropagation(); show(i); });
          lbThumbs.appendChild(btn);
        });
      }
      function collect() {
        list = [];
        var shots = media.querySelectorAll('.br__shot');
        for (var i = 0; i < shots.length; i++) {
          var s = shots[i];
          if (s.hasAttribute('data-br-diamond-360-fig')) continue;
          if (s.hidden || getComputedStyle(s).display === 'none') continue;
          var im = s.querySelector('.br__img');
          if (im && im.classList.contains('is-shown') && im.getAttribute('src')) list.push(im.getAttribute('src'));
        }
      }
      function open(src) {
        collect();
        buildThumbs();
        var start = list.indexOf(src);
        show(start < 0 ? 0 : start);
        lb.hidden = false; document.documentElement.style.overflow = 'hidden';
      }
      function close() { lb.hidden = true; document.documentElement.style.overflow = ''; setZoom(1); }

      media.addEventListener('click', function (e) {
        var fig = e.target.closest('.br__shot');
        if (!fig || fig.hasAttribute('data-br-diamond-360-fig')) return;
        var im = fig.querySelector('.br__img');
        if (im && im.classList.contains('is-shown') && im.getAttribute('src')) open(im.getAttribute('src'));
      });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      lbImg.addEventListener('click', function (e) {
        e.stopPropagation();
        if (scale > 1) { setZoom(1); return; }
        var r = lbImg.getBoundingClientRect();
        setZoom(2, ((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
      });
      lbImg.addEventListener('mousemove', function (e) {
        if (scale <= 1) return;
        var r = lbImg.getBoundingClientRect();
        lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
      });
      lbImg.addEventListener('wheel', function (e) {
        e.preventDefault();
        var r = lbImg.getBoundingClientRect();
        setZoom(scale + (e.deltaY < 0 ? 0.3 : -0.3), ((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
      }, { passive: false });
      var cb = $('[data-br-lb-close]');
      if (cb) cb.addEventListener('click', function (e) { e.stopPropagation(); close(); });
      if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
      if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') show(idx - 1);
        else if (e.key === 'ArrowRight') show(idx + 1);
      });
    })();

    /* ---- Mobile carousel dots — one image per swipe. Rebuilt whenever the
       visible shots change (side/macro/model populate async). ---- */
    (function () {
      var media = $('.br__media');
      var dotsWrap = $('[data-br-dots]');
      if (!media || !dotsWrap) return;
      function visibleShots() {
        return [].slice.call(media.querySelectorAll('.br__shot')).filter(function (s) { return !s.hidden && getComputedStyle(s).display !== 'none'; });
      }
      function updateDots() {
        var dots = dotsWrap.querySelectorAll('.br__dot');
        if (!dots.length) return;
        var shots = visibleShots();
        var center = media.scrollLeft + media.clientWidth / 2, active = 0, best = Infinity;
        for (var i = 0; i < shots.length; i++) { var c = shots[i], cc = c.offsetLeft + c.offsetWidth / 2, d = Math.abs(cc - center); if (d < best) { best = d; active = i; } }
        for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === active);
      }
      function buildDots() {
        dotsWrap.innerHTML = '';
        var shots = visibleShots();
        if (shots.length < 2) return;
        shots.forEach(function (shot) {
          var dot = document.createElement('span');
          dot.className = 'br__dot';
          dot.addEventListener('click', function () { shot.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); });
          dotsWrap.appendChild(dot);
        });
        updateDots();
      }
      media.addEventListener('scroll', function () { window.requestAnimationFrame(updateDots); }, { passive: true });
      window.addEventListener('resize', function () { window.requestAnimationFrame(updateDots); });
      buildDots();
      if (window.MutationObserver) {
        var pend = false;
        new MutationObserver(function () { if (pend) return; pend = true; setTimeout(function () { pend = false; buildDots(); }, 150); })
          .observe(media, { attributes: true, attributeFilter: ['hidden', 'class'], subtree: true });
      }
    })();

    var bp = new URLSearchParams(window.location.search);
    var p = {
      setting: bp.get('setting') || '',
      variant: bp.get('variant') || '',
      metal: bp.get('metal') || '',
      shape: (bp.get('shape') || '').toLowerCase(),
      diamond: bp.get('diamond') || '',
      dimg: bp.get('dimg') || '',
      // handle:qty pairs, no prices — those are read from each product below
      ref: bp.get('ref') || '',
      flow: bp.get('flow') === 'diamond' ? 'diamond' : 'setting'
    };

    var emptyEl = $('[data-br-empty]');
    var mainEl = $('[data-br-main]');

    if (!p.setting || !p.diamond) {
      if (emptyEl) emptyEl.hidden = false;
      return;
    }

    function money(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function esc(s) { return String(s == null ? '' : s); }

    // Parse diamond specs from its title, e.g. "1.00ct Pear Lab Diamond — D VVS1"
    function parseDiamond(title) {
      var t = String(title || '');
      var d = { carat: '', shape: '', color: '', clarity: '' };
      var m = t.match(/([\d.]+)\s*ct/i); if (m) d.carat = m[1];
      m = t.match(/ct\s+([A-Za-z]+)\s+Lab/i); if (m) d.shape = m[1];
      m = t.match(/[—\-]\s*([A-Z]+)\s+(\S+)/); if (m) { d.color = m[1]; d.clarity = m[2]; }
      return d;
    }

    // Map a chosen metal to the colour slug used in the setting image alt tokens.
    function metalSlug(metal) {
      metal = (metal || '').toLowerCase();
      if (metal.indexOf('white') !== -1) return 'white-gold';
      if (metal.indexOf('platinum') !== -1) return 'white-gold'; // platinum -> white
      if (metal.indexOf('rose') !== -1) return 'rose-gold';
      return 'yellow-gold';
    }

    // Pick the setting photo that matches the chosen metal + shape, using the image
    // ALT tokens ("<metal>-<shape>-<angle>") — the same source of truth the
    // configurator gallery uses. Falls back to yellow-gold, then any angle.
    function settingImageFor(sp, metal, shape, angle) {
      angle = angle || 'front';
      var media = sp.media || [];
      var ms = metalSlug(metal);
      shape = (shape || '').toLowerCase();
      if (!shape) return null;
      function find(token) {
        for (var i = 0; i < media.length; i++) {
          if (media[i].media_type && media[i].media_type !== 'image') continue;
          var alt = (media[i].alt || '').toLowerCase();
          if (token && alt.indexOf(token) !== -1) {
            return (media[i].preview_image && media[i].preview_image.src) || media[i].src || null;
          }
        }
        return null;
      }
      var r = find(ms + '-' + shape + '-' + angle) || find('yellow-gold-' + shape + '-' + angle);
      if (!r && angle === 'front') { r = find(ms + '-' + shape) || find('yellow-gold-' + shape); }
      return r;
    }

    var settingUrl = '/products/' + encodeURIComponent(p.setting);
    var diamondUrl = '/products/' + encodeURIComponent(p.diamond);
    var state = { settingCents: 0, diamondCents: 0, settingVariantId: p.variant, diamondVariantId: '', diamond: {}, settingName: '', diamondSku: '' };

    Promise.all([
      fetch(settingUrl + '.js', { headers: { 'X-Requested-With': 'fetch' } }).then(function (r) { return r.json(); }),
      fetch(diamondUrl + '.js', { headers: { 'X-Requested-With': 'fetch' } }).then(function (r) { return r.json(); }),
      fetch(settingUrl + '?view=builder-data').then(function (r) { return r.json(); }).catch(function () { return {}; }),
      fetch(diamondUrl + '?view=builder-data').then(function (r) { return r.json(); }).catch(function () { return {}; })
    ]).then(function (res) {
      var sp = res[0], dp = res[1], sMeta = res[2] || {}, dMeta = res[3] || {};

      // ---- Setting ----
      // Shape is a real variant axis on settings, so the variant is resolved from the
      // metal the customer picked plus the shape of the diamond they actually chose.
      // The variant id in the URL only ever knew the metal, and goes stale the moment
      // they switch shape mid-flow — which is why checkout used to show the wrong ring.
      var settingShape = (parseDiamond(dp.title).shape || p.shape || '').toLowerCase();
      var sv = null;
      var wantMetal = String(p.metal || '').trim().toLowerCase();
      if (wantMetal && settingShape) {
        for (var i = 0; i < (sp.variants || []).length; i++) {
          var vv = sp.variants[i];
          if (String(vv.option1 || '').trim().toLowerCase() === wantMetal &&
              String(vv.option2 || '').trim().toLowerCase() === settingShape) { sv = vv; break; }
        }
      }
      // Older links (and any shape with no matching variant) still resolve by id.
      if (!sv) {
        for (var j = 0; j < (sp.variants || []).length; j++) {
          if (String(sp.variants[j].id) === String(p.variant)) { sv = sp.variants[j]; break; }
        }
      }
      if (!sv && sp.variants) sv = sp.variants[0];
      state.settingVariantId = sv ? sv.id : p.variant;
      state.settingCents = sv ? sv.price : 0;
      var settingBase = (sp.title || 'Setting').replace(/\s*engagement ring\s*$/i, '').trim();
      state.settingName = settingBase + ' Setting';
      // Match the setting photo to the diamond the customer actually chose — if they
      // switched the shape mid-flow (e.g. round -> oval), the setting should follow.
      var settingImg = settingImageFor(sp, p.metal, settingShape, 'front') || (sv && sv.featured_image && sv.featured_image.src) || sp.featured_image || (sp.images && sp.images[0]);
      var settingSide = settingImageFor(sp, p.metal, settingShape, 'side');
      var settingMacro = settingImageFor(sp, p.metal, settingShape, 'macro');
      var settingModel = settingImageFor(sp, p.metal, settingShape, 'model');

      // ---- Diamond ----
      var dv = (dp.variants && dp.variants[0]) || null;
      state.diamondVariantId = dv ? dv.id : '';
      state.diamondCents = dv ? dv.price : 0;
      state.diamondSku = dv ? (dv.sku || '') : '';
      state.diamond = parseDiamond(dp.title);
      // Build is fully resolved — determine whether this ring is already in the cart.
      loadCartState();
      var diamondImg = p.dimg || dMeta.image_url || dp.featured_image || (dp.images && dp.images[0]);

      // ---- Populate media ----
      function showImg(sel, src) { var el = $(sel); if (el && src) { el.src = src; el.alt = ''; el.classList.add('is-shown'); } }
      function showShot(imgSel, figSel, src) {
        var img = $(imgSel), fig = $(figSel);
        if (src && img) { img.src = src; img.alt = ''; img.classList.add('is-shown'); if (fig) fig.hidden = false; }
        else if (fig) { fig.hidden = true; }
      }
      // Diamond: a clean still image, plus a second cell that launches the 360°
      // spin viewer in a lightbox (same two-view pattern as the diamond info page).
      showImg('[data-br-diamond-still]', diamondImg);
      showImg('[data-br-diamond-img]', diamondImg);
      var modal360 = $('[data-br-360-modal]'), frame360 = $('[data-br-360-frame]');
      function open360(url) {
        if (!modal360 || !frame360 || !url) return;
        frame360.innerHTML = '';
        var f = document.createElement('iframe');
        f.src = url; f.setAttribute('allow', 'autoplay'); f.setAttribute('allowfullscreen', '');
        f.setAttribute('referrerpolicy', 'no-referrer'); f.setAttribute('title', '360 degree view of your diamond');
        frame360.appendChild(f);
        modal360.hidden = false; document.body.style.overflow = 'hidden';
      }
      function close360() { if (!modal360 || modal360.hidden) return; modal360.hidden = true; frame360.innerHTML = ''; document.body.style.overflow = ''; }
      var dvid = dMeta.video_url;
      var btn360 = $('[data-br-360-open]');
      var fig360 = $('[data-br-diamond-360-fig]');
      if (dvid && btn360) {
        var vsep = dvid.indexOf('?') !== -1 ? '&' : '?';
        var vurl = dvid + vsep + 'autoplay=1';
        if (fig360) fig360.hidden = false;
        btn360.hidden = false;
        btn360.addEventListener('click', function () { open360(vurl); });
      }
      var closers360 = document.querySelectorAll('[data-br-360-close]');
      for (var ci = 0; ci < closers360.length; ci++) closers360[ci].addEventListener('click', close360);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close360(); });
      // Setting: front (main) + side + on-the-hand model shot when available.
      showImg('[data-br-setting-img]', settingImg);
      showShot('[data-br-setting-side]', '[data-br-setting-side-fig]', settingSide);
      showShot('[data-br-setting-macro]', '[data-br-setting-macro-fig]', settingMacro);
      showShot('[data-br-setting-model]', '[data-br-setting-model-fig]', settingModel);

      // ---- Title ----
      var d = state.diamond;
      var diamondPhrase = [d.carat ? d.carat + ' Carat' : '', d.color, d.clarity, d.shape].filter(Boolean).join(' ');
      $('[data-br-title]').textContent = state.settingName + (diamondPhrase ? ' with a ' + diamondPhrase + ' Diamond' : ' with your diamond');

      // ---- Setting card ----
      $('[data-br-setting-name]').textContent = state.settingName;
      $('[data-br-setting-metal]').textContent = p.metal || (sv ? sv.title : '');
      $('[data-br-setting-price]').textContent = money(state.settingCents);

      // ---- Diamond card ----
      $('[data-br-diamond-name]').textContent = d.shape ? d.shape + ' diamond' : 'Diamond';
      $('[data-br-diamond-sub]').textContent = [d.carat ? d.carat + 'ct' : '', d.color, d.clarity].filter(Boolean).join(' ');
      $('[data-br-diamond-price]').textContent = money(state.diamondCents);

      // ---- Flow-aware back navigation ----
      // "Change setting" always opens the full settings listing (not the single
      // setting product), carrying the chosen diamond so re-picking a setting
      // returns straight to this review with the same stone.
      var settingChange = '/collections/engagement-rings?flow=diamond&diamond=' + encodeURIComponent(p.diamond) + '&dimg=' + encodeURIComponent(p.dimg);
      var diamondChange;
      if (p.flow === 'diamond') {
        diamondChange = '/collections/loose-diamonds?flow=diamond';
      } else {
        diamondChange = '/collections/loose-diamonds?setting=' + encodeURIComponent(p.setting) +
          '&variant=' + encodeURIComponent(p.variant) + '&metal=' + encodeURIComponent(p.metal) + '&shape=' + encodeURIComponent(p.shape);
      }
      $('[data-br-setting-change]').href = settingChange;
      $('[data-br-diamond-change]').href = diamondChange;

      // ---- Step bar back-links (on the visible, flow-matching bar) ----
      var bar = root.querySelector('.cfg-steps[data-cfg-flow="' + p.flow + '"]');
      if (bar) {
        var s1 = bar.querySelector('[data-cfg-step="1"]');
        var s2 = bar.querySelector('[data-cfg-step="2"]');
        if (p.flow === 'diamond') {
          if (s1) s1.href = diamondChange;  // Select your Diamond
          if (s2) s2.href = settingChange;  // Select your Setting
        } else {
          if (s1) s1.href = settingChange;  // Select your Setting
          if (s2) s2.href = diamondChange;  // Select your Stone
        }
      }

      // ---- Totals ----
      // state.refineCents only counts refinements whose product resolved, so a
      // not-yet-purchasable one is listed but never silently added to the total.
      function brRenderTotal() {
        var total = state.settingCents + state.diamondCents + (state.refineCents || 0);
        $('[data-br-total]').textContent = money(total);
        $('[data-br-sticky-total]').textContent = money(total);
      }
      brRenderTotal();

      // ---- Refinements (ref=handle:qty,handle:qty) ----
      state.refineCents = 0;
      state.refineLines = [];
      (function () {
        var listEl = root.querySelector('[data-br-refines]');
        var raw = (p.ref || '').trim();
        if (!listEl || !raw) return;

        var tokens = raw.split(',').map(function (t) {
          var bits = t.split(':');
          return { handle: (bits[0] || '').trim(), qty: Math.max(1, parseInt(bits[1], 10) || 1) };
        }).filter(function (t) { return t.handle; });
        if (!tokens.length) return;

        Promise.all(tokens.map(function (t) {
          return fetch('/products/' + encodeURIComponent(t.handle) + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; })
            .then(function (prod) { return { token: t, product: prod }; });
        })).then(function (results) {
          listEl.textContent = '';
          results.forEach(function (r) {
            var li = document.createElement('li');
            li.className = 'br__refine';
            var name = document.createElement('span');
            name.className = 'br__refine-name';
            var amt = document.createElement('span');
            amt.className = 'br__refine-amt';

            if (r.product && r.product.variants && r.product.variants.length) {
              var v = r.product.variants[0];
              var line = v.price * r.token.qty;
              name.textContent = r.token.qty > 1 ? r.product.title + ' \u00d7 ' + r.token.qty : r.product.title;
              amt.textContent = money(line);
              state.refineCents += line;
              state.refineLines.push({ id: v.id, qty: r.token.qty, title: r.product.title });
            } else {
              // Not purchasable yet: show it, price it later, never total it.
              name.textContent = r.token.handle.replace(/^refinement-/, '').replace(/-/g, ' ');
              amt.className += ' br__refine-amt--pending';
              amt.textContent = 'priced on request';
            }
            li.appendChild(name);
            li.appendChild(amt);
            listEl.appendChild(li);
          });
          listEl.hidden = false;
          brRenderTotal();
        });
      })();

      // ---- Details accordion (replaces the per-card "View details" links) ----
      function brRows(pairs) {
        var body = pairs.filter(function (r) { return r[0] && r[1] != null && r[1] !== ''; }).map(function (r) {
          return '<div class="br__deet"><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>';
        }).join('');
        return body ? '<dl class="br__deets">' + body + '</dl>' : '';
      }
      var CUTMAP = { EX: 'Excellent', EXCELLENT: 'Excellent', ID: 'Ideal', IDEAL: 'Ideal', VG: 'Very Good', 'VERY GOOD': 'Very Good', G: 'Good', GD: 'Good', GOOD: 'Good', F: 'Fair', FR: 'Fair', FAIR: 'Fair' };
      function cutLabel(v) { if (!v) return ''; var k = String(v).toUpperCase(); return CUTMAP[k] || v; }
      function joinAnd(a) { return a.length <= 1 ? a.join('') : a.slice(0, -1).join(', ') + ', and ' + a[a.length - 1]; }
      // Carat is quoted to two decimals by convention (and by the product title).
      function caratLabel(c) { var n = parseFloat(c); return isNaN(n) ? (c || '') : n.toFixed(2); }

      var metalTxt = p.metal || (sv ? sv.title : '');
      var dShape = dMeta.shape || d.shape || (p.shape ? p.shape.charAt(0).toUpperCase() + p.shape.slice(1) : '');
      var dColor = dMeta.color || d.color;
      var dClar = dMeta.clarity || d.clarity;
      var dCut = cutLabel(dMeta.cut);
      var dLab = dMeta.lab || '';
      var dCarat = caratLabel(dMeta.carat != null ? dMeta.carat : d.carat);
      var settingShort = state.settingName.replace(/\s*Setting$/, '');

      // Carry the stone's own specs onto its cart line so they survive into
      // checkout, the order admin and the confirmation email. The diamond line
      // otherwise reads as a bare title with no way to tell the stones apart.
      var dims = [dMeta.length_mm, dMeta.width_mm, dMeta.depth_mm].filter(function (v) { return v != null && v !== ''; });
      state.diamondSpecs = {
        'Shape': dShape,
        'Carat': dCarat ? dCarat + ' ct' : '',
        'Color': dColor,
        'Clarity': dClar,
        'Cut': dCut,
        'Certificate': dLab ? (dLab + ' ' + (dMeta.cert_number || '')).trim() : '',
        'Dimensions': dims.length === 3 ? dims.join(' \u00d7 ') + ' mm' : ''
      };

      // About your ring — one plain-language line built from the actual selection.
      var aboutEl = $('[data-br-about]');
      if (aboutEl) {
        var quals = [];
        if (dColor) quals.push(dColor + '-color');
        if (dClar) quals.push(dClar + '-clarity');
        if (dCut) quals.push(dCut + '-cut');
        var lead = [metalTxt, dShape].filter(Boolean).join(' / ');
        aboutEl.textContent = 'This ' + (lead ? lead + ' ' : '') + settingShort + ' Setting has a ' +
          (dCarat ? dCarat + ' Carat ' : '') + (dShape ? dShape + ' ' : '') +
          (dLab ? dLab + ' Certified ' : '') + 'lab-grown, conflict-free diamond' +
          (quals.length ? ' with ' + joinAnd(quals) : '') + '.';
      }

      // Ring setting details — the setting's own product_details spec list.
      var setDet = $('[data-br-setting-details]');
      if (setDet) {
        var pd = sMeta.product_details;
        if (pd && String(pd).trim()) {
          var parts = String(pd).split('·').map(function (x) { return x.trim(); }).filter(Boolean);
          setDet.innerHTML = '<dl class="br__deets">' + parts.map(function (part) {
            var ci = part.indexOf(':');
            if (ci > -1) return '<div class="br__deet"><dt>' + esc(part.slice(0, ci).trim()) + '</dt><dd>' + esc(part.slice(ci + 1).trim()) + '</dd></div>';
            return '<div class="br__deet br__deet--note"><dt>' + esc(part) + '</dt></div>';
          }).join('') + '</dl>';
        } else {
          setDet.innerHTML = brRows([['Setting', settingShort], ['Metal', metalTxt]]);
        }
      }

      // Diamond details — the stone's specs.
      var diaDet = $('[data-br-diamond-details]');
      if (diaDet) diaDet.innerHTML = brRows([
        ['Shape', dShape], ['Carat', dCarat ? dCarat + ' ct' : ''], ['Color', dColor],
        ['Clarity', dClar], ['Cut', dCut],
        ['Certificate', dLab ? (dLab + ' ' + (dMeta.cert_number || '')).trim() : '']
      ]);

      if (mainEl) mainEl.hidden = false;
      observeSticky();
    }).catch(function () {
      if (emptyEl) emptyEl.hidden = false;
    });

    // ---- Ring size options (quarter sizes: 3, 3¼, 3½, 3¾, 4, …) ----
    var sizeSel = $('[data-br-size]');
    if (sizeSel) {
      var quarters = ['', '¼', '½', '¾'];
      // q counts quarter-steps: 12 = size 3.0, 44 = size 11.0
      for (var q = 12; q <= 44; q += 1) {
        var label = String(Math.floor(q / 4)) + quarters[q % 4];
        var opt = document.createElement('option');
        opt.value = label; opt.textContent = 'US ' + label;
        sizeSel.appendChild(opt);
      }
    }

    // ---- Ring size control ------------------------------------------------
    // Mirrors the cart's control: the native <select> above stays the single
    // source of truth (everything else already reads its .value and listens for
    // 'change'); this only renders a nicer face for it and writes back.
    (function () {
      var wrap = $('[data-br-rs]');
      var btn = $('[data-br-rs-btn]');
      var pop = $('[data-br-rs-pop]');
      var list = $('[data-br-rs-list]');
      if (!wrap || !btn || !pop || !list || !sizeSel) return;

      var items = [];
      for (var i = 0; i < sizeSel.options.length; i++) {
        var o = sizeSel.options[i];
        if (!o.value) continue;                       // skip the placeholder
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.setAttribute('data-val', o.value);
        li.textContent = 'US ' + o.value;
        list.appendChild(li);
        items.push(li);
      }

      var focusIdx = -1;
      function paint() {
        var v = sizeSel.value;
        for (var i = 0; i < items.length; i++) {
          var on = items[i].getAttribute('data-val') === v;
          items[i].classList.toggle('is-sel', on);
          items[i].setAttribute('aria-selected', on ? 'true' : 'false');
          items[i].classList.toggle('is-focus', i === focusIdx);
        }
        $('[data-br-rs-val]').textContent = v ? 'US ' + v : 'Choose a size';
        wrap.classList.toggle('is-set', !!v);
        if (v) wrap.classList.remove('is-invalid');
      }
      function open() {
        pop.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        var sel = list.querySelector('.is-sel');
        focusIdx = sel ? items.indexOf(sel) : -1;
        paint();
        if (sel) sel.scrollIntoView({ block: 'nearest' });
      }
      function close() {
        pop.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        focusIdx = -1;
        paint();
      }
      function choose(v) {
        sizeSel.value = v;
        sizeSel.dispatchEvent(new Event('change', { bubbles: true }));
        close();
        btn.focus();
      }

      btn.addEventListener('click', function () {
        if (pop.hidden) open(); else close();
      });
      list.addEventListener('click', function (e) {
        var li = e.target.closest('li[data-val]');
        if (li) choose(li.getAttribute('data-val'));
      });
      document.addEventListener('click', function (e) {
        if (!pop.hidden && !wrap.contains(e.target)) close();
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          if (pop.hidden) { e.preventDefault(); open(); }
        }
      });
      wrap.addEventListener('keydown', function (e) {
        if (pop.hidden) return;
        var step = { ArrowDown: 1, ArrowUp: -1 }[e.key];
        if (step) {
          e.preventDefault();
          focusIdx = Math.max(0, Math.min(items.length - 1, (focusIdx < 0 ? 0 : focusIdx + step)));
          paint();
          items[focusIdx].scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'Enter' && focusIdx > -1) {
          e.preventDefault(); choose(items[focusIdx].getAttribute('data-val'));
        } else if (e.key === 'Escape') {
          e.preventDefault(); close(); btn.focus();
        }
      });
      // Anything that sets the size programmatically (e.g. editing a ring
      // already in the cart) still flows through to the face.
      sizeSel.addEventListener('change', paint);
      paint();
    })();

    // ---- Delivery date ----
    var lead = parseInt(root.getAttribute('data-lead-days'), 10) || 21;
    var dd = new Date(Date.now() + lead * 86400000);
    var dEl = $('[data-br-delivery]');
    if (dEl) dEl.textContent = dd.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });

    // ---- Engraving ----
    var eToggle = $('[data-br-engrave-toggle]');
    if (eToggle) {
      eToggle.addEventListener('click', function () {
        var wrap = eToggle.closest('.br__engrave');
        var open = wrap.classList.toggle('is-open');
        eToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    var eInput = $('[data-br-engraving]');
    var eCount = $('[data-br-engrave-count]');
    if (eInput && eCount) eInput.addEventListener('input', function () { eCount.textContent = eInput.value.length; });

    // Placeholder secondary actions
    ['[data-br-wishlist]', '[data-br-unsure]'].forEach(function (sel) {
      var el = $(sel);
      if (el) el.addEventListener('click', function (e) { e.preventDefault(); window.alert('Coming soon.'); });
    });

    // ---- Share this ring: native share sheet, with copy-link fallback ----
    var shareBtn = $('[data-br-share]');
    var toast = $('[data-br-toast]');
    var toastTimer = null;
    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 2400);
    }
    function legacyCopy(url) {
      try {
        var ta = document.createElement('textarea');
        ta.value = url; ta.setAttribute('readonly', '');
        ta.style.position = 'absolute'; ta.style.left = '-9999px';
        document.body.appendChild(ta); ta.select();
        document.execCommand('copy'); document.body.removeChild(ta);
        showToast('Link copied');
      } catch (e) { showToast('Copy the link from your browser bar'); }
    }
    function copyLink(url) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { showToast('Link copied'); }).catch(function () { legacyCopy(url); });
      } else { legacyCopy(url); }
    }
    var sharePop = $('[data-br-share-pop]');
    var shareWrap = $('[data-br-share-wrap]');
    var shareText = "I've been designing our ring — here's the one.";
    function openPop() {
      if (!sharePop) return;
      var url = window.location.href;
      var em = $('[data-br-share-email]');
      if (em) em.href = 'mailto:?subject=' + encodeURIComponent('My Margot Vane ring') + '&body=' + encodeURIComponent(shareText + '\n\n' + url);
      var wa = $('[data-br-share-wa]');
      if (wa) wa.href = 'https://wa.me/?text=' + encodeURIComponent(shareText + ' ' + url);
      sharePop.hidden = false;
      if (shareBtn) shareBtn.setAttribute('aria-expanded', 'true');
    }
    function closePop() {
      if (sharePop && !sharePop.hidden) { sharePop.hidden = true; if (shareBtn) shareBtn.setAttribute('aria-expanded', 'false'); }
    }
    if (shareBtn) {
      shareBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var url = window.location.href;
        var useNative = navigator.share && window.matchMedia('(max-width: 749px)').matches;
        if (useNative) {
          navigator.share({ title: 'My Margot Vane ring', text: shareText, url: url }).catch(function () {});
        } else if (sharePop && sharePop.hidden) {
          openPop();
        } else {
          closePop();
        }
      });
    }
    var copyEl = $('[data-br-copy]');
    if (copyEl) copyEl.addEventListener('click', function (e) { e.stopPropagation(); copyLink(window.location.href); closePop(); });
    if (sharePop) {
      sharePop.querySelectorAll('a.br__share-opt').forEach(function (a) { a.addEventListener('click', function () { closePop(); }); });
    }
    document.addEventListener('click', function (e) { if (shareWrap && !shareWrap.contains(e.target)) closePop(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });

    // ---- Add to cart (two linked line items) ----
    var sizeErr = $('[data-br-size-error]');
    var adding = false;
    var addNotice = $('[data-br-addnotice]');
    // The cart ring currently being edited (if any). Persisted in sessionStorage so it
    // survives the round-trip when the customer changes the setting or diamond via the
    // builder and returns here. Cleared on add/update and when the cart page is viewed.
    var EDIT_KEY = 'mv_edit_ring';
    var editRing = null; // { ringId, settingKey, diamondKey, settingVariantId, diamondVariantId, size, engraving }
    function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
    function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }

    function currentSize() { return sizeSel ? sizeSel.value : ''; }
    function currentEngraving() { return eInput ? eInput.value.trim() : ''; }
    function hasChanges() {
      if (!editRing) return false;
      return String(state.settingVariantId) !== String(editRing.settingVariantId)
        || String(state.diamondVariantId) !== String(editRing.diamondVariantId)
        || currentSize() !== editRing.size
        || currentEngraving() !== editRing.engraving;
    }
    function refreshAddLabel() {
      if (adding) return;
      var label = (editRing && hasChanges()) ? 'Update cart' : 'Add to cart';
      root.querySelectorAll('[data-br-add], [data-br-add-sticky]').forEach(function (b) { b.textContent = label; });
    }
    function setAddBtns(busy) {
      root.querySelectorAll('[data-br-add], [data-br-add-sticky]').forEach(function (b) {
        if (busy) { b.setAttribute('aria-busy', 'true'); b.textContent = (editRing && hasChanges()) ? 'Updating…' : 'Adding…'; }
        else { b.removeAttribute('aria-busy'); }
      });
      if (!busy) refreshAddLabel();
    }
    function ringFromLines(setLine, diaLine) {
      return {
        ringId: setLine.properties['_ring_id'],
        settingKey: setLine.key,
        diamondKey: diaLine.key,
        settingVariantId: setLine.variant_id,
        diamondVariantId: diaLine.variant_id,
        size: (setLine.properties['Ring size'] || '').replace('US ', '').trim(),
        engraving: setLine.properties['Engraving'] || ''
      };
    }
    // Locate a specific ring in the cart by its _ring_id. The diamond line carries a
    // "Setting" property; the setting line carries the "Ring size" / "Diamond" props.
    function findRingById(cart, rid) {
      var items = (cart && cart.items) || [];
      var setLine = null, diaLine = null;
      items.forEach(function (it) {
        if (!it.properties || it.properties['_ring_id'] !== rid) return;
        if (it.properties['Setting']) diaLine = it; else setLine = it;
      });
      return (setLine && diaLine) ? ringFromLines(setLine, diaLine) : null;
    }
    // Locate the ring in the cart that matches the CURRENT build (same setting + diamond).
    function findMatchedByBuild(cart) {
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (String(it.variant_id) !== String(state.settingVariantId) || !it.properties || !it.properties['_ring_id']) continue;
        for (var j = 0; j < items.length; j++) {
          var dj = items[j];
          if (String(dj.variant_id) === String(state.diamondVariantId) && dj.properties && dj.properties['_ring_id'] === it.properties['_ring_id']) {
            return ringFromLines(it, dj);
          }
        }
      }
      return null;
    }
    function resolveEditRing(cart) {
      var storedId = ssGet(EDIT_KEY);
      var er = storedId ? findRingById(cart, storedId) : null;
      if (!er) {
        er = findMatchedByBuild(cart);
        if (er) ssSet(EDIT_KEY, er.ringId);
        else if (storedId) ssDel(EDIT_KEY);
      }
      return er;
    }
    function loadCartState() {
      if (!state.settingVariantId || !state.diamondVariantId) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { editRing = resolveEditRing(cart); refreshAddLabel(); })
        .catch(function () { editRing = null; });
    }
    function showDupNotice() {
      if (!addNotice) return;
      addNotice.innerHTML = 'This ring is already in your cart. <a href="/cart">Review it in your cart &#8594;</a>';
      addNotice.hidden = false;
      addNotice.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    function settingPropsFor(ringId, size) {
      var d = state.diamond;
      var diamondLabel = [d.carat ? d.carat + 'ct' : '', d.shape, d.color, d.clarity].filter(Boolean).join(' ');
      var props = { '_ring_id': ringId, 'Ring size': 'US ' + size, 'Diamond': diamondLabel, 'Diamond SKU': state.diamondSku };
      var eng = currentEngraving();
      if (eng) props['Engraving'] = eng;
      return props;
    }
    function addNewRing(ringId, size) {
      var diamondProps = { '_ring_id': ringId };
      var specs = state.diamondSpecs || {};
      Object.keys(specs).forEach(function (k) { if (specs[k]) diamondProps[k] = specs[k]; });
      // Kept last, and kept unconditionally: findMatchedByBuild() uses the
      // presence of 'Setting' to tell the diamond line from the setting line.
      diamondProps['Setting'] = state.settingName + ' \u00b7 ' + (p.metal || '');
      var items = [
        { id: state.settingVariantId, quantity: 1, properties: settingPropsFor(ringId, size) },
        { id: state.diamondVariantId, quantity: 1, properties: diamondProps }
      ];
      // One line per refinement, sharing the ring id so the cart nests them
      // under the same ring card. Only resolved (purchasable) ones are here.
      (state.refineLines || []).forEach(function (r) {
        items.push({
          id: r.id,
          quantity: r.qty,
          properties: { '_ring_id': ringId, '_refinement': 'true', 'Refines': state.settingName }
        });
      });
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }
    function done() { ssDel(EDIT_KEY); window.location.href = '/cart'; }
    function addToCart() {
      if (adding) return;
      var size = currentSize();
      var rsWrap = $('[data-br-rs]'), rsBtn = $('[data-br-rs-btn]');
      if (!size) {
        if (sizeErr) sizeErr.hidden = false;
        // The native select is visually hidden now, so focus the control the
        // customer can actually see.
        if (rsWrap) rsWrap.classList.add('is-invalid');
        var target = rsBtn || sizeSel;
        if (target) { target.focus(); target.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        return;
      }
      if (sizeErr) sizeErr.hidden = true;
      if (rsWrap) rsWrap.classList.remove('is-invalid');
      if (!state.settingVariantId || !state.diamondVariantId) { window.alert('Sorry, we could not load your ring. Please try again.'); return; }

      adding = true;
      if (addNotice) addNotice.hidden = true;
      setAddBtns(true);

      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          editRing = resolveEditRing(cart);

          if (editRing && hasChanges()) {
            var sameVariants = String(state.settingVariantId) === String(editRing.settingVariantId)
              && String(state.diamondVariantId) === String(editRing.diamondVariantId);
            if (sameVariants) {
              // Only size/engraving changed -> update the setting line's props in place.
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: editRing.settingKey, quantity: 1, properties: settingPropsFor(editRing.ringId, size) })
              }).then(function (r) { if (!r.ok) throw new Error('update failed'); done(); });
            }
            // Setting and/or diamond changed -> ADD the new build first (so the ring is
            // never lost if a call fails), then best-effort remove the old ring's lines.
            var oldSettingKey = editRing.settingKey, oldDiamondKey = editRing.diamondKey;
            return addNewRing('mvr-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6), size)
              .then(function (r) { if (!r.ok) throw new Error('add failed'); })
              .then(function () {
                var updates = {};
                updates[oldSettingKey] = 0;
                updates[oldDiamondKey] = 0;
                return fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ updates: updates })
                }).catch(function () {}); // remove is best-effort; the new ring is already safe
              })
              .then(function () { done(); });
          }
          if (editRing) {
            // Already in the cart, unchanged -> don't duplicate.
            adding = false; setAddBtns(false); showDupNotice(); return;
          }
          // Fresh ring.
          return addNewRing('mvr-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6), size)
            .then(function (r) { if (!r.ok) throw new Error('add failed'); done(); });
        })
        .catch(function () {
          adding = false;
          setAddBtns(false);
          window.alert('Sorry, something went wrong. Please try again.');
        });
    }
    var addBtn = $('[data-br-add]'); if (addBtn) addBtn.addEventListener('click', addToCart);
    var addSticky = $('[data-br-add-sticky]'); if (addSticky) addSticky.addEventListener('click', addToCart);

    // Flip the button between "Add to cart" and "Update cart" as the customer edits.
    if (sizeSel) sizeSel.addEventListener('change', refreshAddLabel);
    if (eInput) eInput.addEventListener('input', refreshAddLabel);

    // Refresh whether/what ring is being edited whenever the page is shown (incl. bfcache
    // back from /cart). loadCartState is also called once the build finishes loading.
    window.addEventListener('pageshow', function () {
      adding = false;
      setAddBtns(false);
      if (addNotice) addNotice.hidden = true;
      loadCartState();
    });

    // ---- Sticky bar reveal when the main button scrolls out of view ----
    function observeSticky() {
      var sticky = $('[data-br-sticky]');
      var anchor = $('[data-br-add]');
      if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { sticky.classList.remove('is-shown'); sticky.hidden = true; }
          else { sticky.hidden = false; requestAnimationFrame(function () { sticky.classList.add('is-shown'); }); }
        });
      }, { rootMargin: '0px 0px -40px 0px' }).observe(anchor);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-ring"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-ring]');
    if (!root) return;

    // Viewing the cart ends any in-progress "edit this ring" session (Step 3 uses this to
    // decide Update-vs-Add). Editing restarts when the customer returns to Step 3.
    try { sessionStorage.removeItem('mv_edit_ring'); } catch (e) {}

    // Smart mobile checkout: hide the sticky bar whenever the main summary checkout
    // button is on screen, so the two CTAs never show at once.
    var mSticky = root.querySelector('.cr__msticky');
    var mainCheckout = root.querySelector('.cr__btn--primary');
    if (mSticky && mainCheckout && 'IntersectionObserver' in window) {
      var ckIO = new IntersectionObserver(function (entries) {
        mSticky.classList.toggle('cr__msticky--hidden', entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -88px 0px' });
      ckIO.observe(mainCheckout);
    }

    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
    }

    // Remove an entire ring (both linked line items) at once.
    root.querySelectorAll('[data-remove-keys]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var keys = (btn.getAttribute('data-remove-keys') || '').split(',').filter(Boolean);
        if (!keys.length) return;
        var updates = {};
        keys.forEach(function (k) { updates[k] = 0; });
        btn.setAttribute('aria-busy', 'true');
        post('/cart/update.js', { updates: updates })
          .then(function (r) { if (!r.ok) throw 0; window.location.reload(); })
          .catch(function () { btn.removeAttribute('aria-busy'); window.alert('Sorry, we couldn’t remove that. Please try again.'); });
      });
    });

    // Remove a single normal line.
    root.querySelectorAll('[data-remove-key]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        post('/cart/change.js', { id: btn.getAttribute('data-remove-key'), quantity: 0 })
          .then(function (r) { if (!r.ok) throw 0; window.location.reload(); })
          .catch(function () { window.alert('Sorry, we couldn’t remove that. Please try again.'); });
      });
    });

    // Ring size change on a setting line -> update that line's "Ring size" property,
    // preserving every other property (_ring_id, Diamond, Engraving, etc.).
    root.querySelectorAll('[data-cr-ringsize]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        if (!sel.value) return;
        // `item.properties | json` emits an array of [key, value] pairs, not an
        // object. Assigning a named key to that array is dropped by
        // JSON.stringify, so the update posted properties as an array and the
        // size silently never changed. Normalise to an object first.
        var raw = null;
        try { raw = JSON.parse(sel.getAttribute('data-props') || '{}'); } catch (e) { raw = null; }
        var props = {};
        if (Array.isArray(raw)) {
          raw.forEach(function (pair) { if (pair && pair.length === 2 && pair[1] != null) props[pair[0]] = pair[1]; });
        } else if (raw && typeof raw === 'object') {
          props = raw;
        }
        props['Ring size'] = 'US ' + sel.value;
        var qty = parseInt(sel.getAttribute('data-qty'), 10); if (isNaN(qty) || qty < 1) qty = 1;
        sel.setAttribute('aria-busy', 'true'); sel.disabled = true;
        post('/cart/change.js', { id: sel.getAttribute('data-key'), quantity: qty, properties: props })
          .then(function (r) { if (!r.ok) throw 0; window.location.reload(); })
          .catch(function () { sel.disabled = false; sel.removeAttribute('aria-busy'); window.alert('Sorry, we couldn’t update the ring size. Please try again.'); });
      });
    });

    // Quantity steppers on a normal line. Stepping to 0 removes the line, which
    // is what the minus button on the last unit is expected to do.
    root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      var current = parseInt(btn.getAttribute('data-qty'), 10);
      var step = parseInt(btn.getAttribute('data-qty-step'), 10);
      if (isNaN(current)) current = 1;
      btn.addEventListener('click', function () {
        var next = current + step;
        if (next < 0) return;
        btn.disabled = true;
        post('/cart/change.js', { id: btn.getAttribute('data-key'), quantity: next })
          .then(function (r) { if (!r.ok) throw 0; window.location.reload(); })
          .catch(function () { btn.disabled = false; window.alert('Sorry, we couldn’t update that. Please try again.'); });
      });
    });


    // Placeholder soft actions.
    root.querySelectorAll('[data-cr-soon]').forEach(function (b) {
      b.addEventListener('click', function () { window.alert('Coming soon.'); });
    });
  })();

    // Swap which of the paired photos leads. Delegated so it survives cart re-renders.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cr-swapbtn]');
      if (!btn) return;
      var wrap = btn.closest('[data-cr-swap]');
      if (!wrap) return;
      var main = wrap.querySelector('.cr__media-main');
      var small = btn.querySelector('img');
      if (!main || !small) return;
      var s = main.getAttribute('src'), a = main.getAttribute('alt');
      main.setAttribute('src', small.getAttribute('src'));
      main.setAttribute('alt', small.getAttribute('alt'));
      small.setAttribute('src', s);
      small.setAttribute('alt', a);
    });

    // Shipping slide-over: open/close, with Escape and overlay click.
    (function () {
      var panel = document.querySelector('[data-cr-shippanel]');
      var overlay = document.querySelector('[data-cr-shipoverlay]');
      if (!panel || !overlay) return;

      function open() {
        panel.hidden = false; overlay.hidden = false;
        requestAnimationFrame(function () { panel.classList.add('is-open'); overlay.classList.add('is-open'); });
        document.body.style.overflow = 'hidden';
        panel.querySelector('[data-cr-closeship]').focus();
      }
      function close() {
        panel.classList.remove('is-open'); overlay.classList.remove('is-open');
        document.body.style.overflow = '';
        // wait for the transition before hiding, or it snaps shut
        setTimeout(function () { panel.hidden = true; overlay.hidden = true; }, 280);
      }
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cr-openship]')) { e.preventDefault(); open(); }
        else if (e.target.closest('[data-cr-closeship]') || e.target === overlay) { close(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) close();
      });
    })();

    // Shop Pay installments: swap Shopify's "View sample plans" text link for the
    // round info button, without losing Shopify's own plans modal.
    (function () {
      var HIDE = ':host button, button { display: none !important; }';

      function dressUp(pt) {
        if (!pt || !pt.shadowRoot || pt.dataset.crDressed) return false;
        var btn = pt.shadowRoot.querySelector('button');
        if (!btn) return false;                 // component not hydrated yet
        var st = document.createElement('style');
        st.textContent = HIDE;
        pt.shadowRoot.appendChild(st);
        pt.dataset.crDressed = '1';
        return true;
      }

      // The web component hydrates asynchronously, so poll briefly rather than
      // assuming it is ready on DOMContentLoaded.
      var tries = 0;
      var timer = setInterval(function () {
        var done = true;
        document.querySelectorAll('shopify-payment-terms').forEach(function (pt) {
          if (!dressUp(pt)) done = false;
        });
        if ((done && tries > 0) || ++tries > 40) clearInterval(timer);
      }, 150);

      document.addEventListener('click', function (e) {
        var hit = e.target.closest('[data-cr-terms-info]');
        if (!hit) return;
        e.preventDefault();
        var row = hit.closest('[data-cr-terms]');
        var pt = row && row.querySelector('shopify-payment-terms');
        var btn = pt && pt.shadowRoot && pt.shadowRoot.querySelector('button');
        if (btn) btn.click();
      });
    })();

    // Ring size list -> drives the hidden native select so cart updates keep working.
    (function () {
      function closeAll(except) {
        document.querySelectorAll('[data-cr-rs-list]').forEach(function (l) {
          if (l === except) return;
          l.hidden = true;
          var b = l.parentElement.querySelector('[data-cr-rs-btn]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      }
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cr-rs-btn]');
        if (btn) {
          var list = btn.parentElement.querySelector('[data-cr-rs-list]');
          var willOpen = list.hidden;
          closeAll(list);
          list.hidden = !willOpen;
          btn.setAttribute('aria-expanded', String(willOpen));
          if (willOpen) {
            var sel = list.querySelector('.is-sel');
            if (sel) list.scrollTop = sel.offsetTop - 90;
          }
          return;
        }
        var opt = e.target.closest('[data-cr-rs-list] li');
        if (opt) {
          var wrap = opt.closest('[data-cr-rs]');
          var native = wrap.parentElement.querySelector('.cr__rs-native');
          wrap.querySelectorAll('li').forEach(function (l) { l.classList.remove('is-sel'); l.removeAttribute('aria-selected'); });
          opt.classList.add('is-sel'); opt.setAttribute('aria-selected', 'true');
          wrap.querySelector('[data-cr-rs-val]').textContent = opt.textContent;
          if (native) { native.value = opt.getAttribute('data-val'); native.dispatchEvent(new Event('change', { bubbles: true })); }
          closeAll();
          return;
        }
        closeAll();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-trust"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-trust]');
    if (!root) return;

    function copy(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).catch(function () { return fallback(text); });
      }
      return fallback(text);
    }
    function fallback(text) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      return Promise.resolve();
    }

    var note = root.querySelector('[data-ct-note]');
    function showNote(msg) { if (note) { note.textContent = msg; note.hidden = false; } }

    var shareBtn = root.querySelector('[data-ct-share]');
    if (shareBtn) shareBtn.addEventListener('click', function () {
      copy(window.location.origin + shareBtn.getAttribute('data-link')).then(function () { showNote('Link copied'); });
    });
    var saveBtn = root.querySelector('[data-ct-save]');
    if (saveBtn) saveBtn.addEventListener('click', function () {
      var msg = saveBtn.getAttribute('data-save-note') || 'Saved — keep this link to return to your ring';
      copy(window.location.origin + saveBtn.getAttribute('data-link')).then(function () { showNote(msg); });
    });

    root.querySelectorAll('.ct-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.ct-faq__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["configurator-setting"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cfg]');
    if (!root) return;

    var priceEl = root.querySelector('[data-cfg-price]');
    var metalLabel = root.querySelector('[data-cfg-metal-label]');
    var shapeLabel = root.querySelector('[data-cfg-shape-label]');
    var stickyConfig = root.querySelector('[data-cfg-sticky-config]');
    function prettyShape(s) {
      return (s || '').split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
    }
    function updateStickyConfig() {
      if (!stickyConfig) return;
      var shp = (typeof state !== 'undefined' && state.shape) ? prettyShape(state.shape) : '';
      var met = (typeof state !== 'undefined' && state.metal ? state.metal : '').trim();
      stickyConfig.textContent = [shp, met].filter(Boolean).join(' · ');
    }
    var gallery = root.querySelector('[data-cfg-images]');
    var primaryImg = root.querySelector('[data-cfg-primary]');

    var state = { variant: '', metal: '', shape: 'round' };

    var activeMetal = root.querySelector('.cfg-metal.is-active');
    if (activeMetal) {
      state.variant = activeMetal.getAttribute('data-cfg-variant');
      state.metal = activeMetal.getAttribute('data-metal');
    }
    // Scope to the radiogroups: the locked chip is also a .cfg-shape and sits
    // earlier in the DOM, so an unscoped query picked it up and left state.shape
    // null, which blanked the gallery until the customer clicked a shape.
    var activeShape = root.querySelector('.cfg__shapes .cfg-shape.is-active');
    if (activeShape) state.shape = activeShape.getAttribute('data-cfg-shape');

    // Collapse the shape grids down to the one already-chosen shape, with a
    // "Change shape" affordance. Used by BOTH entry points: a diamond chosen in
    // step 1 (diamond-first) and a shape chosen upstream in the mega menu.
    var lockedShapeShown = false;
    function showLockedShape(pill, note) {
      var lockField = root.querySelector('[data-cfg-shape-locked]');
      var lockBtn = root.querySelector('[data-cfg-shape-lock]');
      var lockVal = root.querySelector('[data-cfg-shape-lock-value]');
      var lockIcon = root.querySelector('[data-cfg-shape-locked-icon]');
      var lockNote = root.querySelector('[data-cfg-locked-note]');
      var lockBtnText = root.querySelector('[data-cfg-shape-change-text]');
      var shapeGroups = root.querySelector('[data-cfg-shape-groups]');
      if (!pill || !lockField || !lockBtn || !shapeGroups || lockedShapeShown) return;
      lockedShapeShown = true;

      if (lockVal) lockVal.textContent = pill.getAttribute('data-shape-label') || prettyShape(pill.getAttribute('data-cfg-shape'));
      // Reuse the chosen pill's own artwork so the locked chip looks native.
      var srcIcon = pill.querySelector('.cfg-shape__icon');
      if (lockIcon && srcIcon) lockIcon.innerHTML = srcIcon.innerHTML;
      if (lockNote && note) lockNote.textContent = note;
      lockField.hidden = false;
      shapeGroups.hidden = true;
      lockBtn.addEventListener('click', function () {
        var opening = shapeGroups.hidden;
        shapeGroups.hidden = !opening;
        lockBtn.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (lockBtnText) lockBtnText.textContent = opening ? 'Keep this shape' : 'Change shape';
      });
    }

    // Diamond-first: the diamond (and its shape) was already chosen in Step 1.
    // Lock the Shape selector to that diamond's shape so Step 3 can't conflict.
    var cfgSp = new URLSearchParams(window.location.search);
    var cfgDiamondFirst = cfgSp.get('flow') === 'diamond' && cfgSp.get('diamond');
    var cfgDShape = (cfgSp.get('dshape') || '').toLowerCase();
    if (cfgDiamondFirst && cfgDShape) {
      var lockShape = root.querySelector('.cfg-shape[data-cfg-shape="' + cfgDShape + '"]');
      if (lockShape) {
        root.querySelectorAll('.cfg-shape').forEach(function (x) {
          x.classList.remove('is-active');
          x.setAttribute('aria-checked', 'false');
        });
        lockShape.classList.add('is-active');
        lockShape.setAttribute('aria-checked', 'true');
        state.shape = cfgDShape;

        // Collapse the shape grids behind a one-line summary. Showing every
        // shape here invited a pick that conflicts with the chosen diamond.
        showLockedShape(lockShape, 'Matched to the diamond you chose.');
      }
    }

    // ---- Refinements drawer (shell) ----
    // Rows come from section blocks, so prices are whatever the merchant set.
    // Selections are recorded onto the Select-this-setting URL for step 3; this
    // drawer never touches the cart.
    (function () {
      var drawer = root.querySelector('[data-cfg-refine]');
      var opener = root.querySelector('[data-cfg-refine-open]');
      if (!drawer || !opener) return;

      var subtotalEl = drawer.querySelector('[data-cfg-refine-subtotal]');
      // Take the currency shape from the server-rendered zero ("$0.00") and swap
      // the number, so formatting follows the store. Liquid cannot be used in
      // this block: the javascript tag is not rendered through Liquid, and even
      // Liquid delimiters inside a comment trip theme-check.
      var moneySample = subtotalEl ? subtotalEl.textContent.trim() : '$0.00';

      function money(v) {
        var n = v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return moneySample.replace(/\d[\d.,]*/, n);
      }

      function chosen() {
        var out = [];
        drawer.querySelectorAll('[data-cfg-refine-control]').forEach(function (c) {
          var price = parseFloat(c.getAttribute('data-price') || '0') || 0;
          var name = c.getAttribute('data-name') || '';
          var handle = c.getAttribute('data-handle') || '';
          if (c.getAttribute('data-cfg-refine-control') === 'toggle') {
            if (c.checked) out.push({ name: name, qty: 1, price: price, handle: handle });
          } else {
            var q = parseInt(c.querySelector('[data-cfg-refine-qty]').textContent, 10) || 0;
            if (q > 0) out.push({ name: name, qty: q, price: price, handle: handle });
          }
        });
        return out;
      }

      var sumEl = root.querySelector('[data-cfg-refine-sum]');

      function sync() {
        var picks = chosen();
        var total = picks.reduce(function (s, p) { return s + p.price * p.qty; }, 0);
        if (subtotalEl) subtotalEl.textContent = money(total);
        // Hand the selection to step 3 via the Select-this-setting link.
        // Compact, price-free token list for step 3. Never pass the money: a
        // customer could edit it. Step 3 looks each price up from the product.
        state.refinements = picks.filter(function (p) { return p.handle; })
          .map(function (p) { return p.handle + ':' + p.qty; }).join(',');
        // One quiet line under the link: "Euroshank +$150, Birthstone × 2 +$160".
        if (sumEl) {
          sumEl.textContent = picks.map(function (p) {
            var label = p.qty > 1 ? p.name + ' \u00d7 ' + p.qty : p.name;
            return label + ' +' + money(p.price * p.qty);
          }).join(', ');
          sumEl.hidden = picks.length === 0;
        }
      }

      function open() {
        drawer.hidden = false;
        opener.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
      }
      function close() {
        drawer.hidden = true;
        opener.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
      }

      opener.addEventListener('click', open);
      drawer.querySelectorAll('[data-cfg-refine-close]').forEach(function (b) {
        b.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !drawer.hidden) close();
      });

      drawer.querySelectorAll('[data-cfg-refine-control="toggle"]').forEach(function (c) {
        c.addEventListener('change', sync);
      });
      drawer.querySelectorAll('[data-cfg-refine-control="stepper"]').forEach(function (s) {
        var out = s.querySelector('[data-cfg-refine-qty]');
        var max = parseInt(s.getAttribute('data-max'), 10) || 3;
        s.querySelector('[data-cfg-refine-inc]').addEventListener('click', function () {
          var q = parseInt(out.textContent, 10) || 0;
          if (q < max) { out.textContent = q + 1; sync(); }
        });
        s.querySelector('[data-cfg-refine-dec]').addEventListener('click', function () {
          var q = parseInt(out.textContent, 10) || 0;
          if (q > 0) { out.textContent = q - 1; sync(); }
        });
      });

      sync();
    })();

    // Parse the product's image list (each entry has url + alt token).
    var images = [];
    try { images = JSON.parse(gallery.getAttribute('data-cfg-images') || '[]'); } catch (e) { images = []; }

    var gridEl = root.querySelector('[data-cfg-grid]') || root.querySelector('.cfg__grid');
    var VIEWS = ['front', 'model', 'macro', 'macro2', 'side', 'side2', 'basket']; // on-page display order (side2/macro2 = optional 2nd angle when a setting provides one)
    // Shapes without their own photos borrow another shape's set. Without an
    // entry here a shape resolves to zero images and the gallery renders empty
    // placeholder cells, so every offered shape needs either photos or a stand-in.
    // Specialty cuts have no renders yet; replace these with real photo sets as
    // they are shot.
    var SHAPE_FALLBACK = {
      'long-cushion': 'cushion',
      moval: 'oval',
      'elongated-hexagon': 'round',
      'dutch-marquise': 'round',
      portuguese: 'round',
      'old-miner': 'round'
    };

    // Metal -> colour slug used in the image alt tokens.
    function metalSlug(metal) {
      metal = (metal || '').toLowerCase();
      if (metal.indexOf('rose') !== -1) return 'rose-gold';
      if (metal.indexOf('white') !== -1) return 'white-gold';
      if (metal.indexOf('platinum') !== -1) return 'white-gold'; // platinum -> white
      return 'yellow-gold';                                       // 14k/18k yellow + default
    }

    // Find the image whose alt IS exactly "<colour>-<shape>-<view>". Exact match
    // (alt is set to that token on upload) so "side" never grabs "side2", and
    // "cushion" never grabs "long-cushion".
    function imgFor(colour, shape, view) {
      if (!shape) return null;
      var token = colour + '-' + shape + '-' + view;
      for (var i = 0; i < images.length; i++) {
        if ((images[i].alt || '').toLowerCase() === token) return images[i].url;
      }
      return null;
    }
    function collect(colour, shape) {
      var a = [];
      for (var k = 0; k < VIEWS.length; k++) { var u = imgFor(colour, shape, VIEWS[k]); if (u) a.push(u); }
      return a;
    }
    // The image URLs for the current metal + shape, in view order. Falls back:
    // shape without photos -> its stand-in (long-cushion->cushion);
    // colour without photos -> yellow, then white. Empty if the setting has none.
    function resolvedUrls() {
      var shape = state.shape;
      function forColour(c) {
        var a = collect(c, shape);
        if (!a.length && SHAPE_FALLBACK[shape]) a = collect(c, SHAPE_FALLBACK[shape]);
        return a;
      }
      var a = forColour(metalSlug(state.metal));
      if (!a.length) a = forColour('yellow-gold');
      if (!a.length) a = forColour('white-gold');
      return a;
    }

    function applyImages() {
      if (!gridEl) return;
      var urls = resolvedUrls();
      var cells = gridEl.querySelectorAll('.cfg__cell');
      var count = urls.length ? Math.min(urls.length, cells.length) : 2; // 2 placeholder cells when no renders
      for (var i = 0; i < cells.length; i++) {
        var cell = cells[i];
        var img = cell.querySelector('.cfg__cell-img');
        var ph = cell.querySelector('.cfg__cell-ph');
        if (i < count) {
          cell.classList.remove('cfg__cell--hidden');
          if (urls[i]) {
            if (img) { img.src = urls[i]; img.hidden = false; }
            cell.classList.remove('cfg__cell--empty');
            if (ph) ph.style.display = 'none';
          } else {
            if (img) { img.hidden = true; img.removeAttribute('src'); }
            cell.classList.add('cfg__cell--empty');
            if (ph) ph.style.display = '';
          }
        } else {
          cell.classList.add('cfg__cell--hidden');
        }
      }
      if (typeof buildGalleryDots === 'function') buildGalleryDots();
    }

    // Metal selection -> updates price + state + swaps to the right-colour image
    root.querySelectorAll('.cfg-metal').forEach(function (b) {
      b.addEventListener('click', function () {
        state.variant = b.getAttribute('data-cfg-variant');
        state.metal = b.getAttribute('data-metal');
        if (priceEl) priceEl.textContent = b.getAttribute('data-price');
        var cfgStickyPrice = root.querySelector('[data-cfg-sticky-price]');
        if (cfgStickyPrice) cfgStickyPrice.textContent = b.getAttribute('data-price');
        if (metalLabel) metalLabel.textContent = b.getAttribute('data-metal');
        var cfgSku = root.querySelector('[data-cfg-sku]');
        if (cfgSku && b.getAttribute('data-sku')) cfgSku.textContent = b.getAttribute('data-sku');
        updateStickyConfig();
        root.querySelectorAll('.cfg-metal').forEach(function (x) {
          x.classList.remove('is-active');
          x.setAttribute('aria-checked', 'false');
        });
        b.classList.add('is-active');
        b.setAttribute('aria-checked', 'true');
        applyImages();
      });
    });

    // Shape selection -> records choice + swaps front (primary) + side (secondary).
    // Scoped to the radiogroups: the locked chip is a .cfg-shape too, and binding
    // it would run this with a null shape (blanking the gallery, or firing the
    // diamond-first redirect).
    root.querySelectorAll('.cfg__shapes .cfg-shape').forEach(function (b) {
      b.addEventListener('click', function () {
        var clickedShape = b.getAttribute('data-cfg-shape');
        // Diamond-first: a different shape means the customer wants a different
        // diamond. Keep the chosen setting and open the diamond grid in
        // setting-first mode (it shows as Step 2, not Step 1), pre-filtered to the
        // new shape. Picking a diamond there leads straight to Step 3 (review),
        // where both the loose-diamond image and the ring update to the new shape.
        if (cfgDiamondFirst && cfgDShape && clickedShape !== cfgDShape) {
          var selEl = root.querySelector('[data-cfg-select]');
          var sHandle = selEl ? (selEl.getAttribute('data-handle') || '') : '';
          var dColl = (selEl && selEl.getAttribute('data-collection-url')) || '/collections/loose-diamonds';
          window.location.href = dColl + '?setting=' + encodeURIComponent(sHandle) +
            '&variant=' + encodeURIComponent(state.variant) +
            '&metal=' + encodeURIComponent(state.metal) +
            '&shape=' + encodeURIComponent(clickedShape);
          return;
        }
        state.shape = clickedShape;
        if (shapeLabel) shapeLabel.textContent = b.getAttribute('data-shape-label');
        updateStickyConfig();
        root.querySelectorAll('.cfg-shape').forEach(function (x) {
          x.classList.remove('is-active');
          x.setAttribute('aria-checked', 'false');
        });
        b.classList.add('is-active');
        b.setAttribute('aria-checked', 'true');
        applyImages();
      });
    });

    // Apply the correct images for the initial shape + metal on load.
    applyImages();

    // Pre-select a shape from the URL (Engagement Rings mega "Shop by shape",
    // carried through the settings gallery), then collapse to the locked chip so
    // the customer sees the shape they picked rather than every shape again.
    //
    // Skipped entirely in diamond-first: the chosen diamond already fixed the
    // shape above. Clicking a pill here would run the shape handler's "customer
    // wants a different shape" branch and redirect back to the diamond grid
    // mid-load, which blanked the gallery whenever `shape` and `dshape` differed.
    var urlShape = (new URLSearchParams(window.location.search).get('shape') || '').toLowerCase();
    if (urlShape && !cfgDiamondFirst) {
      var preShape = root.querySelector('.cfg-shape[data-cfg-shape="' + urlShape + '"]');
      if (preShape) {
        if (!preShape.classList.contains('is-active')) preShape.click();
        showLockedShape(preShape, 'Matched to the shape you chose.');
      }
    }

    // Carry the choice forward. Setting-first -> Loose Diamonds (Step 2).
    // Diamond-first (arrived with ?flow=diamond&diamond=...) -> review (Step 3).
    var sel = root.querySelector('[data-cfg-select]');
    if (sel) {
      var sp = new URLSearchParams(window.location.search);
      var diamondFirst = sp.get('flow') === 'diamond' && sp.get('diamond');
      if (diamondFirst) {
        var dbar = root.querySelector('.cfg-steps[data-cfg-flow="diamond"]');
        if (dbar) { var ds1 = dbar.querySelector('[data-cfg-step="1"]'); if (ds1) ds1.href = '/collections/loose-diamonds?flow=diamond'; }
      }
      sel.addEventListener('click', function () {
        var handle = sel.getAttribute('data-handle');
        var url;
        if (diamondFirst) {
          url = '/pages/build-review?flow=diamond' +
            '&setting=' + encodeURIComponent(handle) +
            '&variant=' + encodeURIComponent(state.variant) +
            '&metal=' + encodeURIComponent(state.metal) +
            '&shape=' + encodeURIComponent(state.shape) +
            (state.refinements ? '&ref=' + encodeURIComponent(state.refinements) : '') +
            '&diamond=' + encodeURIComponent(sp.get('diamond')) +
            '&dimg=' + encodeURIComponent(sp.get('dimg') || '');
        } else {
          var base = sel.getAttribute('data-collection-url') || '/collections/loose-diamonds';
          url = base +
            '?setting=' + encodeURIComponent(handle) +
            '&variant=' + encodeURIComponent(state.variant) +
            '&metal=' + encodeURIComponent(state.metal) +
            '&shape=' + encodeURIComponent(state.shape) +
            (state.refinements ? '&ref=' + encodeURIComponent(state.refinements) : '');
        }
        window.location.href = url;
      });
    }

    // Accordions — smooth open/close (grid-rows), accessible toggle
    root.querySelectorAll('.cfg__acc-head').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.cfg__acc-item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Mobile gallery swipe dots — rebuilt whenever the visible images change.
    var galleryDotsWrap = root.querySelector('[data-cfg-dots]');
    function galleryVisibleCells() { return gridEl ? gridEl.querySelectorAll('.cfg__cell:not(.cfg__cell--hidden)') : []; }
    function updateGalleryDots() {
      if (!gridEl || !galleryDotsWrap) return;
      var cells = galleryVisibleCells();
      var dots = galleryDotsWrap.querySelectorAll('.cfg__dot');
      if (!dots.length) return;
      var center = gridEl.scrollLeft + gridEl.clientWidth / 2, active = 0, best = Infinity;
      for (var i = 0; i < cells.length; i++) {
        var c = cells[i], cc = c.offsetLeft + c.offsetWidth / 2, dist = Math.abs(cc - center);
        if (dist < best) { best = dist; active = i; }
      }
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === active);
    }
    function buildGalleryDots() {
      if (!gridEl || !galleryDotsWrap) return;
      galleryDotsWrap.innerHTML = '';
      var cells = galleryVisibleCells();
      if (cells.length < 2) return;
      for (var i = 0; i < cells.length; i++) {
        var dot = document.createElement('span');
        dot.className = 'cfg__dot';
        (function (idx) { dot.addEventListener('click', function () { cells[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); }); })(i);
        galleryDotsWrap.appendChild(dot);
      }
      updateGalleryDots();
    }
    if (gridEl) gridEl.addEventListener('scroll', function () { window.requestAnimationFrame(updateGalleryDots); }, { passive: true });
    buildGalleryDots();

    // ---- Lightbox: open full-size (same page), with zoom + thumbnail filmstrip ----
    var lb = root.querySelector('[data-cfg-lightbox]');
    var lbImg = root.querySelector('[data-cfg-lb-img]');
    var lbPrevBtn = root.querySelector('[data-cfg-lb-prev]');
    var lbNextBtn = root.querySelector('[data-cfg-lb-next]');
    var lbThumbs = root.querySelector('[data-cfg-lb-thumbs]');
    var lbList = [], lbIndex = 0, lbScale = 1;

    function lbSetZoom(scale, ox, oy) {
      lbScale = Math.max(1, Math.min(scale, 3));
      if (!lbImg) return;
      lbImg.style.transformOrigin = (ox != null) ? (ox + '% ' + oy + '%') : 'center';
      lbImg.style.transform = 'scale(' + lbScale + ')';
      lbImg.classList.toggle('is-zoomed', lbScale > 1);
    }
    function lbShow(i) {
      if (!lbList.length) return;
      lbIndex = (i % lbList.length + lbList.length) % lbList.length;
      if (lbImg) lbImg.src = lbList[lbIndex];
      lbSetZoom(1);
      var multi = lbList.length > 1;
      if (lbPrevBtn) lbPrevBtn.hidden = !multi;
      if (lbNextBtn) lbNextBtn.hidden = !multi;
      if (lbThumbs) {
        var t = lbThumbs.querySelectorAll('.cfg__lb-thumb');
        for (var j = 0; j < t.length; j++) t[j].classList.toggle('is-active', j === lbIndex);
      }
    }
    function lbBuildThumbs() {
      if (!lbThumbs) return;
      lbThumbs.innerHTML = '';
      if (lbList.length < 2) { lbThumbs.hidden = true; return; }
      lbThumbs.hidden = false;
      lbList.forEach(function (src, i) {
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'cfg__lb-thumb';
        var im = document.createElement('img'); im.src = src; im.alt = '';
        btn.appendChild(im);
        btn.addEventListener('click', function (e) { e.stopPropagation(); lbShow(i); });
        lbThumbs.appendChild(btn);
      });
    }
    function lbOpen(src) {
      lbList = [];
      var cells = galleryVisibleCells();
      for (var i = 0; i < cells.length; i++) {
        var im = cells[i].querySelector('.cfg__cell-img');
        if (im && !im.hidden && im.getAttribute('src')) lbList.push(im.getAttribute('src'));
      }
      lbBuildThumbs();
      var start = lbList.indexOf(src);
      lbShow(start < 0 ? 0 : start);
      if (lb) { lb.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    }
    function lbClose() { if (lb) { lb.hidden = true; document.documentElement.style.overflow = ''; lbSetZoom(1); } }

    if (gridEl) {
      gridEl.addEventListener('click', function (e) {
        var cell = e.target.closest('.cfg__cell');
        if (!cell || cell.classList.contains('cfg__cell--empty') || cell.classList.contains('cfg__cell--hidden')) return;
        var im = cell.querySelector('.cfg__cell-img');
        if (im && im.getAttribute('src')) lbOpen(im.getAttribute('src'));
      });
    }
    // Backdrop closes; the image itself toggles zoom (and pans while zoomed).
    if (lb) { lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); }); }
    if (lbImg) {
      lbImg.addEventListener('click', function (e) {
        e.stopPropagation();
        if (lbScale > 1) { lbSetZoom(1); return; }
        var r = lbImg.getBoundingClientRect();
        lbSetZoom(2, ((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
      });
      lbImg.addEventListener('mousemove', function (e) {
        if (lbScale <= 1) return;
        var r = lbImg.getBoundingClientRect();
        lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
      });
      lbImg.addEventListener('wheel', function (e) {
        e.preventDefault();
        var r = lbImg.getBoundingClientRect();
        lbSetZoom(lbScale + (e.deltaY < 0 ? 0.3 : -0.3), ((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
      }, { passive: false });
    }
    var lbCloseBtn = root.querySelector('[data-cfg-lb-close]');
    if (lbCloseBtn) lbCloseBtn.addEventListener('click', function (e) { e.stopPropagation(); lbClose(); });
    if (lbPrevBtn) lbPrevBtn.addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIndex - 1); });
    if (lbNextBtn) lbNextBtn.addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIndex + 1); });
    document.addEventListener('keydown', function (e) {
      if (!lb || lb.hidden) return;
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
      else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
    });

    // ---- Sticky select bar: shows when the main Select button scrolls out of view ----
    var stickyBar = root.querySelector('[data-cfg-stickybar]');
    var stickySelect = root.querySelector('[data-cfg-sticky-select]');
    if (stickySelect && sel) stickySelect.addEventListener('click', function () { sel.click(); });
    if (stickyBar && sel) {
      // Show the docked bar ONLY once the main "Select this setting" button has
      // scrolled above the top of the viewport (you're below it). Keep it hidden
      // whenever the button is on screen OR still below the viewport (you're above it).
      function updateSticky() {
        var r = sel.getBoundingClientRect();
        // Hidden while the button is on screen, and while it is still below the
        // fold (you have not reached it yet). Shown only once it has gone past
        // the top edge.
        stickyBar.hidden = r.bottom > 0;
      }

      // The page does not scroll on `window`: the body is overflow:hidden and
      // `.page-wrapper` is the real scroll container. Scroll events do not bubble
      // from a scroller to window, so a window listener fired once on load and
      // then never again — the bar froze in whatever state it started in.
      // IntersectionObserver does not care which ancestor scrolls.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          stickyBar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
        }, { threshold: 0 }).observe(sel);
      } else {
        var scroller = sel.closest('.page-wrapper') || document.querySelector('.page-wrapper') || window;
        scroller.addEventListener('scroll', updateSticky, { passive: true });
      }
      updateSticky();
      window.addEventListener('resize', updateSticky, { passive: true });
    }

    // Apply the correct image for the initial shape + metal on load.
    applyImages();
    updateStickyConfig();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cpg-explore]');
    if (!root) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cpg-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cpg-panel]'));
    var carousels = {}; // panelId -> state (or null when no carousel)

    function stepOf(track) {
      var c = track.children[0];
      if (!c) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      return c.getBoundingClientRect().width + gap;
    }

    function initCarousel(panel) {
      var car = panel.querySelector('[data-cpg-carousel]');
      var dotsWrap = panel.querySelector('[data-cpg-dots]');
      if (!car || !dotsWrap) return null;
      var track = car.querySelector('[data-cpg-track]');
      var originals = Array.prototype.slice.call(track.children);
      var count = originals.length;
      if (count === 0) return null;

      var st = { car: car, track: track, count: count, paused: false, visible: false };

      // Build one dash per card.
      st.dots = [];
      for (var i = 0; i < count; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'cpg__dot';
        d.setAttribute('aria-label', 'Go to item ' + (i + 1));
        (function (idx) { d.addEventListener('click', function () { track.scrollTo({ left: idx * stepOf(track), behavior: 'smooth' }); }); })(i);
        dotsWrap.appendChild(d);
        st.dots.push(d);
      }

      // Clone once for a seamless loop when there's overflow to scroll.
      st.canScroll = track.scrollWidth > track.clientWidth + 4;
      if (st.canScroll) {
        originals.forEach(function (el) {
          var cl = el.cloneNode(true);
          cl.setAttribute('aria-hidden', 'true');
          cl.setAttribute('tabindex', '-1');
          track.appendChild(cl);
        });
      }

      function setW() { return count * stepOf(track); }
      st.setDots = function () {
        var s = stepOf(track); if (!s) return;
        var w = setW(), pos = track.scrollLeft;
        if (w) pos = pos % w;
        var idx = Math.round(pos / s) % count;
        for (var j = 0; j < st.dots.length; j++) st.dots[j].classList.toggle('is-active', j === idx);
      };
      st.advance = function () {
        if (!st.canScroll) return;
        var w = setW();
        if (track.scrollLeft >= w - 1) track.scrollLeft = track.scrollLeft - w; // invisible reset (identical content)
        track.scrollBy({ left: stepOf(track), behavior: 'smooth' });
      };

      track.addEventListener('scroll', st.setDots, { passive: true });
      st.setDots();

      ['pointerenter', 'focusin', 'touchstart'].forEach(function (e) { car.addEventListener(e, function () { st.paused = true; }, { passive: true }); });
      ['pointerleave', 'focusout', 'touchend'].forEach(function (e) { car.addEventListener(e, function () { st.paused = false; }, { passive: true }); });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) { ents.forEach(function (en) { st.visible = en.isIntersecting; }); }, { threshold: 0.15 });
        io.observe(car);
      } else {
        st.visible = true;
      }
      return st;
    }

    function ensureInit(panel) {
      var id = panel.getAttribute('data-cpg-panel');
      if (!(id in carousels)) carousels[id] = initCarousel(panel);
    }

    function activate(id) {
      tabs.forEach(function (t) { var on = t.getAttribute('data-cpg-tab') === id; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      panels.forEach(function (pl) {
        var on = pl.getAttribute('data-cpg-panel') === id;
        pl.classList.toggle('is-active', on);
        pl.hidden = !on;
        if (on) ensureInit(pl); // measure/clone only once the panel is visible
      });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { activate(t.getAttribute('data-cpg-tab')); }); });

    // Init the default (first, visible) panel now so it can auto-slide immediately.
    if (panels[0]) ensureInit(panels[0]);

    // One ticker advances the active + visible + unpaused carousel (~2s).
    setInterval(function () {
      if (document.hidden) return;
      for (var id in carousels) {
        var st = carousels[id];
        if (!st) continue;
        var panel = st.car.closest('[data-cpg-panel]');
        if (panel && panel.hidden) continue;
        if (st.paused || !st.visible) continue;
        st.advance();
      }
    }, 2000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crafted-with-purpose"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cwp]');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;

    /* ---------- scroll reveal ---------- */
    var items = root.querySelectorAll('.cwp__reveal');
    if (reduce || !hasIO) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
      items.forEach(function (el) { io.observe(el); });
    }

    /* ---------- count up the example total ---------- */
    var totalEl = root.querySelector('[data-cwp-total]');
    if (totalEl && !reduce && hasIO) {
      var target = parseInt(totalEl.getAttribute('data-total'), 10) || 0;
      var finalText = totalEl.textContent;
      if (target > 0) {
        var fmt = function (cents) {
          return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };
        var done = false;
        var cio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && !done) {
              done = true; cio.disconnect();
              var dur = 1100, start = null;
              var step = function (ts) {
                if (!start) start = ts;
                var p = Math.min((ts - start) / dur, 1);
                var eased = 1 - Math.pow(1 - p, 3);
                totalEl.textContent = fmt(Math.round(target * eased));
                if (p < 1) { window.requestAnimationFrame(step); } else { totalEl.textContent = finalText; }
              };
              window.requestAnimationFrame(step);
            }
          });
        }, { threshold: 0.5 });
        cio.observe(totalEl);
      }
    }

    /* ---------- subtle parallax (real images only) ---------- */
    if (!reduce) {
      var pxImgs = root.querySelectorAll('.cwp__media--parallax .cwp__img');
      if (pxImgs.length) {
        var ticking = false;
        var update = function () {
          var vh = window.innerHeight;
          pxImgs.forEach(function (img) {
            var media = img.parentNode;
            var r = media.getBoundingClientRect();
            if (r.bottom < -50 || r.top > vh + 50) return;
            var offset = ((r.top + r.height / 2) - vh / 2) / vh;
            img.style.transform = 'translateY(' + (offset * -22).toFixed(1) + 'px) scale(1.12)';
          });
          ticking = false;
        };
        var onScroll = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        update();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diamond-education"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-de]');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* 4Cs tabs */
    var tabsWrap = root.querySelector('[data-de-tabs]');
    if (tabsWrap) {
      var tabs = tabsWrap.querySelectorAll('.de__cs-tab');
      var panels = tabsWrap.querySelectorAll('.de__cs-panel');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-de-tab');
          tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panels.forEach(function (p) { var on = p.getAttribute('data-de-panel') === key; p.classList.toggle('is-active', on); p.hidden = !on; });
        });
      });
    }

    /* Scroll reveal */
    var items = root.querySelectorAll('.de__reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
      items.forEach(function (el) { io.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diamond-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-diamond-grid]');

    // Where a shape-locked collection hands off to. It arrives on the element
    // rather than inline: this block is compiled into a shared static asset,
    // so a Liquid tag written in here is emitted verbatim and takes the whole
    // bundle down with a syntax error.
    var ALL_DIAMONDS_URL = (root && root.getAttribute('data-all-diamonds-url'))
      || '/collections/loose-diamonds';
    if (!root) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var collectionUrl = root.getAttribute('data-collection-url') || window.location.pathname;
    var CHUNK = parseInt(root.getAttribute('data-per-page'), 10) || 24;
    var LAB_LOGOS = {};
    try { LAB_LOGOS = JSON.parse(root.getAttribute('data-lab-logos') || '{}'); } catch (e) { LAB_LOGOS = {}; }

    var listEl = root.querySelector('[data-grid-list]');
    var emptyEl = root.querySelector('[data-grid-empty]');
    var sentinel = root.querySelector('[data-grid-sentinel]');
    var form = root.querySelector('[data-diamond-filters]');
    var panel = root.querySelector('[data-filter-panel]');
    var backdrop = root.querySelector('[data-filter-backdrop]');

    // Reveal placeholder when a card image is missing or fails to load.
    document.addEventListener('error', function (e) {
      var t = e.target;
      if (t && t.tagName === 'IMG' && t.classList && t.classList.contains('diamond-card__img')) {
        var m = t.closest('.diamond-card__media');
        if (m) m.classList.add('diamond-card__media--img-error');
      }
    }, true);

    // Gentle fade-in once each card image loads.
    document.addEventListener('load', function (e) {
      var t = e.target;
      if (t && t.tagName === 'IMG' && t.classList && t.classList.contains('dg-fade')) {
        t.classList.add('is-loaded');
      }
    }, true);

    var ALL = [];
    var filtered = [];
    var rendered = 0;
    var loaded = false;
    var bounds = { min: 0, max: 15 };
    var rbounds = { min: 1, max: 3 };
    var state = {
      compareOnly: false,
      search: '', shape: new Set(), color: new Set(), clarity: new Set(),
      cut: new Set(), lab: new Set(), caratMin: null, caratMax: null,
      ratioMin: null, ratioMax: null, priceMin: null, priceMax: null, sort: 'recommended'
    };

    // ----- Builder mode -----
    // Setting-first: this grid is Step 2 (URL carries ?setting=...).
    // Diamond-first: it's Step 1 (URL carries ?flow=diamond, no setting yet).
    var bp = new URLSearchParams(window.location.search);
    var flowDiamond = bp.get('flow') === 'diamond';
    var urlCaratMin = bp.get('caratmin');
    var urlCaratMax = bp.get('caratmax');
    var builder = bp.get('setting') ? {
      setting: bp.get('setting'),
      variant: bp.get('variant') || '',
      metal: bp.get('metal') || '',
      shape: (bp.get('shape') || '').toLowerCase(),
      // Chosen refinements ride along untouched to step 3 (handle:qty, no prices)
      ref: bp.get('ref') || ''
    } : null;

    var PLACEHOLDER =
      '<span class="diamond-card__placeholder" aria-hidden="true">' +
      '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
      '<path d="M20 10h24l10 14-22 30L10 24z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
      '<path d="M10 24h44M20 10l4 14M44 10l-4 14M24 24l8 30M40 24l-8 30" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
      '</svg></span>';

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function isViewer(u) {
      // Hosts that serve an embeddable 360 viewer. v360 is the current supplier;
      // the s360/diamonds360 entries cover stock loaded before the switch. A few
      // records carry a certificate PDF in the video field — never frame those.
      if (!u || /api\.igi\.org|\.pdf(\?|$)/i.test(u)) return false;
      return /s360\.services|s360online|view360|video\.diamonds360\.in|v360\.in|v360\.diamonds/i.test(u);
    }

    function buildCard(d) {
      var li = document.createElement('li');
      li.className = 'diamond-grid__item';
      // Colour and clarity read as one grade ("D VS1"), so they share a segment.
      // Cut arrives abbreviated (EX / ID / VG) — spell it out, as the Liquid card does.
      // Cut is graded on rounds only; fancy shapes carry no Cut Grade on the
      // report, so symmetry fills the slot. Not written into the cut field, so
      // the Cut filter still matches only real cut grades.
      var CUTS = { EX: 'Excellent', ID: 'Ideal', VG: 'Very good', GD: 'Good' };
      function labMark(lab) {
        var key = String(lab).trim().toUpperCase();
        var label = key + ' certified';
        var url = LAB_LOGOS[key];
        if (url) {
          return '<img class="lab-mark lab-mark--logo" src="' + esc(url) + '" alt="' + esc(label) +
            '" loading="lazy" decoding="async">';
        }
        return '<span class="lab-mark" title="' + esc(label) + '">' +
          '<span class="visually-hidden">' + esc(label) + '</span>' +
          '<span aria-hidden="true">' + esc(key) + '</span></span>';
      }

      var specs = [];
      if (d.carat != null && d.carat !== '') specs.push(esc(Number(d.carat).toFixed(2)) + 'ct');
      var grade = [d.color, d.clarity].filter(Boolean).join(' ');
      if (grade) specs.push(esc(grade));
      if (d.cut) specs.push(esc(CUTS[d.cut] || d.cut));
      else if (d.symmetry) specs.push(esc(CUTS[d.symmetry] || d.symmetry));
      // Carry builder context onto the diamond's detail page.
      var cardHref = d.url;
      if (builder) {
        // Setting-first: keep the chosen setting so the detail opens as Step 2.
        var sep = cardHref.indexOf('?') === -1 ? '?' : '&';
        cardHref += sep + 'setting=' + encodeURIComponent(builder.setting) +
          '&variant=' + encodeURIComponent(builder.variant) +
          '&metal=' + encodeURIComponent(builder.metal) +
          '&shape=' + encodeURIComponent(builder.shape) +
          (builder.ref ? '&ref=' + encodeURIComponent(builder.ref) : '');
      } else if (flowDiamond) {
        // Diamond-first: this is Step 1; carry the flow so the detail shows
        // "Choose this diamond" (-> the settings gallery).
        cardHref += (cardHref.indexOf('?') === -1 ? '?' : '&') + 'flow=diamond';
      }
      li.innerHTML =
        '<a class="diamond-card" href="' + esc(cardHref) + '">' +
          '<span class="diamond-card__media">' +
            PLACEHOLDER +
            (d.image ? '<img class="diamond-card__img dg-fade" src="' + esc(d.image) + '" alt="' + esc(d.title) +
              '" loading="lazy" decoding="async" width="600" height="600">' : '') +
            '<span class="diamond-card__compare' + (compare.has(d.handle) ? ' is-active' : '') +
              '" role="button" tabindex="0" aria-pressed="' + (compare.has(d.handle) ? 'true' : 'false') +
              '" data-compare="' + esc(d.handle) + '" aria-label="Add ' + esc(d.title) + ' to compare">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.5 4.2 12.9a4.6 4.6 0 0 1 6.5-6.5l1.3 1.3 1.3-1.3a4.6 4.6 0 1 1 6.5 6.5Z"/></svg>' +
            '</span>' +
            (isViewer(d.video) ? '<span class="diamond-card__view360" role="button" tabindex="0" data-video="' + esc(d.video) + '" aria-label="View 360 degree spin of this diamond"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-2.64-6.36"/><path d="M21 3v4h-4"/></svg><span>360°</span></span>' : '') +
          '</span>' +
          '<span class="diamond-card__body">' +
            '<span class="diamond-card__head">' +
              (d.shape ? '<span class="diamond-card__shape">' + esc(d.shape) + '</span>' : '') +
              (d.lab ? labMark(d.lab) : '') +
            '</span>' +
            '<span class="diamond-card__specs">' + specs.join(' · ') + '</span>' +
            '<span class="diamond-card__pricerow">' +
              '<span class="diamond-card__price">' + esc(d.price_money) + '</span>' +
            '</span>' +
          '</span>' +
        '</a>';
      return li;
    }

    /* ---------- data ---------- */
    function feedUrl(page) { return collectionUrl + '?view=diamonds-data&page=' + page; }


    // Pre-apply a carat range from the URL (Diamonds mega "Shop by carat").
    // Runs after initBounds so the bounds/sliders exist; diamond-first only.
    // Opening carat window for the browser. The catalogue runs from a fifth of a
    // carat to 8.57, and the stones people come here for sit in this band, so
    // the grid opens on those rather than on 0.27ct melee. It shows up as a
    // removable chip above the grid, so nothing is hidden from the customer.
    var DEFAULT_CARAT_MIN = 1.5;
    var DEFAULT_CARAT_MAX = 4;

    function applyDefaultCarat() {
      // A carat in the URL or a builder hand-off has already spoken; only fill
      // in the window when nothing else has.
      if (state.caratMin !== bounds.min || state.caratMax !== bounds.max) return;
      // ...and only on a collection that actually runs from melee to large
      // stones, which is the full browser. A carat collection has already done
      // this filtering itself, and clamping it again hid the very stones the
      // page is named after: /collections/1-carat-lab-grown-diamonds spans
      // 1.00-1.99ct, so the 1.50 floor buried all 1,426 one-carat stones, and
      // the under-1ct collection has a ceiling below 1.5, which collapsed the
      // window to a single point and showed "1ct to 1ct".
      if (!(bounds.min < DEFAULT_CARAT_MIN && bounds.max > DEFAULT_CARAT_MAX)) return;
      state.caratMin = Math.max(bounds.min, Math.min(DEFAULT_CARAT_MIN, bounds.max));
      state.caratMax = Math.min(bounds.max, Math.max(DEFAULT_CARAT_MAX, state.caratMin));
      reflectCarat();
    }

    function applyUrlCarat() {
      if (!flowDiamond) return;
      var hasMin = urlCaratMin != null && urlCaratMin !== '';
      var hasMax = urlCaratMax != null && urlCaratMax !== '';
      if (!hasMin && !hasMax) return;
      var mn = hasMin ? parseFloat(urlCaratMin) : bounds.min;
      var mx = hasMax ? parseFloat(urlCaratMax) : bounds.max;
      if (isNaN(mn)) mn = bounds.min;
      if (isNaN(mx)) mx = bounds.max;
      mn = Math.max(bounds.min, Math.min(mn, bounds.max));
      mx = Math.min(bounds.max, Math.max(mx, bounds.min));
      if (mn > mx) { var t = mn; mn = mx; mx = t; }
      state.caratMin = mn;
      state.caratMax = mx;
      reflectCarat();
    }

    function loadAll() {
      fetch(feedUrl(1), { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.json(); })
        .then(function (first) {
          ALL = (first.products || []).slice();
          var pages = first.pages || 1;
          var rest = [];
          for (var p = 2; p <= pages; p++) {
            rest.push(fetch(feedUrl(p), { headers: { 'X-Requested-With': 'fetch' } }).then(function (r) { return r.json(); }));
          }
          return Promise.all(rest);
        })
        .then(function (parts) {
          parts.forEach(function (pg) { if (pg && pg.products) ALL = ALL.concat(pg.products); });
          loaded = true;
          initBounds();
          initShapeLock();
          applyUrlCarat();
          applyDefaultCarat();
          apply(true);
        })
        .catch(function () { root.classList.remove('is-prefiltering'); /* reveal server-rendered grid as fallback */ });
    }

    // Which shapes this collection actually contains. The shape collections
    // reached from the Diamonds mega menu hold exactly one, and the shape
    // filter inside them can then only ever subtract: ticking Oval inside
    // /collections/round-lab-grown-diamonds asks for oval stones in a
    // round-only collection and correctly returns "No diamonds match these
    // filters". Knowing the collection is locked lets the click hand off to
    // the full browser instead of returning nothing.
    var lockedShape = null;

    function initShapeLock() {
      var seen = {};
      ALL.forEach(function (d) { if (d.shape) seen[String(d.shape).toLowerCase()] = 1; });
      var keys = Object.keys(seen);
      lockedShape = keys.length === 1 ? keys[0] : null;
    }

    function initBounds() {
      var lo = Infinity, hi = -Infinity;
      ALL.forEach(function (d) {
        var c = parseFloat(d.carat);
        if (!isNaN(c)) { if (c < lo) lo = c; if (c > hi) hi = c; }
      });
      if (lo === Infinity) { lo = 0; hi = 15; }
      bounds.min = Math.floor(lo * 10) / 10;
      bounds.max = Math.ceil(hi * 10) / 10;
      state.caratMin = bounds.min;
      state.caratMax = bounds.max;
      var sMin = root.querySelector('[data-carat-slider-min]');
      var sMax = root.querySelector('[data-carat-slider-max]');
      [sMin, sMax].forEach(function (s) { if (s) { s.min = bounds.min; s.max = bounds.max; s.step = 0.01; } });
      reflectCarat();

      var rlo = Infinity, rhi = -Infinity;
      ALL.forEach(function (d) {
        var r = parseFloat(d.ratio);
        if (!isNaN(r)) { if (r < rlo) rlo = r; if (r > rhi) rhi = r; }
      });
      if (rlo === Infinity) { rlo = 1; rhi = 3; }
      rbounds.min = Math.floor(rlo * 100) / 100;
      rbounds.max = Math.ceil(rhi * 100) / 100;
      state.ratioMin = rbounds.min;
      state.ratioMax = rbounds.max;
      var rsMin = root.querySelector('[data-ratio-slider-min]');
      var rsMax = root.querySelector('[data-ratio-slider-max]');
      [rsMin, rsMax].forEach(function (s) { if (s) { s.min = rbounds.min; s.max = rbounds.max; s.step = 0.01; } });
      reflectRatio();
    }

    function reflectRatio() {
      var sMin = root.querySelector('[data-ratio-slider-min]');
      var sMax = root.querySelector('[data-ratio-slider-max]');
      var nMin = root.querySelector('[data-ratio-min]');
      var nMax = root.querySelector('[data-ratio-max]');
      if (sMin) sMin.value = state.ratioMin;
      if (sMax) sMax.value = state.ratioMax;
      if (nMin) nMin.value = state.ratioMin;
      if (nMax) nMax.value = state.ratioMax;
      updateRatioFill();
    }

    function updateRatioFill() {
      var fill = root.querySelector('[data-ratio-fill]');
      if (!fill) return;
      var range = (rbounds.max - rbounds.min) || 1;
      fill.style.left = ((state.ratioMin - rbounds.min) / range * 100) + '%';
      fill.style.right = ((rbounds.max - state.ratioMax) / range * 100) + '%';
    }

    function reflectCarat() {
      var sMin = root.querySelector('[data-carat-slider-min]');
      var sMax = root.querySelector('[data-carat-slider-max]');
      var nMin = root.querySelector('[data-carat-min]');
      var nMax = root.querySelector('[data-carat-max]');
      if (sMin) sMin.value = state.caratMin;
      if (sMax) sMax.value = state.caratMax;
      if (nMin) nMin.value = state.caratMin;
      if (nMax) nMax.value = state.caratMax;
      updateCaratFill();
    }

    /* ---------- filtering ---------- */
    function matches(d) {
      if (state.compareOnly && !compare.has(d.handle)) return false;
      if (state.search) {
        var q = state.search.toLowerCase();
        var cert = (d.cert == null ? '' : String(d.cert)).toLowerCase();
        var sku = (d.sku || '').toLowerCase();
        if (cert.indexOf(q) === -1 && sku.indexOf(q) === -1) return false;
      }
      if (state.shape.size && !(d.shape && state.shape.has(d.shape.toLowerCase()))) return false;
      if (state.color.size && !(d.color && state.color.has(d.color))) return false;
      if (state.clarity.size && !(d.clarity && state.clarity.has(d.clarity))) return false;
      if (state.cut.size && !(d.cut && state.cut.has(d.cut))) return false;
      if (state.lab.size && !(d.lab && state.lab.has(d.lab))) return false;
      var c = parseFloat(d.carat);
      if (!isNaN(c)) {
        if (state.caratMin != null && c < state.caratMin - 1e-9) return false;
        if (state.caratMax != null && c > state.caratMax + 1e-9) return false;
      }
      var rt = parseFloat(d.ratio);
      if (!isNaN(rt)) {
        if (state.ratioMin != null && rt < state.ratioMin - 1e-9) return false;
        if (state.ratioMax != null && rt > state.ratioMax + 1e-9) return false;
      }
      if (state.priceMin != null && d.price < state.priceMin * 100) return false;
      if (state.priceMax != null && d.price > state.priceMax * 100) return false;
      return true;
    }

    var viewCount = root.querySelector('[data-view-count]');

    /* ---------- compare ---------- */
    var COMPARE_KEY = 'mv-diamond-compare';
    var compare = new Set();
    try {
      var stored = window.localStorage.getItem(COMPARE_KEY);
      if (stored) JSON.parse(stored).forEach(function (h) { compare.add(h); });
    } catch (e) { /* private mode, blocked storage — compare just won't persist */ }

    function saveCompare() {
      try { window.localStorage.setItem(COMPARE_KEY, JSON.stringify(Array.from(compare))); }
      catch (e) { /* not worth breaking the grid over */ }
    }

    var compareCountEl = root.querySelector('[data-compare-count]');
    var tabsEl = root.querySelector('[data-grid-tabs]');

    // A handle can be on screen twice (server card + rebuilt card), so paint by
    // selector rather than trusting the element that was clicked.
    function paintCompare(handle) {
      var on = compare.has(handle);
      root.querySelectorAll('[data-compare="' + handle + '"]').forEach(function (el) {
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function syncCompareMarks() {
      if (!listEl) return;
      listEl.querySelectorAll('[data-compare]').forEach(function (el) {
        var on = compare.has(el.getAttribute('data-compare'));
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function updateCompareCount() {
      if (compareCountEl) compareCountEl.textContent = compare.size;
    }

    function toggleCompare(handle) {
      if (compare.has(handle)) compare.delete(handle); else compare.add(handle);
      saveCompare();
      paintCompare(handle);
      updateCompareCount();
      // Un-hearting the last stone while the Compare tab is open would leave an
      // unexplained empty grid, so re-filter immediately.
      if (state.compareOnly) apply(false);
    }

    if (tabsEl) {
      tabsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-tab]');
        if (!btn) return;
        state.compareOnly = btn.getAttribute('data-tab') === 'compare';
        tabsEl.querySelectorAll('[data-tab]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply(false);
      });
    }

    /* ---------- active-filter chips ---------- */
    var chipsEl = root.querySelector('[data-active-filters]');
    var CUT_LABELS = { ID: 'Ideal', EX: 'Excellent', VG: 'Very good', GD: 'Good', FR: 'Fair' };

    function prettyShape(v) {
      return v.replace(/-/g, ' ').replace(/^./, function (ch) { return ch.toUpperCase(); });
    }

    function nearly(a, b) { return Math.abs(a - b) < 1e-9; }

    // One entry per thing the customer actually narrowed. Ranges only count when
    // they have been moved off the bounds, otherwise every visit would show a
    // "Carat" chip nobody set.
    function activeFilters() {
      var out = [];
      if (state.search) out.push({ kind: 'search', label: '"' + state.search + '"' });
      state.shape.forEach(function (v) { out.push({ kind: 'shape', value: v, label: prettyShape(v) }); });
      state.color.forEach(function (v) { out.push({ kind: 'color', value: v, label: 'Colour ' + v }); });
      state.clarity.forEach(function (v) { out.push({ kind: 'clarity', value: v, label: v }); });
      state.cut.forEach(function (v) { out.push({ kind: 'cut', value: v, label: CUT_LABELS[v] || v }); });
      state.lab.forEach(function (v) { out.push({ kind: 'lab', value: v, label: v }); });
      if (!nearly(state.caratMin, bounds.min) || !nearly(state.caratMax, bounds.max)) {
        out.push({ kind: 'carat', label: state.caratMin.toFixed(2) + '–' + state.caratMax.toFixed(2) + 'ct' });
      }
      if (!nearly(state.ratioMin, rbounds.min) || !nearly(state.ratioMax, rbounds.max)) {
        out.push({ kind: 'ratio', label: 'Ratio ' + state.ratioMin.toFixed(2) + '–' + state.ratioMax.toFixed(2) });
      }
      if (state.priceMin != null || state.priceMax != null) {
        out.push({
          kind: 'price',
          label: 'Price ' + (state.priceMin != null ? '$' + state.priceMin : 'any') +
            '–' + (state.priceMax != null ? '$' + state.priceMax : 'any')
        });
      }
      return out;
    }

    var X_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';

    function renderActiveChips() {
      if (!chipsEl) return;
      var items = activeFilters();
      if (!items.length) { chipsEl.hidden = true; chipsEl.innerHTML = ''; return; }
      chipsEl.hidden = false;
      chipsEl.innerHTML = items.map(function (it) {
        return '<button type="button" class="diamond-grid__chip" data-chip-kind="' + it.kind + '"' +
          (it.value ? ' data-chip-value="' + esc(it.value) + '"' : '') +
          ' aria-label="Remove filter ' + esc(it.label) + '">' + esc(it.label) + X_SVG + '</button>';
      }).join('') +
        '<button type="button" class="diamond-grid__chip diamond-grid__chip--clear" data-filter-clear>Clear all</button>';
    }

    if (chipsEl) {
      chipsEl.addEventListener('click', function (e) {
        if (e.target.closest('[data-filter-clear]')) {
          var toolbarClear = root.querySelector('.diamond-grid__clear[data-filter-clear]');
          if (toolbarClear) toolbarClear.click();
          return;
        }
        var chip = e.target.closest('[data-chip-kind]');
        if (!chip) return;
        var kind = chip.getAttribute('data-chip-kind');
        var value = chip.getAttribute('data-chip-value');
        if (kind === 'search') {
          state.search = '';
          var sb = form && form.querySelector('[data-filter-search]');
          if (sb) sb.value = '';
        } else if (kind === 'carat') {
          state.caratMin = bounds.min; state.caratMax = bounds.max; reflectCarat();
        } else if (kind === 'ratio') {
          state.ratioMin = rbounds.min; state.ratioMax = rbounds.max; reflectRatio();
        } else if (kind === 'price') {
          state.priceMin = null; state.priceMax = null;
          var pmn = form && form.querySelector('[data-price-min]');
          var pmx = form && form.querySelector('[data-price-max]');
          if (pmn) pmn.value = '';
          if (pmx) pmx.value = '';
        } else if (state[kind] && state[kind].delete) {
          state[kind].delete(value);
          paintFilterButtons(kind, value, false);
        }
        apply(false);
      });
    }

    function apply(initial) {
      if (!loaded) return;
      filtered = ALL.filter(matches);
      sortFiltered();
      renderGrid(initial);
      if (viewCount) { viewCount.textContent = filtered.length; viewCount.hidden = false; }
      updateCompareCount();
      renderActiveChips();
      if (emptyEl) {
        emptyEl.textContent = state.compareOnly
          ? 'Nothing to compare yet. Tap the heart on a diamond to add it here.'
          : 'No diamonds match these filters.';
      }
    }

    function sortFiltered() {
      var s = state.sort;
      if (s === 'price-asc') filtered.sort(function (a, b) { return a.price - b.price; });
      else if (s === 'price-desc') filtered.sort(function (a, b) { return b.price - a.price; });
      else if (s === 'carat-asc') filtered.sort(function (a, b) { return (+a.carat) - (+b.carat); });
      else if (s === 'carat-desc') filtered.sort(function (a, b) { return (+b.carat) - (+a.carat); });
    }

    function appendChunk(animate) {
      var frag = document.createDocumentFragment();
      var end = Math.min(rendered + CHUNK, filtered.length);
      for (var i = rendered; i < end; i++) {
        var li = buildCard(filtered[i]);
        if (animate && !reduce) {
          li.classList.add('is-enter');
          li.style.animationDelay = (Math.min(i - rendered, 12) * 30) + 'ms';
        }
        frag.appendChild(li);
      }
      listEl.appendChild(frag);
      rendered = end;
      // Mark already-cached images as loaded so they fade in immediately.
      listEl.querySelectorAll('img.dg-fade:not(.is-loaded)').forEach(function (im) {
        if (im.complete && im.naturalWidth > 0) im.classList.add('is-loaded');
      });
    }

    function rebuild() {
      listEl.innerHTML = '';
      rendered = 0;
      appendChunk(true);
      if (emptyEl) emptyEl.hidden = filtered.length !== 0;
      fillViewport();
    }

    function fillViewport() {
      if (!sentinel) return;
      var guard = 0;
      while (rendered < filtered.length && guard < 60) {
        if (sentinel.getBoundingClientRect().top < window.innerHeight + 600) { appendChunk(true); guard++; }
        else break;
      }
    }

    // Default (untouched) view = no search/filters/sort applied.
    function isDefaultView() {
      return state.search === '' &&
        state.shape.size === 0 && state.color.size === 0 && state.clarity.size === 0 &&
        state.cut.size === 0 && state.lab.size === 0 &&
        state.caratMin === bounds.min && state.caratMax === bounds.max &&
        state.ratioMin === rbounds.min && state.ratioMax === rbounds.max &&
        state.priceMin == null && state.priceMax == null &&
        state.sort === 'recommended' &&
        listEl.querySelectorAll('.diamond-grid__item').length > 0;
    }

    // In builder mode the server-rendered cards link to plain product URLs;
    // patch them in place to carry the builder context (avoids a full rebuild).
    function decorateServerHrefs() {
      if (!builder && !flowDiamond) return;
      listEl.querySelectorAll('a.diamond-card').forEach(function (a) {
        var href = a.getAttribute('href'); if (!href) return;
        var base = href.split('?')[0];
        if (builder) {
          a.setAttribute('href', base + '?setting=' + encodeURIComponent(builder.setting) +
            '&variant=' + encodeURIComponent(builder.variant) + '&metal=' + encodeURIComponent(builder.metal) +
            '&shape=' + encodeURIComponent(builder.shape) +
            (builder.ref ? '&ref=' + encodeURIComponent(builder.ref) : ''));
        } else if (flowDiamond) {
          a.setAttribute('href', base + '?flow=diamond');
        }
      });
    }

    function renderGrid(initial) {
      // First load with nothing filtered: KEEP the server-rendered cards so the
      // grid doesn't wipe-and-rebuild (the flicker). Just continue from them.
      if (initial && isDefaultView()) {
        rendered = listEl.querySelectorAll('.diamond-grid__item').length;
        if (emptyEl) emptyEl.hidden = filtered.length !== 0;
        decorateServerHrefs();
        syncCompareMarks();
        fillViewport();
        return;
      }
      if (initial || reduce) { rebuild(); root.classList.remove('is-prefiltering'); return; }
      listEl.classList.add('is-updating');
      window.setTimeout(function () {
        listEl.classList.remove('is-updating');
        rebuild();
      }, 180);
    }

    function updateCaratFill() {
      var fill = root.querySelector('[data-carat-fill]');
      if (!fill) return;
      var range = (bounds.max - bounds.min) || 1;
      fill.style.left = ((state.caratMin - bounds.min) / range * 100) + '%';
      fill.style.right = ((bounds.max - state.caratMax) / range * 100) + '%';
    }

    /* ---------- events ---------- */
    var t;
    function debounced() { window.clearTimeout(t); t = window.setTimeout(function () { apply(false); }, 120); }

    // One filter value, possibly several buttons (drawer + mobile shape rail).
    function paintFilterButtons(group, value, on) {
      root.querySelectorAll('[data-filter-group="' + group + '"][data-value="' + value + '"]').forEach(function (b) {
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); });

      // Bound to the section root, not the form: the mobile shape rail sits
      // outside the form and carries the same data-filter-group buttons. A shape
      // now has two controls, so paint every button that shares the value —
      // otherwise the rail and the drawer disagree about what is selected.
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-filter-group]');
        if (!btn) return;
        var group = btn.getAttribute('data-filter-group');
        var value = btn.getAttribute('data-value');
        var set = state[group];
        var on = !set.has(value);
        // Adding a shape to a single-shape collection can only ever empty the
        // grid, so send them to the full browser carrying both shapes rather
        // than showing them nothing.
        if (group === 'shape' && on && lockedShape && value !== lockedShape) {
          window.location.href = ALL_DIAMONDS_URL
            + '?flow=diamond&shape=' + encodeURIComponent(lockedShape)
            + '&shape=' + encodeURIComponent(value);
          return;
        }
        if (on) set.add(value); else set.delete(value);
        paintFilterButtons(group, value, on);
        debounced();
      });

      var search = form.querySelector('[data-filter-search]');
      if (search) search.addEventListener('input', function () { state.search = search.value.trim(); debounced(); });

      var sMin = form.querySelector('[data-carat-slider-min]');
      var sMax = form.querySelector('[data-carat-slider-max]');
      var nMin = form.querySelector('[data-carat-min]');
      var nMax = form.querySelector('[data-carat-max]');

      if (sMin) sMin.addEventListener('input', function () {
        state.caratMin = Math.min(parseFloat(sMin.value), state.caratMax);
        reflectCarat(); debounced();
      });
      if (sMax) sMax.addEventListener('input', function () {
        state.caratMax = Math.max(parseFloat(sMax.value), state.caratMin);
        reflectCarat(); debounced();
      });
      if (nMin) nMin.addEventListener('change', function () {
        var v = parseFloat(nMin.value);
        if (isNaN(v)) v = bounds.min;
        state.caratMin = Math.max(bounds.min, Math.min(v, state.caratMax));
        reflectCarat(); debounced();
      });
      if (nMax) nMax.addEventListener('change', function () {
        var v = parseFloat(nMax.value);
        if (isNaN(v)) v = bounds.max;
        state.caratMax = Math.min(bounds.max, Math.max(v, state.caratMin));
        reflectCarat(); debounced();
      });

      var rsMin = form.querySelector('[data-ratio-slider-min]');
      var rsMax = form.querySelector('[data-ratio-slider-max]');
      var rnMin = form.querySelector('[data-ratio-min]');
      var rnMax = form.querySelector('[data-ratio-max]');
      if (rsMin) rsMin.addEventListener('input', function () {
        state.ratioMin = Math.min(parseFloat(rsMin.value), state.ratioMax);
        reflectRatio(); debounced();
      });
      if (rsMax) rsMax.addEventListener('input', function () {
        state.ratioMax = Math.max(parseFloat(rsMax.value), state.ratioMin);
        reflectRatio(); debounced();
      });
      if (rnMin) rnMin.addEventListener('change', function () {
        var v = parseFloat(rnMin.value);
        if (isNaN(v)) v = rbounds.min;
        state.ratioMin = Math.max(rbounds.min, Math.min(v, state.ratioMax));
        reflectRatio(); debounced();
      });
      if (rnMax) rnMax.addEventListener('change', function () {
        var v = parseFloat(rnMax.value);
        if (isNaN(v)) v = rbounds.max;
        state.ratioMax = Math.min(rbounds.max, Math.max(v, state.ratioMin));
        reflectRatio(); debounced();
      });

      var pMin = form.querySelector('[data-price-min]');
      var pMax = form.querySelector('[data-price-max]');
      if (pMin) pMin.addEventListener('input', function () { var v = parseFloat(pMin.value); state.priceMin = isNaN(v) ? null : v; debounced(); });
      if (pMax) pMax.addEventListener('input', function () { var v = parseFloat(pMax.value); state.priceMax = isNaN(v) ? null : v; debounced(); });

      root.querySelectorAll('[data-filter-clear]').forEach(function (clearBtn) {
        clearBtn.addEventListener('click', function () {
          state.search = ''; state.shape.clear(); state.color.clear(); state.clarity.clear();
          state.cut.clear(); state.lab.clear();
          state.caratMin = bounds.min; state.caratMax = bounds.max;
          state.ratioMin = rbounds.min; state.ratioMax = rbounds.max;
          state.priceMin = null; state.priceMax = null;
          root.querySelectorAll('.is-active').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
          if (search) search.value = '';
          reflectCarat();
          reflectRatio();
          if (pMin) pMin.value = '';
          if (pMax) pMax.value = '';
          state.sort = 'recommended';
          var ss = root.querySelector('[data-sort]'); if (ss) ss.value = 'recommended';
          apply(false);
        });
      });
    }

    /* ---------- sort ---------- */
    var sortSel = root.querySelector('[data-sort]');
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(false); });

    /* ---------- 360 lightbox ---------- */
    var vmodal = root.querySelector('[data-video-modal]');
    var vframe = root.querySelector('[data-video-frame]');
    var vlink = root.querySelector('[data-video-link]');
    function openVideo(url) {
      if (!vmodal || !vframe || !url) return;
      vframe.innerHTML = '';
      var ifr = document.createElement('iframe');
      ifr.src = url;
      ifr.title = '360 degree diamond view';
      ifr.loading = 'lazy';
      ifr.setAttribute('allowfullscreen', '');
      ifr.setAttribute('referrerpolicy', 'no-referrer');
      vframe.appendChild(ifr);
      if (vlink) vlink.href = url;
      vmodal.hidden = false;
      requestAnimationFrame(function () { vmodal.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var c = vmodal.querySelector('.diamond-360__close');
      if (c) c.focus();
    }
    function closeVideo() {
      if (!vmodal || vmodal.hidden) return;
      vmodal.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(function () { vmodal.hidden = true; vframe.innerHTML = ''; }, 230);
    }
    root.querySelectorAll('[data-video-close]').forEach(function (el) { el.addEventListener('click', closeVideo); });
    if (listEl) {
      listEl.addEventListener('click', function (e) {
        var c = e.target.closest('[data-compare]');
        if (c) { e.preventDefault(); toggleCompare(c.getAttribute('data-compare')); return; }
        var v = e.target.closest('[data-video]');
        if (v) { e.preventDefault(); openVideo(v.getAttribute('data-video')); }
      });
      listEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          var c = e.target.closest('[data-compare]');
          if (c) { e.preventDefault(); toggleCompare(c.getAttribute('data-compare')); return; }
          var v = e.target.closest('[data-video]');
          if (v) { e.preventDefault(); openVideo(v.getAttribute('data-video')); }
        }
      });
    }

    /* ---------- mobile drawer ---------- */
    var openBtn = root.querySelector('[data-filter-open]');
    var closeBtns = root.querySelectorAll('[data-filter-close]');
    function openDrawer() {
      if (!panel) return;
      panel.classList.add('is-open');
      if (backdrop) { backdrop.hidden = false; requestAnimationFrame(function () { backdrop.classList.add('is-shown'); }); }
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!panel) return;
      panel.classList.remove('is-open');
      if (backdrop) { backdrop.classList.remove('is-shown'); window.setTimeout(function () { backdrop.hidden = true; }, 250); }
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    closeBtns.forEach(function (b) { b.addEventListener('click', closeDrawer); });
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeVideo(); } });

    /* ---------- builder mode ---------- */
    function setupBuilder() {
      // Diamond-first (Step 1): reveal the step bar; no setting context yet.
      if (!builder && flowDiamond) {
        // Step 1 of the diamond-first flow: no setting chosen yet, so the page
        // still needs its own title. is-builder alone hides the header, which is
        // right for step 2 where the setting context bar takes its place.
        root.classList.add('is-builder');
        root.classList.add('is-builder-first');
        var sw = root.querySelector('[data-builder-steps]');
        if (sw) sw.hidden = false;
        // Pre-apply the shape filter when arriving from "Shop by shape".
        // getAll, not get: a hand-off from a shape-locked collection arrives
        // with two, and get() would silently drop the second.
        var shps = bp.getAll ? bp.getAll('shape') : [bp.get('shape')];
        shps.forEach(function (raw) {
          var shp = (raw || '').toLowerCase();
          if (!shp) return;
          state.shape.add(shp);
          paintFilterButtons('shape', shp, true);
        });
        return;
      }
      if (!builder) return;
      root.classList.add('is-builder');

      var stepsWrap = root.querySelector('[data-builder-steps]');
      if (stepsWrap) stepsWrap.hidden = false;
      var ctxEl = root.querySelector('[data-builder-context]');
      if (ctxEl) ctxEl.hidden = false;

      var settingUrl = '/products/' + encodeURIComponent(builder.setting);
      // "Change setting" goes to the full settings listing so the customer can
      // pick a different ring — not back to the one they already chose.
      var changeEl = root.querySelector('[data-ctx-change]');
      if (changeEl) changeEl.href = '/collections/engagement-rings';
      var step1 = root.querySelector('[data-cfg-step="1"]');
      if (step1) step1.href = settingUrl;

      var metalEl = root.querySelector('[data-ctx-metal]');
      var sepEl = root.querySelector('[data-ctx-sep]');
      if (metalEl && builder.metal) { metalEl.textContent = builder.metal; if (sepEl) sepEl.hidden = false; }

      // Pre-apply the shape filter from Step 1 (they can still change/clear it).
      if (builder.shape && form) {
        var shapeChip = form.querySelector('[data-filter-group="shape"][data-value="' + builder.shape + '"]');
        if (shapeChip) {
          state.shape.add(builder.shape);
          shapeChip.classList.add('is-active');
          shapeChip.setAttribute('aria-pressed', 'true');
        }
      }

      // Fill the context bar from the chosen setting variant.
      fetch(settingUrl + '.js', { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var name = (p.title || '').replace(/\s*engagement ring\s*$/i, '');
          var variant = null;
          for (var i = 0; i < (p.variants || []).length; i++) {
            if (String(p.variants[i].id) === String(builder.variant)) { variant = p.variants[i]; break; }
          }
          if (!variant && p.variants) variant = p.variants[0];
          var nameEl = root.querySelector('[data-ctx-name]');
          if (nameEl) nameEl.textContent = name;
          if (metalEl && !builder.metal && variant) { metalEl.textContent = variant.title; if (sepEl) sepEl.hidden = false; }
          // Pick the photo matching the chosen metal + shape, using the same alt
          // token as the configurator ("<metal-slug>-<shape>-front"). The metal
          // variants carry no per-variant image, so matching on product media by
          // alt is the only way to reflect the actual pick — otherwise it falls
          // back to the product's default featured image (wrong colour/shape).
          function metalSlug(metal) {
            metal = (metal || '').toLowerCase();
            if (metal.indexOf('white') !== -1) return 'white-gold';
            if (metal.indexOf('platinum') !== -1) return 'white-gold'; // platinum -> white
            if (metal.indexOf('rose') !== -1) return 'rose-gold';
            return 'yellow-gold';
          }
          function imgFor(ms, shape, angle) {
            if (!shape) return null;
            var token = ms + '-' + shape + '-' + angle;
            var media = p.media || [];
            for (var i = 0; i < media.length; i++) {
              if ((media[i].alt || '').toLowerCase().indexOf(token) !== -1) {
                return (media[i].preview_image && media[i].preview_image.src) || media[i].src;
              }
            }
            return null;
          }
          var ms = metalSlug(builder.metal);
          var thumb = imgFor(ms, builder.shape, 'front')
            || imgFor('yellow-gold', builder.shape, 'front')
            || imgFor('yellow-gold', 'round', 'front')
            || p.featured_image;
          var imgEl = root.querySelector('[data-ctx-thumb]');
          if (imgEl && thumb) { imgEl.src = thumb; imgEl.alt = name; }
          var priceEl = root.querySelector('[data-ctx-price]');
          if (priceEl && variant) {
            priceEl.textContent = '$' + (variant.price / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        })
        .catch(function () { /* context bar stays minimal if the fetch fails */ });
    }

    /* ---------- infinite scroll over filtered set ---------- */
    if (sentinel && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && loaded && rendered < filtered.length) appendChunk(true);
        });
      }, { rootMargin: '600px 0px' }).observe(sentinel);
    }

    function init() { setupBuilder(); loadAll(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diamond-product"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-diamond-product]');
    if (!root) return;

    /* ---------- builder mode ---------- */
    var bp = new URLSearchParams(window.location.search);
    var builder = bp.get('setting') ? {
      setting: bp.get('setting'),
      variant: bp.get('variant') || '',
      metal: bp.get('metal') || '',
      shape: (bp.get('shape') || '').toLowerCase(),
      // Chosen refinements ride along untouched to step 3 (handle:qty, no prices)
      ref: bp.get('ref') || ''
    } : null;
    var flowDiamond = bp.get('flow') === 'diamond';

    if (builder) {
      root.classList.add('is-builder');
      var steps = root.querySelector('[data-builder-steps]'); if (steps) steps.hidden = false;
      var eyebrow = root.querySelector('[data-builder-eyebrow]'); if (eyebrow) eyebrow.hidden = false;
      var prefer = root.querySelector('[data-prefer]'); if (prefer) prefer.hidden = false;

      var settingUrl = '/products/' + encodeURIComponent(builder.setting);
      var step1 = root.querySelector('[data-cfg-step="1"]'); if (step1) step1.href = settingUrl;

      var ring = root.querySelector('[data-add-to-ring]');
      if (ring) {
        var diamond = ring.getAttribute('data-diamond') || '';
        ring.href = '/pages/build-review?setting=' + encodeURIComponent(builder.setting) +
          '&variant=' + encodeURIComponent(builder.variant) +
          '&metal=' + encodeURIComponent(builder.metal) +
          '&shape=' + encodeURIComponent(builder.shape) +
          (builder.ref ? '&ref=' + encodeURIComponent(builder.ref) : '') +
          '&diamond=' + encodeURIComponent(diamond) +
          '&dimg=' + encodeURIComponent(ring.getAttribute('data-diamond-img') || '');
        ring.hidden = false;
      }
    } else if (flowDiamond) {
      // Diamond-first Step 1: "Choose this diamond" -> the settings gallery.
      root.classList.add('is-builder');
      var stepsD = root.querySelector('[data-builder-steps]'); if (stepsD) stepsD.hidden = false;
      var preferD = root.querySelector('[data-prefer]'); if (preferD) preferD.hidden = false;
      var choose = root.querySelector('[data-choose-diamond]');
      if (choose) {
        var dh2 = choose.getAttribute('data-diamond') || '';
        choose.href = '/collections/engagement-rings?flow=diamond&diamond=' + encodeURIComponent(dh2) +
          '&dimg=' + encodeURIComponent(choose.getAttribute('data-diamond-img') || '') +
          '&dshape=' + encodeURIComponent(choose.getAttribute('data-diamond-shape') || '');
        choose.hidden = false;
      }
    }

    /* ---------- 360 lightbox (open the viewer full, on demand) ---------- */
    var modal = root.querySelector('[data-360-modal]');
    var frame = root.querySelector('[data-360-frame]');
    function open360(url) {
      if (!modal || !frame || !url) return;
      frame.innerHTML = '';
      var ifr = document.createElement('iframe');
      ifr.src = url;
      ifr.title = '360 degree view of this diamond';
      ifr.loading = 'lazy';
      ifr.setAttribute('allowfullscreen', '');
      ifr.setAttribute('referrerpolicy', 'no-referrer');
      ifr.setAttribute('allow', 'autoplay');
      frame.appendChild(ifr);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var c = modal.querySelector('.dp__lightbox-close');
      if (c) c.focus();
    }
    function close360() {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      frame.innerHTML = '';
      document.body.style.overflow = '';
    }
    root.querySelectorAll('[data-360-open]').forEach(function (b) {
      b.addEventListener('click', function () { open360(b.getAttribute('data-video')); });
    });
    root.querySelectorAll('[data-360-close]').forEach(function (el) {
      el.addEventListener('click', close360);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close360(); });

    /* ---------- accordions ---------- */
    root.querySelectorAll('.dp__acc-head').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.dp__acc-item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---------- mobile sticky CTA ---------- */
    var msticky = root.querySelector('[data-dp-sticky]');
    var mbtn = root.querySelector('[data-dp-sticky-btn]');
    var actionsEl = root.querySelector('.dp__actions');
    if (msticky && mbtn && actionsEl) {
      var choose = root.querySelector('[data-choose-diamond]');
      var ring = root.querySelector('[data-add-to-ring]');
      var buy = root.querySelector('.dp__btn--buy');
      var primary, label;
      if (flowDiamond && choose) { primary = choose; label = 'Choose this diamond'; }
      else if (builder && ring) { primary = ring; label = 'Add to ring'; }
      else { primary = buy; label = 'Buy loose'; }
      mbtn.textContent = label;
      mbtn.addEventListener('click', function () { if (primary) primary.click(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { msticky.hidden = en.isIntersecting; });
        }, { rootMargin: '0px 0px -8px 0px' }).observe(actionsEl);
      } else {
        msticky.hidden = false;
      }
    }

    /* ---------- mobile: measurement panels join the gallery ---------- */
    (function () {
      // Phone only. Desktop keeps the stacked layout it has today, so this runs
      // against the same markup rather than a second set of it. Both branches of
      // the measurement block render exactly two panels — the diamond-proportions
      // snippet's .dpx__panel pair, or the top-view / profile .dp__diagram pair.
      if (!window.matchMedia('(max-width: 560px)').matches) return;
      var gallery = root.querySelector('.dp__images');
      var measure = root.querySelector('.dp__measure');
      if (!gallery || !measure) return;
      var panels = measure.querySelectorAll('.dpx__panel, figure.dp__diagram');
      if (!panels.length) return;
      Array.prototype.forEach.call(panels, function (panel) {
        panel.classList.add('dp__image', 'dp__image--measure');
        gallery.appendChild(panel);
      });
      // A single-photo stone is no longer single once the panels are in.
      gallery.classList.remove('dp__images--single');
      // Whatever is left of the block is an empty grid holding open a gap.
      if (!measure.querySelector('figure, .dpx__panel')) measure.remove();
    })();

    /* ---------- mobile gallery swipe dots (still + 360 + measurements) ---------- */
    (function () {
      var gal = root.querySelector('.dp__images:not(.dp__images--single)');
      var dotsWrap = root.querySelector('[data-dp-dots]');
      if (!gal || !dotsWrap) return;
      var cells = gal.querySelectorAll('.dp__image');
      if (cells.length < 2) return;
      for (var i = 0; i < cells.length; i++) {
        var dot = document.createElement('span');
        dot.className = 'dp__dot';
        (function (idx) {
          dot.addEventListener('click', function () {
            cells[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          });
        })(i);
        dotsWrap.appendChild(dot);
      }
      function updateDots() {
        var dots = dotsWrap.querySelectorAll('.dp__dot');
        var center = gal.scrollLeft + gal.clientWidth / 2;
        var active = 0, best = Infinity;
        for (var i = 0; i < cells.length; i++) {
          var c = cells[i], cc = c.offsetLeft + c.offsetWidth / 2, d = Math.abs(cc - center);
          if (d < best) { best = d; active = i; }
        }
        for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === active);
      }
      gal.addEventListener('scroll', function () { window.requestAnimationFrame(updateDots); }, { passive: true });
      updateDots();
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diamond-shapes-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-ds]');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Best-ring-style shape selector */
    var rs = root.querySelector('[data-ds-rs]');
    if (rs) {
      var rtabs = rs.querySelectorAll('.ds__rs-tab');
      var rpanels = rs.querySelectorAll('.ds__rs-panel');
      rtabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-rs-tab');
          rtabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
          rpanels.forEach(function (p) { var on = p.getAttribute('data-rs-panel') === key; p.classList.toggle('is-active', on); p.hidden = !on; });
        });
      });
    }

    var items = root.querySelectorAll('.ds__reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diamond-shapes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mqMobile = window.matchMedia('(max-width: 600px)');

    document.querySelectorAll('.diamond-shapes__grid').forEach(function (track) {
      var items = Array.prototype.slice.call(track.children);
      if (items.length < 2) return;

      var idx = 0, timer = null, paused = false, resumeT = null;

      // build dots
      var dots = document.createElement('div');
      dots.className = 'diamond-shapes__dots';
      // Visible controls must not sit inside aria-hidden: the buttons below stay
      // focusable, so hiding them only breaks screen-reader users.
      dots.setAttribute('aria-label', 'Choose a diamond shape');
      items.forEach(function (it, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'diamond-shapes__dot';
        d.setAttribute('aria-label', 'Show shape ' + (i + 1));
        d.addEventListener('click', function () { go(i); interact(); scheduleResume(3000); });
        dots.appendChild(d);
      });
      // A single, always-centered caption that lives OUTSIDE the swiping track,
      // so it can never slide independently of the diamond. It cross-fades to the
      // active shape's description as the carousel changes (shown on mobile via CSS).
      var caption = document.createElement('p');
      caption.className = 'diamond-shapes__caption';
      caption.setAttribute('aria-hidden', 'true');
      var firstDesc = items[0].querySelector('.diamond-shape__desc');
      caption.textContent = firstDesc ? firstDesc.textContent.trim() : '';

      track.parentNode.insertBefore(caption, track.nextSibling);
      track.parentNode.insertBefore(dots, caption.nextSibling);
      var dotEls = Array.prototype.slice.call(dots.children);

      function setCaption() {
        var d = items[idx] && items[idx].querySelector('.diamond-shape__desc');
        var t = d ? d.textContent.trim() : '';
        if (caption.textContent === t) return;
        caption.style.opacity = '0';
        window.clearTimeout(caption._t);
        caption._t = window.setTimeout(function () {
          caption.textContent = t;
          caption.style.opacity = '1';
        }, 200);
      }

      function apply() {
        if (mqMobile.matches) {
          track.style.transform = 'translateX(' + (-idx * track.clientWidth) + 'px)';
        } else {
          track.style.transform = '';
        }
        items.forEach(function (it, k) { it.classList.toggle('is-active', k === idx); });
        dotEls.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
        setCaption();
      }
      function go(i) { idx = (i % items.length + items.length) % items.length; apply(); }
      function next() { if (paused || !mqMobile.matches) return; go(idx + 1); }
      function start() { stop(); if (mqMobile.matches) { timer = setInterval(next, 3400); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function interact() { paused = true; stop(); clearTimeout(resumeT); }
      function scheduleResume(ms) { clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; start(); }, ms); }

      // Swipe: directional-lock live drag. The whole slide (diamond + label +
      // description) tracks the finger together. Horizontal drags are captured
      // (preventDefault) so the browser can't natively pan the page/text, while
      // vertical drags fall through so the page still scrolls normally.
      var x0 = null, y0 = null, dragging = false, axis = null, baseX = 0, moved = 0;

      function baseTranslate() { return -idx * track.clientWidth; }

      track.addEventListener('touchstart', function (e) {
        if (!mqMobile.matches) return;
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
        baseX = baseTranslate();
        moved = 0;
        axis = null;
        dragging = true;
        interact();
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        var dx = e.touches[0].clientX - x0;
        var dy = e.touches[0].clientY - y0;
        if (axis === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (axis === 'x') { track.style.transition = 'none'; }
        }
        if (axis === 'x') {
          e.preventDefault();
          moved = dx;
          track.style.transform = 'translateX(' + (baseX + dx) + 'px)';
        }
      }, { passive: false });

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        if (axis === 'x') {
          track.style.transition = '';
          if (Math.abs(moved) > 40) { go(idx + (moved < 0 ? 1 : -1)); }
          else { apply(); }
        }
        axis = null; x0 = null; y0 = null;
        scheduleResume(2000);
      }
      track.addEventListener('touchend', endDrag, { passive: true });
      track.addEventListener('touchcancel', endDrag, { passive: true });

      window.addEventListener('resize', apply);
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', function () { apply(); start(); });

      apply();
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["earrings-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-eg-grid]');
    if (!root) return;

    // Mobile image-swipe dots: light up the dot for the visible slide.
    root.querySelectorAll('.eg-card').forEach(function (card) {
      var media = card.querySelector('.eg-card__media');
      var dots = card.querySelectorAll('.eg-card__dots i');
      if (!media || dots.length < 2) return;
      media.addEventListener('scroll', function () {
        var i = Math.round(media.scrollLeft / Math.max(1, media.clientWidth));
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }, { passive: true });
    });

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-eg-item]'));
    if (!items.length) return;
    items.forEach(function (it, i) {
      it.__order = i;
      it.__mainImg = it.querySelector('[data-eg-main]');
      it.__hoverImg = it.querySelector('[data-eg-hover]');
      it.__defF = it.__mainImg ? it.__mainImg.getAttribute('src') : '';
      it.__defS = it.__hoverImg ? it.__hoverImg.getAttribute('src') : '';
      it.__defMetal = it.getAttribute('data-default-metal') || 'yellow';
    });

    var list = root.querySelector('[data-eg-list]');
    var typeEls = Array.prototype.slice.call(root.querySelectorAll('[data-type]'));
    var shapeEls = Array.prototype.slice.call(root.querySelectorAll('[data-facet="shape"]'));
    var metalEls = Array.prototype.slice.call(root.querySelectorAll('[data-facet="metal"]'));
    var priceMinEl = root.querySelector('[data-price-min]');
    var priceMaxEl = root.querySelector('[data-price-max]');
    var sortSel = root.querySelector('[data-eg-sort]');
    var drawer = root.querySelector('[data-eg-drawer]');
    var activeWrap = root.querySelector('[data-eg-active]');
    var activeTypes = [], activeShapes = [], activeMetals = [];

    function tokens(v) { return (v || '').split(/\s+/).filter(Boolean); }

    function matches(it) {
      if (activeTypes.length && activeTypes.indexOf(it.getAttribute('data-etype')) === -1) return false;
      if (activeShapes.length && activeShapes.indexOf(it.getAttribute('data-shape')) === -1) return false;
      if (activeMetals.length) {
        var metals = tokens(it.getAttribute('data-metals'));
        if (!activeMetals.some(function (m) { return metals.indexOf(m) !== -1; })) return false;
      }
      var pr = parseInt(it.getAttribute('data-price'), 10) || 0;
      var mn = parseFloat(priceMinEl && priceMinEl.value) || 0;
      var mx = parseFloat(priceMaxEl && priceMaxEl.value);
      if (mn > 0 && pr < mn * 100) return false;
      if (!isNaN(mx) && mx > 0 && pr > mx * 100) return false;
      return true;
    }

    function sortNow() {
      if (!list) return;
      var mode = sortSel ? sortSel.value : 'featured';
      items.filter(function (it) { return !it.hidden; }).sort(function (a, b) {
        if (mode === 'price-asc') return (parseInt(a.getAttribute('data-price'), 10) || 0) - (parseInt(b.getAttribute('data-price'), 10) || 0);
        if (mode === 'price-desc') return (parseInt(b.getAttribute('data-price'), 10) || 0) - (parseInt(a.getAttribute('data-price'), 10) || 0);
        if (mode === 'carat-asc') return (parseFloat(a.getAttribute('data-carat')) || 0) - (parseFloat(b.getAttribute('data-carat')) || 0);
        if (mode === 'carat-desc') return (parseFloat(b.getAttribute('data-carat')) || 0) - (parseFloat(a.getAttribute('data-carat')) || 0);
        if (mode === 'name') return (a.getAttribute('data-name') || '').localeCompare(b.getAttribute('data-name') || '');
        return a.__order - b.__order;
      }).forEach(function (it) { list.appendChild(it); });
    }

    // Swap each visible card's photo to the last-selected metal (revert to default when cleared).
    function applyDisplay() {
      var dm = activeMetals.length ? activeMetals[activeMetals.length - 1] : null;
      items.forEach(function (it) {
        if (it.hidden || !it.__mainImg) return;
        if (dm) {
          var sw = it.querySelector('.eg-card__swatch--' + dm + '[data-eg-img]');
          if (sw) {
            it.__mainImg.setAttribute('src', sw.getAttribute('data-eg-img'));
            if (it.__hoverImg) it.__hoverImg.setAttribute('src', sw.getAttribute('data-eg-pair') || sw.getAttribute('data-eg-img'));
          }
        } else {
          it.__mainImg.setAttribute('src', it.__defF);
          if (it.__hoverImg) it.__hoverImg.setAttribute('src', it.__defS);
        }
        Array.prototype.forEach.call(it.querySelectorAll('.eg-card__swatch'), function (s) {
          s.classList.toggle('is-active', s.classList.contains('eg-card__swatch--' + (dm || it.__defMetal)));
        });
      });
    }

    function apply() {
      items.forEach(function (it) { it.hidden = !matches(it); });
      sortNow();
      applyDisplay();
      renderChips();
    }

    function labelFor(type, value) {
      var sel;
      if (type === 'type') sel = root.querySelector('.eg-stile[data-type="' + value + '"] .eg-tile__label') || root.querySelector('.eg-cat[data-type="' + value + '"] .eg-cat__label');
      else if (type === 'shape') sel = root.querySelector('.eg-stile[data-facet="shape"][data-value="' + value + '"] .eg-tile__label');
      else if (type === 'metal') sel = root.querySelector('.eg-mtile[data-value="' + value + '"] .eg-tile__label');
      return sel ? sel.textContent.trim() : value;
    }
    function deselect(kind, value) {
      var i;
      if (kind === 'type') { i = activeTypes.indexOf(value); if (i > -1) activeTypes.splice(i, 1); root.querySelectorAll('[data-type="' + value + '"]').forEach(function (e) { e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); }); }
      else if (kind === 'shape') { i = activeShapes.indexOf(value); if (i > -1) activeShapes.splice(i, 1); root.querySelectorAll('[data-facet="shape"][data-value="' + value + '"]').forEach(function (e) { e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); }); }
      else if (kind === 'metal') { i = activeMetals.indexOf(value); if (i > -1) activeMetals.splice(i, 1); root.querySelectorAll('[data-facet="metal"][data-value="' + value + '"]').forEach(function (e) { e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); }); }
      else if (kind === 'pmin') { if (priceMinEl) priceMinEl.value = ''; }
      else if (kind === 'pmax') { if (priceMaxEl) priceMaxEl.value = ''; }
      apply();
    }
    function clearAll() {
      activeTypes.length = 0; activeShapes.length = 0; activeMetals.length = 0;
      root.querySelectorAll('[data-type].is-active, [data-facet].is-active').forEach(function (e) { e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); });
      if (priceMinEl) priceMinEl.value = '';
      if (priceMaxEl) priceMaxEl.value = '';
      apply();
    }
    function renderChips() {
      if (!activeWrap) return;
      var chips = [];
      activeTypes.forEach(function (v) { chips.push(['type', v, labelFor('type', v)]); });
      activeShapes.forEach(function (v) { chips.push(['shape', v, labelFor('shape', v)]); });
      activeMetals.forEach(function (v) { chips.push(['metal', v, labelFor('metal', v)]); });
      if (priceMinEl && priceMinEl.value) chips.push(['pmin', '', 'Min $' + priceMinEl.value]);
      if (priceMaxEl && priceMaxEl.value) chips.push(['pmax', '', 'Max $' + priceMaxEl.value]);
      activeWrap.innerHTML = '';
      if (!chips.length) { activeWrap.hidden = true; return; }
      activeWrap.hidden = false;
      chips.forEach(function (c) {
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'eg-chip'; btn.setAttribute('aria-label', 'Remove ' + c[2]);
        btn.appendChild(document.createTextNode(c[2] + ' '));
        var x = document.createElement('span'); x.className = 'eg-chip__x'; x.setAttribute('aria-hidden', 'true'); x.textContent = '×';
        btn.appendChild(x);
        btn.addEventListener('click', function () { deselect(c[0], c[1]); });
        activeWrap.appendChild(btn);
      });
      var clr = document.createElement('button'); clr.type = 'button'; clr.className = 'eg-chip eg-chip--clear'; clr.textContent = 'Clear all';
      clr.addEventListener('click', clearAll);
      activeWrap.appendChild(clr);
    }

    // Style type: the top bar buttons and drawer tiles share data-type, so toggle both.
    // (Unstocked types are plain links to the listing, so they're not in typeEls.)
    function toggleType(key) {
      var i = activeTypes.indexOf(key);
      if (i === -1) activeTypes.push(key); else activeTypes.splice(i, 1);
      var on = activeTypes.indexOf(key) !== -1;
      root.querySelectorAll('[data-type="' + key + '"]').forEach(function (e) { e.classList.toggle('is-active', on); e.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      apply();
    }
    typeEls.forEach(function (e) { e.addEventListener('click', function () { toggleType(e.getAttribute('data-type')); }); });

    function bindFacet(els, arr) {
      els.forEach(function (e) {
        e.addEventListener('click', function () {
          var v = e.getAttribute('data-value'), i = arr.indexOf(v);
          if (i === -1) { arr.push(v); e.classList.add('is-active'); e.setAttribute('aria-pressed', 'true'); }
          else { arr.splice(i, 1); e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); }
          apply();
        });
      });
    }
    bindFacet(shapeEls, activeShapes);
    bindFacet(metalEls, activeMetals);
    if (priceMinEl) priceMinEl.addEventListener('input', apply);
    if (priceMaxEl) priceMaxEl.addEventListener('input', apply);
    if (sortSel) sortSel.addEventListener('change', sortNow);

    // Card metal swatches → swap that card's photos to the chosen metal.
    // Delegated on the grid so it survives re-ordering, and preventDefault stops
    // the click from bubbling into a scroll jump.
    if (list) list.addEventListener('click', function (e) {
      var sw = e.target.closest('.eg-card__swatch');
      if (!sw || !list.contains(sw)) return;
      e.preventDefault();
      e.stopPropagation();
      var main = sw.getAttribute('data-eg-img');
      var it = sw.closest('[data-eg-item]');
      if (!main || !it) return;
      var mimg = it.querySelector('[data-eg-main]');
      var himg = it.querySelector('[data-eg-hover]');
      if (mimg) mimg.setAttribute('src', main);
      if (himg) himg.setAttribute('src', sw.getAttribute('data-eg-pair') || main);
      Array.prototype.forEach.call(it.querySelectorAll('.eg-card__swatch'), function (s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');
    });

    var openBtn = root.querySelector('[data-eg-open]');
    function closeDrawer() { if (drawer) { drawer.hidden = true; document.body.style.overflow = ''; } }
    if (openBtn && drawer) {
      openBtn.addEventListener('click', function () { drawer.hidden = false; document.body.style.overflow = 'hidden'; });
      root.querySelectorAll('[data-eg-close]').forEach(function (c) { c.addEventListener('click', closeDrawer); });
    }
    var clearBtn = root.querySelector('[data-eg-clear]');
    if (clearBtn) clearBtn.addEventListener('click', clearAll);

    // Pre-select a metal from the URL (mega-menu "Shop by metal").
    try {
      var mp = (new URLSearchParams(window.location.search).get('metal') || '').toLowerCase();
      var key = mp.indexOf('rose') !== -1 ? 'rose' : (mp.indexOf('white') !== -1 || mp.indexOf('platinum') !== -1) ? 'white' : mp.indexOf('yellow') !== -1 ? 'yellow' : '';
      if (key) { var mel = root.querySelector('[data-facet="metal"][data-value="' + key + '"]'); if (mel) mel.click(); }
    } catch (e) {}

    // Pre-select a style category from the URL (mega-menu "Earrings" links).
    try {
      var tp = (new URLSearchParams(window.location.search).get('type') || '').toLowerCase();
      if (tp) { var tel = root.querySelector('.eg-cat[data-type="' + tp + '"]') || root.querySelector('.eg-stile[data-type="' + tp + '"]'); if (tel) tel.click(); }
    } catch (e) {}

    apply();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["earrings-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-epd]');
    if (!root) return;

    var variants = [];
    var images = {};
    try { variants = JSON.parse(root.getAttribute('data-variants') || '[]'); } catch (e) {}
    try { images = JSON.parse(root.getAttribute('data-images') || '{}'); } catch (e) {}

    var priceEl = root.querySelector('[data-epd-price]');
    var wasEl = root.querySelector('[data-epd-was]');
    var savedEl = root.querySelector('[data-epd-saved]');
    var idInput = root.querySelector('[data-epd-id]');
    var metalLabel = root.querySelector('[data-epd-metal-label]');
    var caratLabel = root.querySelector('[data-epd-carat-label]');
    var edCarat = root.querySelector('[data-epd-ed-carat]');
    var mainImg = root.querySelector('[data-epd-main]');
    var pairImg = root.querySelector('[data-epd-pair]');
    var pairCell = root.querySelector('[data-epd-pair-cell]');
    var compareCell = root.querySelector('[data-epd-compare-cell]');
    var addBtn = root.querySelector('.epd__add');

    var state = { metal: '', carat: '' };
    var am = root.querySelector('.epd-metal.is-active');
    var ac = root.querySelector('.epd-carat.is-active');
    if (am) state.metal = am.getAttribute('data-epd-metal');
    if (ac) state.carat = ac.getAttribute('data-epd-carat');

    function metalSlug(metal) {
      metal = (metal || '').toLowerCase();
      if (metal.indexOf('rose') !== -1) return 'rose';
      if (metal.indexOf('white') !== -1) return 'white';
      return 'yellow';
    }

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].metal === state.metal && variants[i].carat === state.carat) return variants[i];
      }
      return null;
    }

    function applyImages() {
      var slug = metalSlug(state.metal);
      var im = images[slug] || {};
      var main = im.main, pair = im.pair;
      // Selected metal has no photo -> fall back to any metal that does (yellow, then white, then rose).
      if (!main) {
        var fb = images.yellow || {}; if (!fb.main) fb = images.white || {}; if (!fb.main) fb = images.rose || {};
        main = fb.main; pair = fb.pair;
      }
      if (main && mainImg) mainImg.src = main;
      if (pairCell) {
        if (pair) { if (pairImg) pairImg.src = pair; pairCell.classList.remove('epd__cell--hidden'); }
        else { pairCell.classList.add('epd__cell--hidden'); }
      }
      if (compareCell) {
        var showCompare = images.compare && (state.carat || '').indexOf('0.5') !== -1;
        compareCell.classList.toggle('epd__cell--hidden', !showCompare);
      }
    }

    function update() {
      var v = findVariant();
      if (v) {
        if (priceEl) priceEl.textContent = v.price;
        // The was-price and the saving belong to the variant, not the product:
        // 1ct is on offer here and the other weights are not.
        if (wasEl) {
          wasEl.textContent = v.compare || '';
          wasEl.hidden = !v.compare;
        }
        if (savedEl) {
          savedEl.textContent = v.saved ? 'Save ' + v.saved : '';
          savedEl.hidden = !v.saved;
        }
        if (idInput) idInput.value = v.id;
        var epdSku = root.querySelector('[data-epd-sku]');
        if (epdSku && v.sku) epdSku.textContent = v.sku;
        if (addBtn) addBtn.disabled = !v.available;
      }
      if (metalLabel) metalLabel.textContent = state.metal;
      if (caratLabel) caratLabel.textContent = state.carat;
      if (edCarat) edCarat.textContent = state.carat.replace(/\s*ct\s*/i, '').trim() || state.carat;
      applyImages();
      buildDots();
    }

    root.querySelectorAll('.epd-metal').forEach(function (b) {
      b.addEventListener('click', function () {
        state.metal = b.getAttribute('data-epd-metal');
        root.querySelectorAll('.epd-metal').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-active'); b.setAttribute('aria-checked', 'true');
        update();
      });
    });
    root.querySelectorAll('.epd-carat').forEach(function (b) {
      b.addEventListener('click', function () {
        state.carat = b.getAttribute('data-epd-carat');
        root.querySelectorAll('.epd-carat').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-active'); b.setAttribute('aria-checked', 'true');
        update();
      });
    });

    root.querySelectorAll('.epd__acc-head').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.epd__acc-item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Mobile gallery swipe dots — rebuilt whenever metal/carat changes which images show.
    var galleryGrid = root.querySelector('.epd__grid');
    var dotsWrap = root.querySelector('[data-epd-dots]');
    function visibleCells() { return galleryGrid ? galleryGrid.querySelectorAll('.epd__cell:not(.epd__cell--hidden)') : []; }
    function updateDots() {
      if (!galleryGrid || !dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.epd__dot'); if (!dots.length) return;
      var cells = visibleCells();
      var center = galleryGrid.scrollLeft + galleryGrid.clientWidth / 2;
      var active = 0, best = Infinity;
      for (var i = 0; i < cells.length; i++) { var c = cells[i], cc = c.offsetLeft + c.offsetWidth / 2, dd = Math.abs(cc - center); if (dd < best) { best = dd; active = i; } }
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === active);
    }
    function buildDots() {
      if (!galleryGrid || !dotsWrap) return;
      var cells = visibleCells();
      dotsWrap.innerHTML = '';
      if (cells.length < 2) return;
      for (var i = 0; i < cells.length; i++) {
        var dot = document.createElement('span'); dot.className = 'epd__dot';
        (function (idx) { dot.addEventListener('click', function () { visibleCells()[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); }); })(i);
        dotsWrap.appendChild(dot);
      }
      updateDots();
    }
    if (galleryGrid) galleryGrid.addEventListener('scroll', function () { window.requestAnimationFrame(updateDots); }, { passive: true });

    // ---- Lightbox: open full-size (same page), zoom + prev/next + thumbnail filmstrip
    // (matches the setting details page). ----
    var lb = root.querySelector('[data-epd-lightbox]');
    var lbImg = root.querySelector('[data-epd-lb-img]');
    var lbPrev = root.querySelector('[data-epd-lb-prev]');
    var lbNext = root.querySelector('[data-epd-lb-next]');
    var lbThumbs = root.querySelector('[data-epd-lb-thumbs]');
    var lbList = [], lbIndex = 0, lbScale = 1;
    function lbSetZoom(scale, ox, oy) {
      lbScale = Math.max(1, Math.min(scale, 3));
      if (!lbImg) return;
      lbImg.style.transformOrigin = (ox != null) ? (ox + '% ' + oy + '%') : 'center';
      lbImg.style.transform = 'scale(' + lbScale + ')';
      lbImg.classList.toggle('is-zoomed', lbScale > 1);
    }
    function lbShow(i) {
      if (!lbList.length) return;
      lbIndex = (i % lbList.length + lbList.length) % lbList.length;
      if (lbImg) lbImg.src = lbList[lbIndex];
      lbSetZoom(1);
      var multi = lbList.length > 1;
      if (lbPrev) lbPrev.hidden = !multi;
      if (lbNext) lbNext.hidden = !multi;
      if (lbThumbs) { var t = lbThumbs.querySelectorAll('.epd__lb-thumb'); for (var j = 0; j < t.length; j++) t[j].classList.toggle('is-active', j === lbIndex); }
    }
    function lbBuildThumbs() {
      if (!lbThumbs) return;
      lbThumbs.innerHTML = '';
      if (lbList.length < 2) { lbThumbs.hidden = true; return; }
      lbThumbs.hidden = false;
      lbList.forEach(function (src, i) {
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'epd__lb-thumb';
        var im = document.createElement('img'); im.src = src; im.alt = ''; btn.appendChild(im);
        btn.addEventListener('click', function (e) { e.stopPropagation(); lbShow(i); });
        lbThumbs.appendChild(btn);
      });
    }
    function lbOpen(src) {
      lbList = [];
      var cells = visibleCells();
      for (var i = 0; i < cells.length; i++) {
        var im = cells[i].querySelector('.epd__cell-img');
        if (im && im.getAttribute('src')) lbList.push(im.getAttribute('src'));
      }
      lbBuildThumbs();
      var start = lbList.indexOf(src);
      lbShow(start < 0 ? 0 : start);
      if (lb) { lb.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    }
    function lbClose() { if (lb) { lb.hidden = true; document.documentElement.style.overflow = ''; lbSetZoom(1); } }
    if (galleryGrid) {
      galleryGrid.addEventListener('click', function (e) {
        var cell = e.target.closest('.epd__cell');
        if (!cell || cell.classList.contains('epd__cell--hidden')) return;
        var im = cell.querySelector('.epd__cell-img');
        if (im && im.getAttribute('src')) lbOpen(im.getAttribute('src'));
      });
    }
    if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
    if (lbImg) {
      lbImg.addEventListener('click', function (e) {
        e.stopPropagation();
        if (lbScale > 1) { lbSetZoom(1); return; }
        var r = lbImg.getBoundingClientRect();
        lbSetZoom(2, ((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
      });
      lbImg.addEventListener('mousemove', function (e) {
        if (lbScale <= 1) return;
        var r = lbImg.getBoundingClientRect();
        lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
      });
      lbImg.addEventListener('wheel', function (e) {
        e.preventDefault();
        var r = lbImg.getBoundingClientRect();
        lbSetZoom(lbScale + (e.deltaY < 0 ? 0.3 : -0.3), ((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
      }, { passive: false });
    }
    var lbCloseBtn = root.querySelector('[data-epd-lb-close]');
    if (lbCloseBtn) lbCloseBtn.addEventListener('click', function (e) { e.stopPropagation(); lbClose(); });
    if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIndex - 1); });
    if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIndex + 1); });
    document.addEventListener('keydown', function (e) {
      if (!lb || lb.hidden) return;
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
      else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
    });

    // Add over AJAX so a failure can be reported in place, then go to the cart.
    // If this listener never runs the browser submits the form itself and
    // return_to lands on the cart, so the button always works.
    var epdForm = root.querySelector('form[data-type="add-to-cart-form"]');
    if (epdForm) {
      epdForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('aria-busy', 'true'); }
        fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(epdForm) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          // Literal path: Liquid is not rendered inside {% javascript %}, so
          // routes.cart_url would arrive here as the unexpanded tag.
          .then(function () { window.location.href = '/cart'; })
          .catch(function () {
            if (addBtn) { addBtn.disabled = false; addBtn.removeAttribute('aria-busy'); }
            var live = root.querySelector('[data-epd-live]');
            if (live) live.textContent = 'Sorry, we could not add that to your cart. Please try again.';
            window.alert('Sorry, we couldn\u2019t add that to your cart. Please try again.');
          });
      });

      // Returning from the cart restores this page from the back-forward cache
      // with the button still disabled from the add that navigated away.
      window.addEventListener('pageshow', function (event) {
        if (!event.persisted || !addBtn) return;
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-busy');
      });
    }

    update();
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["earrings-seo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-eseo].eseo--collapsible').forEach(function (root) {
      var toggle = root.querySelector('[data-eseo-toggle]');
      var label = root.querySelector('[data-eseo-toggle-label]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var expanded = root.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (label) label.textContent = expanded ? 'Read less' : 'Read more';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["engagement-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.ef-faq__q').forEach(function (btn) {
        if (btn.dataset.efBound) return;
        btn.dataset.efBound = '1';
        btn.addEventListener('click', function () {
          var item = btn.closest('.ef-faq__item');
          var open = item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["engagement-ring-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-er]');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Metal selector */
    var metals = root.querySelector('[data-er-metals]');
    if (metals) {
      var tabs = metals.querySelectorAll('.er__metal-tab');
      var panels = metals.querySelectorAll('.er__metal-panel');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var key = t.getAttribute('data-metal');
          tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panels.forEach(function (p) { var on = p.getAttribute('data-panel') === key; p.classList.toggle('is-active', on); p.hidden = !on; });
        });
      });
    }

    /* Reveal */
    var items = root.querySelectorAll('.er__reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
      items.forEach(function (el) { io.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["engagement-rings-seo"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-erseo]').forEach(function (root) {
    var btn = root.querySelector('[data-erseo-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = root.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Read less' : 'Read more';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-fa]');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var search = root.querySelector('[data-fa-search]');
    var rail = root.querySelectorAll('[data-fa-rail] a');
    var groups = Array.prototype.slice.call(root.querySelectorAll('.fa__group'));
    var items = Array.prototype.slice.call(root.querySelectorAll('.fa__item'));
    var noResults = root.querySelector('[data-fa-noresults]');

    items.forEach(function (it) { it.dataset.text = (it.textContent || '').toLowerCase(); });

    function apply() {
      var q = (search.value || '').trim().toLowerCase();
      var shown = 0;
      items.forEach(function (it) {
        var ok = !q || it.dataset.text.indexOf(q) !== -1;
        it.hidden = !ok;
        if (ok) shown++;
        if (!ok && it.open) it.open = false;
      });
      groups.forEach(function (g) {
        var vis = g.querySelectorAll('.fa__item:not([hidden])').length;
        g.hidden = vis === 0;
      });
      if (noResults) noResults.hidden = shown !== 0;
    }
    search.addEventListener('input', apply);

    /* Smooth scroll for rail links */
    rail.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        var target = id && document.querySelector(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      });
    });

    /* Scroll-spy: highlight the rail link for the group in view */
    if ('IntersectionObserver' in window) {
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var key = en.target.getAttribute('data-group');
            rail.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-railcat') === key); });
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
      groups.forEach(function (g) { spy.observe(g); });
    }

    /* Reveal */
    var rv = root.querySelectorAll('.fa__reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      rv.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
      rv.forEach(function (el) { io.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-mv"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 768px)');

    document.querySelectorAll('.footer-mv__column').forEach(function (col) {
      var head = col.querySelector('.footer-mv__column-heading');
      if (!head) return;

      function toggle() {
        if (!mq.matches) return;
        var open = col.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      head.addEventListener('click', function () { toggle(); });
      head.addEventListener('keydown', function (e) {
        if (mq.matches && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); toggle(); }
      });

      function sync() {
        if (mq.matches) {
          // ARIA does not allow role="button" on a heading element, and axe flags it
          // on every page. The heading keeps its semantics; the button behaviour moves
          // onto the element itself only as far as ARIA permits — expanded state and a
          // focusable target, without claiming to BE a button.
          head.setAttribute('tabindex', '0');
          if (!head.hasAttribute('aria-expanded')) head.setAttribute('aria-expanded', 'false');
        } else {
          head.removeAttribute('role');
          head.removeAttribute('tabindex');
          head.removeAttribute('aria-expanded');
          col.classList.remove('is-open');
        }
      }
      sync();
      if (mq.addEventListener) mq.addEventListener('change', sync);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fourcs-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-fc]');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* progress-fill for range sliders */
    function setFill(s) {
      var pct = (s.value - s.min) / (s.max - s.min) * 100;
      s.style.background = 'linear-gradient(90deg, var(--fc-moss), var(--fc-gold) ' + pct + '%, #ded7c8 ' + pct + '%)';
    }

    /* CUT grade selector */
    var cut = root.querySelector('[data-fc-cut]');
    if (cut) {
      var gbtns = cut.querySelectorAll('.fc__grade');
      var stage = cut.querySelector('[data-cut-stage]');
      var cname = cut.querySelector('[data-cut-name]');
      var cdesc = cut.querySelector('[data-cut-desc]');
      gbtns.forEach(function (b) {
        b.addEventListener('click', function () {
          gbtns.forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
          stage.style.setProperty('--lvl', b.dataset.grade);
          cname.textContent = b.dataset.name;
          cdesc.textContent = b.dataset.desc;
        });
      });
    }

    /* COLOUR slider */
    var cgr = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    var cs = root.querySelector('[data-fc-color]');
    if (cs) {
      var swatch = root.querySelector('[data-color-swatch]');
      var clab = root.querySelector('[data-color-label]');
      var czone = root.querySelector('[data-color-zone]');
      var cnote = root.querySelector('[data-color-note]');
      var colorFn = function () {
        var i = +cs.value, w = i / 22;
        swatch.setAttribute('fill', 'hsl(47, ' + Math.round(w * 80) + '%, ' + Math.round(99 - w * 18) + '%)');
        clab.textContent = cgr[i];
        var z, n;
        if (i <= 2) { z = 'Colourless'; n = 'Icy white and rare — stunning in any metal.'; }
        else if (i <= 6) { z = 'Near-colourless'; n = 'Looks white face-up — the smart-value zone.'; }
        else if (i <= 12) { z = 'Faint'; n = 'A gentle warmth shows, especially against white metals.'; }
        else { z = 'Noticeable'; n = 'Clear warmth — usually set in yellow gold to suit it.'; }
        czone.textContent = z; cnote.textContent = n;
        setFill(cs);
      };
      cs.addEventListener('input', colorFn); colorFn();
    }

    /* CLARITY slider */
    var clgr = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1'];
    var cln = [0, 0, 1, 1, 2, 2, 4, 5, 8];
    var cl = root.querySelector('[data-fc-clarity]');
    if (cl) {
      var dots = root.querySelectorAll('[data-clarity-gem] .fc__incl');
      var cllab = root.querySelector('[data-clarity-label]');
      var cleye = root.querySelector('[data-clarity-eye]');
      var clnote = root.querySelector('[data-clarity-note]');
      var clarFn = function () {
        var i = +cl.value, n = cln[i];
        dots.forEach(function (d, idx) { d.style.opacity = idx < n ? '1' : '0'; });
        cllab.textContent = clgr[i];
        var e, t, cls;
        if (i <= 5) { e = 'Eye-clean'; t = 'No inclusions visible to the naked eye.'; cls = 'is-good'; }
        else if (i <= 7) { e = 'Usually eye-clean'; t = 'Often clean to the eye — check the report.'; cls = 'is-mid'; }
        else { e = 'Visible'; t = 'Inclusions you can see without a loupe.'; cls = 'is-low'; }
        cleye.textContent = e; clnote.textContent = t; cleye.className = 'fc__pill ' + cls;
        setFill(cl);
      };
      cl.addEventListener('input', clarFn); clarFn();
    }

    /* CARAT slider */
    var ct = root.querySelector('[data-fc-carat]');
    if (ct) {
      var cgem = root.querySelector('[data-carat-gem]');
      var ctc = root.querySelector('[data-carat-ct]');
      var ctm = root.querySelector('[data-carat-mm]');
      var ctnote = root.querySelector('[data-carat-note]');
      var caratFn = function () {
        var c = (+ct.value) / 100;
        var mm = 6.5 * Math.cbrt(c);
        var px = Math.round(mm * 11);
        cgem.style.width = px + 'px'; cgem.style.height = px + 'px';
        ctc.textContent = c.toFixed(2) + ' ct';
        ctm.textContent = mm.toFixed(1) + ' mm';
        var n;
        if ((c >= 0.9 && c < 1) || (c >= 1.4 && c < 1.5) || (c >= 1.9 && c < 2) || (c >= 2.9 && c < 3)) { n = 'Smart buy — just under a magic number, for noticeably less.'; }
        else if (Math.abs(c - Math.round(c)) < 0.03 && c >= 1) { n = 'A “magic number” — sits right on a price jump.'; }
        else { n = 'Cut and shape decide how large this looks.'; }
        ctnote.textContent = n;
        setFill(ct);
      };
      ct.addEventListener('input', caratFn); caratFn();
    }

    /* Sticky subnav active state */
    var nav = root.querySelector('[data-fc-nav]');
    var navlinks = nav ? nav.querySelectorAll('a') : [];
    var ids = ['cut', 'colour', 'clarity', 'carat', 'balance'];

    /* Reveal + section spy */
    var items = root.querySelectorAll('.fc__reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
      items.forEach(function (el) { io.observe(el); });
    }
    if (nav && 'IntersectionObserver' in window) {
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            navlinks.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-nav') === en.target.id); });
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
      ids.forEach(function (id) { var s = document.getElementById(id); if (s) spy.observe(s); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-hslide]');
    if (!root || root.__hslideInit) return;   // this section's JS can run twice; only init once
    root.__hslideInit = true;
    var track = root.querySelector('[data-hslide-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hslide__slide'));
    if (!track || slides.length < 2) return;
    var dotsWrap = root.querySelector('[data-hslide-dots]');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var idx = 0, timer = null, reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Build dots
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (s, i) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'hslide__dot' + (i === 0 ? ' is-active' : '');
        // These are visible controls, so they are exposed rather than hidden. The
        // container used to be aria-hidden while holding real <button>s, which traps
        // a keyboard user on controls a screen reader is told do not exist.
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.addEventListener('click', function () { go(i, true); });
        dotsWrap.appendChild(d); dots.push(d);
      });
    }
    function setActive(i) { dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); }); }

    // Transform-based slide (GPU-composited). The transition is owned by CSS and
    // only turned off via .is-dragging — flipping the inline transition in the same
    // frame as the transform makes iOS Safari SKIP the animation (the "jump").
    var len = slides.length;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var tick = mobile ? 3000 : interval;   // 3s on phones, section setting on desktop
    var w = track.clientWidth;
    function pos(i) { track.style.transform = 'translate3d(' + (-i * 100) + '%, 0, 0)'; }
    function jump(i) { track.classList.add('is-dragging'); pos(i); void track.offsetWidth; track.classList.remove('is-dragging'); }
    function go(i, user) {
      idx = (i % len + len) % len;
      pos(idx);                 // CSS transition animates this
      setActive(idx);
      if (user) restart();
    }
    function next() { go(idx + 1); }

    function start() { if (!timer) timer = setInterval(next, tick); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    // Touch swipe: 1:1 finger drag (transition off via .is-dragging), snap on release.
    var startX = 0, startY = 0, drag = false, moved = false, delta = 0;
    track.addEventListener('touchstart', function (e) {
      stop(); var t = e.touches[0]; startX = t.clientX; startY = t.clientY;
      w = track.clientWidth; drag = true; moved = false; delta = 0;
      track.classList.add('is-dragging');
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!drag) return;
      var t = e.touches[0], dx = t.clientX - startX, dy = t.clientY - startY;
      if (!moved && Math.abs(dy) > Math.abs(dx)) { drag = false; track.classList.remove('is-dragging'); pos(idx); return; }
      moved = true; delta = dx;
      track.style.transform = 'translate3d(' + (-idx * w + dx) + 'px, 0, 0)';
    }, { passive: true });
    function endDrag() {
      if (drag) {
        track.classList.remove('is-dragging');
        if (Math.abs(delta) > w * 0.15) { go(delta < 0 ? idx + 1 : idx - 1); }
        else { pos(idx); }
      }
      drag = false; delta = 0;
      restart();  // always resume autoplay — even after a vertical page scroll on the hero
    }
    track.addEventListener('touchend', endDrag, { passive: true });
    track.addEventListener('touchcancel', endDrag, { passive: true });

    // Pause on hover (desktop) / when the tab is hidden.
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    window.addEventListener('resize', function () { w = track.clientWidth; jump(idx); });

    jump(0);
    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jewelry-care"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-jc]');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Cleaning selector */
    var clean = root.querySelector('[data-jc-clean]');
    if (clean) {
      var tabs = clean.querySelectorAll('.jc__clean-tab');
      var panels = clean.querySelectorAll('.jc__clean-panel');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var key = t.getAttribute('data-clean-tab');
          tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panels.forEach(function (p) { var on = p.getAttribute('data-clean-panel') === key; p.classList.toggle('is-active', on); p.hidden = !on; });
        });
      });
    }

    /* Reveal */
    var items = root.querySelectorAll('.jc__reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
      items.forEach(function (el) { io.observe(el); });
    }

    /* Sticky nav scroll-spy */
    var nav = root.querySelector('[data-jc-nav]');
    if (nav && 'IntersectionObserver' in window) {
      var links = nav.querySelectorAll('a');
      var ids = ['glance', 'daily', 'cleaning', 'storage', 'maintenance', 'help', 'mistakes'];
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-nav') === en.target.id); }); }
        });
      }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
      ids.forEach(function (id) { var s = document.getElementById(id); if (s) spy.observe(s); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab-grown-diamonds"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-lg]');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* HPHT / CVD method selector */
    var methods = root.querySelector('[data-lg-methods]');
    if (methods) {
      var tabs = methods.querySelectorAll('.lg__method-tab');
      var panels = methods.querySelectorAll('.lg__method-panel');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var key = t.getAttribute('data-m');
          tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panels.forEach(function (p) { var on = p.getAttribute('data-panel') === key; p.classList.toggle('is-active', on); p.hidden = !on; });
        });
      });
    }

    /* Reveal */
    var items = root.querySelectorAll('.lg__reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
      items.forEach(function (el) { io.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["made-to-order"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-mo]');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = root.querySelectorAll('.mo__reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-lookup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-mvto-form]');
    if (!form) return;
    var login = form.getAttribute('action');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // Route to the passwordless customer login (clean URL; guests sign in with email + code).
      window.location.assign(login);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policy-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-mvpol-link]'));
    var sections = Array.prototype.slice.call(document.querySelectorAll('[data-mvpol-section]'));
    if (!links.length || !sections.length) return;

    var byId = {};
    links.forEach(function (l) { byId[l.getAttribute('data-mvpol-link')] = l; });

    // Smooth scroll for jump links.
    links.forEach(function (l) {
      l.addEventListener('click', function (e) {
        var id = l.getAttribute('data-mvpol-link');
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });

    // Highlight the section currently in view.
    if ('IntersectionObserver' in window) {
      var visible = {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible[en.target.id] = en.isIntersecting ? en.intersectionRatio : 0; });
        var bestId = null, bestRatio = 0;
        sections.forEach(function (s) { var r = visible[s.id] || 0; if (r >= bestRatio) { bestRatio = r; bestId = s.id; } });
        links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-mvpol-link') === bestId); });
      }, { rootMargin: '-20% 0px -65% 0px', threshold: [0, 0.25, 0.5, 1] });
      sections.forEach(function (s) { io.observe(s); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["price-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-pg]');
    if (!root) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = root.querySelectorAll('.pg__reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"]) return;
  try {
    
  (function () {
    var KEY = 'mv-promo-banner';

    function start() {
      var root = document.querySelector('[data-promo-banner]');
      if (!root) return;

      // The merchant would otherwise be shown this every time they touch a
      // setting in the theme editor.
      if (window.Shopify && window.Shopify.designMode) return;

      // Private browsing and some iOS settings throw on access rather than
      // returning null, so every read and write is guarded. A blocked store
      // means the banner shows each visit — annoying beats broken.
      function seen() {
        try { return window.localStorage.getItem(KEY); } catch (e) { return null; }
      }
      function remember(v) {
        try { window.localStorage.setItem(KEY, v); } catch (e) { /* nothing to do */ }
      }

      // A returning sign-up still needs the banner, to be handed the code again.
      if (seen() && !/[?&]pb_code=1(&|$)/.test(window.location.search)) return;

      var panel = root.querySelector('[data-pb-panel]');
      var form = root.querySelector('form');
      var input = root.querySelector('#pb-email');
      var askEl = root.querySelector('[data-pb-ask]');
      var revealedEl = root.querySelector('[data-pb-revealed]');
      var codeEl = root.querySelector('[data-pb-code]');
      var lastFocused = null;

      function open() {
        lastFocused = document.activeElement;
        root.hidden = false;
        // Two frames: one for the element to exist un-hidden, one for the
        // transition to have a start value to move from.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { root.classList.add('is-open'); });
        });
        document.body.style.overflow = 'hidden';
        if (panel) panel.focus();
      }

      function close(reason) {
        root.classList.remove('is-open');
        document.body.style.overflow = '';
        window.setTimeout(function () { root.hidden = true; }, 320);
        remember(reason || 'dismissed');
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }

      root.querySelectorAll('[data-pb-close]').forEach(function (b) {
        b.addEventListener('click', function () { close('dismissed'); });
      });

      var backdrop = root.querySelector('[data-pb-backdrop]');
      if (backdrop) backdrop.addEventListener('click', function () { close('dismissed'); });

      document.addEventListener('keydown', function (e) {
        if (root.hidden) return;
        if (e.key === 'Escape') { close('dismissed'); return; }
        if (e.key !== 'Tab' || !panel) return;
        // Keep tabbing inside the dialog while it is open.
        var f = panel.querySelectorAll('button, input, a[href]');
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      function reveal() {
        var code = '';
        try { code = window.atob(root.getAttribute('data-code') || ''); } catch (e) { code = ''; }
        if (codeEl) codeEl.textContent = code;
        if (askEl) askEl.hidden = true;
        if (revealedEl) revealedEl.hidden = false;
        remember('subscribed');
      }

      var copyBtn = root.querySelector('[data-pb-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var text = codeEl ? codeEl.textContent : '';
          if (!navigator.clipboard) return;
          navigator.clipboard.writeText(text).then(function () {
            copyBtn.textContent = 'Copied';
            window.setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1600);
          });
        });
      }

      // No submit handler. Shopify's captcha script owns this form's submit; a
      // preventDefault here is what broke it. The page posts, Shopify challenges,
      // and return_to brings the customer back with ?pb_code=1.

      // Back from a successful sign-up: show the code at once, no delay, and
      // tidy the flag out of the address bar so a refresh does not re-trigger it.
      if (/[?&]pb_code=1(&|$)/.test(window.location.search)) {
        // The form's action carries #contact_form, so the browser lands part-way
        // down the page. Put them back at the top, where they were.
        window.scrollTo(0, 0);
        reveal();
        open();
        if (window.history.replaceState) {
          var clean = window.location.pathname +
            window.location.search.replace(/([?&])pb_code=1(&|$)/, '$1').replace(/[?&]$/, '');
          window.history.replaceState({}, '', clean);
        }
        return;
      }

      var delay = parseFloat(root.getAttribute('data-delay'));
      if (isNaN(delay)) delay = 20;
      window.setTimeout(open, delay * 1000);
    }

    // Waiting for `load` rather than firing a bare timer from parse: at ~1.5s the
    // banner can otherwise land before the hero image has painted, which reads
    // as breakage rather than as an offer.
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ring-size-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-rs]');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Size converter (reads data from the chart table) */
    var conv = root.querySelector('[data-rs-conv]');
    var chart = root.querySelector('[data-rs-chart]');
    if (conv && chart) {
      var data = [].map.call(chart.querySelectorAll('tbody tr'), function (tr) {
        return { us: tr.dataset.us, uk: tr.dataset.uk, eu: tr.dataset.eu, jp: tr.dataset.jp, mm: tr.dataset.mm, dia: tr.dataset.dia };
      });
      var regionSel = conv.querySelector('[data-rs-region]');
      var sizeSel = conv.querySelector('[data-rs-size]');
      var outs = {};
      conv.querySelectorAll('[data-out]').forEach(function (el) { outs[el.getAttribute('data-out')] = el; });

      function fillSizes() {
        var region = regionSel.value;
        sizeSel.innerHTML = '';
        data.forEach(function (row, i) {
          var o = document.createElement('option');
          o.value = i; o.textContent = row[region] || '—';
          sizeSel.appendChild(o);
        });
      }
      function show() {
        var row = data[+sizeSel.value];
        if (!row) return;
        outs.us.textContent = row.us;
        outs.uk.textContent = row.uk;
        outs.eu.textContent = row.eu;
        outs.jp.textContent = row.jp;
        outs.mm.textContent = row.mm + ' mm';
        outs.dia.textContent = row.dia + ' mm';
      }
      regionSel.addEventListener('change', function () { fillSizes(); selectDefault(); show(); });
      sizeSel.addEventListener('change', show);
      function selectDefault() {
        // default to US 6 when region is US, else first
        if (regionSel.value === 'us') {
          var idx = data.findIndex(function (r) { return r.us === '6'; });
          sizeSel.value = idx > -1 ? idx : 0;
        } else { sizeSel.value = 0; }
      }
      fillSizes(); selectDefault(); show();
    }

    /* Reveal */
    var items = root.querySelectorAll('.rs__reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
      items.forEach(function (el) { io.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["settings-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-settings-grid]');
    if (!root) return;

    // Mobile image-swipe dots: light up the dot for the visible slide.
    root.querySelectorAll('[data-sg-card]').forEach(function (card) {
      var media = card.querySelector('.sg-card__media');
      var dots = card.querySelectorAll('.sg-card__dots i');
      if (!media || dots.length < 2) return;
      media.addEventListener('scroll', function () {
        var i = Math.round(media.scrollLeft / Math.max(1, media.clientWidth));
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }, { passive: true });
    });

    // Metal swatch -> swap the card's main (+ hover) photo to that metal's render.
    root.querySelectorAll('.sg__item').forEach(function (item) {
      var mainImg = item.querySelector('[data-sg-main]');
      var hoverImg = item.querySelector('[data-sg-hover-img]');
      var swatches = Array.prototype.slice.call(item.querySelectorAll('.sg-card__swatch'));
      if (!mainImg || !swatches.length) return;
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          var front = sw.getAttribute('data-sg-img');
          if (!front) return;
          mainImg.setAttribute('src', front);
          var side = sw.getAttribute('data-sg-hover');
          if (hoverImg && side) hoverImg.setAttribute('src', side);
          swatches.forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
        });
      });
    });

    // Pre-select a metal from the URL (Engagement Rings mega "Metal" -> shop by metal).
    var sgMetal = (new URLSearchParams(window.location.search).get('metal') || '').toLowerCase();
    if (sgMetal) {
      root.querySelectorAll('.sg__item').forEach(function (item) {
        var sw = item.querySelector('.sg-card__swatch--' + sgMetal);
        if (sw) sw.click();
      });
    }

    // ---- Style category bar + Filters drawer + Sort (client-side) ----
    (function () {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-sg-item]'));
      if (!items.length) return;
      items.forEach(function (it, i) {
        it.__order = i;
        it.__rep = it.getAttribute('data-rep-shape') || 'oval';
        var s = it.querySelector('.sg-card__imgs');
        try { it.__imgs = s ? JSON.parse(s.textContent) : {}; } catch (e) { it.__imgs = {}; }
        it.__mainImg = it.querySelector('[data-sg-main]');
        it.__hoverImg = it.querySelector('[data-sg-hover-img]');
        it.__defF = it.__mainImg ? it.__mainImg.getAttribute('src') : '';
        it.__defS = it.__hoverImg ? it.__hoverImg.getAttribute('src') : '';
      });
      var list = root.querySelector('[data-sg-list]');
      var countEls = Array.prototype.slice.call(root.querySelectorAll('[data-sg-count]'));
      var catEls = Array.prototype.slice.call(root.querySelectorAll('[data-cat]'));
      var metalEls = Array.prototype.slice.call(root.querySelectorAll('[data-facet="metal"]'));
      var shapeEls = Array.prototype.slice.call(root.querySelectorAll('[data-facet="shape"]'));
      var priceMinEl = root.querySelector('[data-price-min]');
      var priceMaxEl = root.querySelector('[data-price-max]');
      var sortSel = root.querySelector('[data-sg-sort]');
      var drawer = root.querySelector('[data-sg-drawer]');
      var activeCats = [], activeMetals = [], activeShapes = [];
      var activeWrap = root.querySelector('[data-sg-active]');

      function tokens(v) { return (v || '').split(/\s+/).filter(Boolean); }

      function matches(it) {
        if (activeCats.length) {
          var styles = tokens(it.getAttribute('data-style'));
          if (!activeCats.some(function (c) { return styles.indexOf(c) !== -1; })) return false;
        }
        if (activeShapes.length) {
          var shapes = tokens(it.getAttribute('data-shapes'));
          if (!activeShapes.some(function (c) { return shapes.indexOf(c) !== -1; })) return false;
        }
        if (activeMetals.length) {
          var metals = tokens(it.getAttribute('data-metals'));
          if (!activeMetals.some(function (c) { return metals.indexOf(c) !== -1; })) return false;
        }
        var pr = parseInt(it.getAttribute('data-price'), 10) || 0;
        var mn = parseFloat(priceMinEl && priceMinEl.value) || 0;
        var mx = parseFloat(priceMaxEl && priceMaxEl.value);
        if (mn > 0 && pr < mn * 100) return false;
        if (!isNaN(mx) && mx > 0 && pr > mx * 100) return false;
        return true;
      }

      function sortNow() {
        if (!list) return;
        var mode = sortSel ? sortSel.value : 'featured';
        items.filter(function (it) { return !it.hidden; }).sort(function (a, b) {
          if (mode === 'price-asc') return (parseInt(a.getAttribute('data-price'), 10) || 0) - (parseInt(b.getAttribute('data-price'), 10) || 0);
          if (mode === 'price-desc') return (parseInt(b.getAttribute('data-price'), 10) || 0) - (parseInt(a.getAttribute('data-price'), 10) || 0);
          if (mode === 'name') return (a.getAttribute('data-name') || '').localeCompare(b.getAttribute('data-name') || '');
          // "Best sellers" = tagged products first, then original order within each group.
          var ab = (a.getAttribute('data-style') || '').indexOf('best-seller') >= 0 ? 0 : 1;
          var bb = (b.getAttribute('data-style') || '').indexOf('best-seller') >= 0 ? 0 : 1;
          if (ab !== bb) return ab - bb;
          return a.__order - b.__order;
        }).forEach(function (it) { list.appendChild(it); });
      }

      // Swap each visible card's photo to the selected shape/metal (revert to oval/yellow when cleared).
      function applyDisplay() {
        var ds = activeShapes.length ? activeShapes[activeShapes.length - 1] : null;
        var dm = activeMetals.length ? activeMetals[activeMetals.length - 1] : null;
        items.forEach(function (it) {
          if (it.hidden || !it.__mainImg) return;
          var shape = ds || it.__rep;
          var metal = dm || 'yellow';
          var mkey = (metal === 'platinum') ? 'white' : metal;
          var f = it.__imgs[mkey + '-' + shape + '-f'] || it.__imgs['yellow-' + shape + '-f'] || it.__defF;
          var s = it.__imgs[mkey + '-' + shape + '-s'] || it.__imgs['yellow-' + shape + '-s'] || '';
          it.__mainImg.setAttribute('src', f);
          if (it.__hoverImg) it.__hoverImg.setAttribute('src', s || f);
          Array.prototype.forEach.call(it.querySelectorAll('.sg-card__swatch'), function (sw) {
            sw.classList.toggle('is-active', sw.classList.contains('sg-card__swatch--' + metal));
          });
        });
      }

      function apply() {
        var shown = 0;
        items.forEach(function (it) { var ok = matches(it); it.hidden = !ok; if (ok) shown++; });
        countEls.forEach(function (el) { el.textContent = shown; });
        sortNow();
        applyDisplay();
        renderChips();
      }

      function labelFor(type, value) {
        var sel;
        if (type === 'cat') sel = root.querySelector('.sg-cat[data-cat="' + value + '"] .sg-cat__label') || root.querySelector('.sg-tile[data-cat="' + value + '"] .sg-tile__label');
        else if (type === 'shape') sel = root.querySelector('.sg-stile[data-value="' + value + '"] .sg-tile__label');
        else if (type === 'metal') sel = root.querySelector('.sg-mtile[data-value="' + value + '"] .sg-tile__label');
        return sel ? sel.textContent.trim() : value;
      }
      function deselect(type, value) {
        var i;
        if (type === 'cat') { i = activeCats.indexOf(value); if (i > -1) activeCats.splice(i, 1); root.querySelectorAll('[data-cat="' + value + '"]').forEach(function (e) { e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); }); }
        else if (type === 'shape') { i = activeShapes.indexOf(value); if (i > -1) activeShapes.splice(i, 1); root.querySelectorAll('[data-facet="shape"][data-value="' + value + '"]').forEach(function (e) { e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); }); }
        else if (type === 'metal') { i = activeMetals.indexOf(value); if (i > -1) activeMetals.splice(i, 1); root.querySelectorAll('[data-facet="metal"][data-value="' + value + '"]').forEach(function (e) { e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); }); }
        else if (type === 'pmin') { if (priceMinEl) priceMinEl.value = ''; }
        else if (type === 'pmax') { if (priceMaxEl) priceMaxEl.value = ''; }
        apply();
      }
      function clearAll() {
        activeCats.length = 0; activeMetals.length = 0; activeShapes.length = 0;
        root.querySelectorAll('[data-cat].is-active, [data-facet].is-active').forEach(function (e) { e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); });
        if (priceMinEl) priceMinEl.value = '';
        if (priceMaxEl) priceMaxEl.value = '';
        apply();
      }
      function renderChips() {
        if (!activeWrap) return;
        var chips = [];
        activeCats.forEach(function (v) { chips.push(['cat', v, labelFor('cat', v)]); });
        activeShapes.forEach(function (v) { chips.push(['shape', v, labelFor('shape', v)]); });
        activeMetals.forEach(function (v) { chips.push(['metal', v, labelFor('metal', v)]); });
        if (priceMinEl && priceMinEl.value) chips.push(['pmin', '', 'Min $' + priceMinEl.value]);
        if (priceMaxEl && priceMaxEl.value) chips.push(['pmax', '', 'Max $' + priceMaxEl.value]);
        activeWrap.innerHTML = '';
        if (!chips.length) { activeWrap.hidden = true; return; }
        activeWrap.hidden = false;
        chips.forEach(function (c) {
          var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sg-chip'; btn.setAttribute('aria-label', 'Remove ' + c[2]);
          btn.appendChild(document.createTextNode(c[2] + ' '));
          var x = document.createElement('span'); x.className = 'sg-chip__x'; x.setAttribute('aria-hidden', 'true'); x.textContent = '×';
          btn.appendChild(x);
          btn.addEventListener('click', function () { deselect(c[0], c[1]); });
          activeWrap.appendChild(btn);
        });
        var clr = document.createElement('button'); clr.type = 'button'; clr.className = 'sg-chip sg-chip--clear'; clr.textContent = 'Clear all';
        clr.addEventListener('click', clearAll);
        activeWrap.appendChild(clr);
      }

      // Setting style: the top bar chips and drawer tiles share data-cat, so toggle both.
      function toggleCat(cat) {
        var i = activeCats.indexOf(cat);
        if (i === -1) activeCats.push(cat); else activeCats.splice(i, 1);
        var on = activeCats.indexOf(cat) !== -1;
        root.querySelectorAll('[data-cat="' + cat + '"]').forEach(function (e) { e.classList.toggle('is-active', on); e.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        apply();
      }
      catEls.forEach(function (e) { e.addEventListener('click', function () { toggleCat(e.getAttribute('data-cat')); }); });
      function bindFacet(els, arr) {
        els.forEach(function (e) {
          e.addEventListener('click', function () {
            var v = e.getAttribute('data-value'), i = arr.indexOf(v);
            if (i === -1) { arr.push(v); e.classList.add('is-active'); e.setAttribute('aria-pressed', 'true'); }
            else { arr.splice(i, 1); e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); }
            apply();
          });
        });
      }
      bindFacet(metalEls, activeMetals);
      bindFacet(shapeEls, activeShapes);
      if (priceMinEl) priceMinEl.addEventListener('input', apply);
      if (priceMaxEl) priceMaxEl.addEventListener('input', apply);
      if (sortSel) sortSel.addEventListener('change', sortNow);

      var openBtn = root.querySelector('[data-sg-open]');
      function closeDrawer() { if (drawer) { drawer.hidden = true; document.body.style.overflow = ''; } }
      if (openBtn && drawer) {
        openBtn.addEventListener('click', function () { drawer.hidden = false; document.body.style.overflow = 'hidden'; });
        root.querySelectorAll('[data-sg-close]').forEach(function (c) { c.addEventListener('click', closeDrawer); });
      }
      var clearBtn = root.querySelector('[data-sg-clear]');
      if (clearBtn) clearBtn.addEventListener('click', clearAll);

      // Pre-select a style category from the URL (Engagement Rings mega "Styles").
      var sgCat = (new URLSearchParams(window.location.search).get('cat') || '').toLowerCase();
      if (sgCat) {
        var catBtn = root.querySelector('.sg-cat[data-cat="' + sgCat + '"]');
        if (catBtn) catBtn.click();
      }

      // Pre-apply a shape from the URL (Engagement Rings mega "Shop by shape").
      // Without this the shape links had to target a single product instead of
      // this gallery, which dropped the customer onto an arbitrary setting.
      var sgShape = (new URLSearchParams(window.location.search).get('shape') || '').toLowerCase();
      if (sgShape) {
        var shapeBtn = root.querySelector('[data-facet="shape"][data-value="' + sgShape + '"]');
        if (shapeBtn) shapeBtn.click();
      }

      // Pre-apply a metal from the URL (Engagement Rings mega "Shop by metal").
      // The per-card swatch click further down only re-images each card; without
      // this the grid still listed settings that are not offered in that metal.
      var sgMetalFacet = (new URLSearchParams(window.location.search).get('metal') || '').toLowerCase();
      if (sgMetalFacet) {
        var metalBtn = root.querySelector('[data-facet="metal"][data-value="' + sgMetalFacet + '"]');
        if (metalBtn) metalBtn.click();
      }

      apply();
    })();

    // Carry a shape chosen upstream (Engagement Rings mega "Shop by shape") onto
    // each setting card, so the setting page knows the shape and can show it as
    // locked instead of offering every shape again.
    //
    // NOT in diamond-first: there the chosen diamond owns the shape and the block
    // below appends dshape. Sending both produced a conflicting shape/dshape pair
    // that bounced the setting page back to the diamond grid on load.
    (function () {
      var sp = new URLSearchParams(window.location.search);
      if (sp.get('flow') === 'diamond' && sp.get('diamond')) return;
      var carry = (sp.get('shape') || '').toLowerCase();
      if (!carry) return;
      root.querySelectorAll('[data-sg-card]').forEach(function (a) {
        var base = a.getAttribute('data-url') || a.getAttribute('href') || '';
        if (!base) return;
        a.href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'shape=' + encodeURIComponent(carry);
      });
    })();

    var bp = new URLSearchParams(window.location.search);
    if (bp.get('flow') !== 'diamond' || !bp.get('diamond')) return; // normal grid

    var diamond = bp.get('diamond');
    var dimg = bp.get('dimg') || '';
    var dshape = bp.get('dshape') || '';
    var diamondUrl = '/products/' + encodeURIComponent(diamond);

    root.classList.add('is-builder');
    var steps = root.querySelector('[data-sg-steps]'); if (steps) steps.hidden = false;
    var ctx = root.querySelector('[data-sg-context]'); if (ctx) ctx.hidden = false;

    // Step 1 (diamond grid) back-link + "change diamond"
    var gridUrl = '/collections/loose-diamonds?flow=diamond';
    var step1 = root.querySelector('[data-cfg-step="1"]'); if (step1) step1.href = gridUrl;
    var change = root.querySelector('[data-sg-dia-change]'); if (change) change.href = gridUrl;

    // Each setting card carries the flow + chosen diamond to the setting page
    root.querySelectorAll('[data-sg-card]').forEach(function (a) {
      var base = a.getAttribute('data-url') || a.getAttribute('href');
      var sep = base.indexOf('?') === -1 ? '?' : '&';
      a.href = base + sep + 'flow=diamond&diamond=' + encodeURIComponent(diamond) +
        '&dimg=' + encodeURIComponent(dimg) +
        '&dshape=' + encodeURIComponent(dshape);
    });

    // Fill the "your diamond" context from the chosen diamond
    function parseDiamond(t) {
      t = String(t || ''); var d = { carat: '', shape: '', color: '', clarity: '' };
      var m = t.match(/([\d.]+)\s*ct/i); if (m) d.carat = m[1];
      m = t.match(/ct\s+([A-Za-z]+)\s+Lab/i); if (m) d.shape = m[1];
      m = t.match(/[—\-]\s*([A-Z]+)\s+(\S+)/); if (m) { d.color = m[1]; d.clarity = m[2]; }
      return d;
    }
    var thumb = root.querySelector('[data-sg-dia-thumb]');
    if (thumb && dimg) { thumb.src = dimg; }
    fetch(diamondUrl + '.js', { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var d = parseDiamond(p.title);
        var nameEl = root.querySelector('[data-sg-dia-name]');
        if (nameEl) nameEl.textContent = [d.carat ? d.carat + 'ct' : '', d.shape, d.color, d.clarity].filter(Boolean).join(' ') || p.title;
        var v = (p.variants && p.variants[0]) || null;
        var priceEl = root.querySelector('[data-sg-dia-price]');
        if (priceEl && v) priceEl.textContent = '$' + (v.price / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' (diamond only)';
        if (thumb && !dimg && p.featured_image) thumb.src = p.featured_image;
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sustainability"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-su]');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = root.querySelectorAll('.su__reveal');
    if (reduce || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tulip-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-tg]');
    if (!root) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = root.querySelectorAll('.tg__reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-wr]');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var items = root.querySelectorAll('.wr__reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
      items.forEach(function (el) { io.observe(el); });
    }

    var nav = root.querySelector('[data-wr-nav]');
    if (nav && 'IntersectionObserver' in window) {
      var links = nav.querySelectorAll('a');
      var ids = ['coverage', 'repair', 'rule', 'evaluate'];
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-nav') === en.target.id); }); } });
      }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
      ids.forEach(function (id) { var s = document.getElementById(id); if (s) spy.observe(s); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wedding-band-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-wbp]');
    if (!root) return;

    var variants = [];
    try { variants = JSON.parse(root.getAttribute('data-variants') || '[]'); } catch (e) {}
    var imageData = {};
    try { imageData = JSON.parse(root.getAttribute('data-images') || '{}'); } catch (e) {}

    var priceEl = root.querySelector('[data-wbp-price]');
    var idInput = root.querySelector('[data-wbp-id]');
    var metalLabel = root.querySelector('[data-wbp-metal-label]');
    var caratLabel = root.querySelector('[data-wbp-carat-label]');
    var addBtn = root.querySelector('.wbp__add');

    var state = { metal: '', carat: '' };
    var am = root.querySelector('.wbp-metal.is-active');
    var ac = root.querySelector('.wbp-carat.is-active');
    if (am) state.metal = am.getAttribute('data-wbp-metal');
    if (ac) state.carat = ac.getAttribute('data-wbp-carat');

    function metalSlug(metal) {
      metal = (metal || '').toLowerCase();
      if (metal.indexOf('rose') !== -1) return 'rose';
      if (metal.indexOf('white') !== -1) return 'white';
      return 'yellow';
    }

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].metal === state.metal && variants[i].carat === state.carat) return variants[i];
      }
      return null;
    }

    // A slot shows its photo, or falls back to the dashed placeholder. Never
    // leave an <img> with an empty src, which paints a broken frame.
    function setSlot(img, url) {
      if (!img) return;
      var cell = img.closest('.wbp__cell');
      var ph = cell ? cell.querySelector('.wbp__cell-ph') : null;
      if (url) {
        img.src = url; img.hidden = false;
        if (cell) cell.classList.remove('wbp__cell--empty');
        if (ph) ph.hidden = true;
      } else {
        img.hidden = true; img.removeAttribute('src');
        if (cell) cell.classList.add('wbp__cell--empty');
        if (ph) ph.hidden = false;
      }
    }

    var kyb = root.querySelector('.wbp__kyb');

    // Alloy donut + key are rebuilt together so their indices always line up.
    // Alloy table: one line per metal, "Metal | share comp, share comp | caption".
    // Keyed on the exact option value so 14k and 18k never collide.
    var alloyTable = '';
    try { alloyTable = JSON.parse(root.getAttribute('data-alloys') || '""'); } catch (e) {}

    function alloyFor(metal) {
      var lines = String(alloyTable).split('\n');
      for (var i = 0; i < lines.length; i++) {
        var cols = lines[i].split('|');
        if (cols[0] && cols[0].trim() === metal) {
          var parts = (cols[1] || '').split(',').map(function (r) {
            r = r.trim();
            var sp = r.indexOf(' ');
            if (sp === -1) return null;
            var share = r.slice(0, sp), comp = r.slice(sp + 1).trim();
            return { share: share, comp: comp, num: parseFloat(share) || 0,
                     slug: comp.toLowerCase().replace(/[^a-z0-9]+/g, '-') };
          }).filter(Boolean);
          return { parts: parts, caption: (cols[2] || '').trim() };
        }
      }
      return { parts: [], caption: '' };
    }

    function applyAlloy() {
      var slug = metalSlug(state.metal);
      var donut = root.querySelector('[data-wbp-donut]');
      var key = root.querySelector('[data-wbp-alloy-key]');
      if (!donut || !key) return;
      var data = alloyFor(state.metal);
      var parts = data.parts;
      var capEl = root.querySelector('[data-wbp-alloy-caption]');
      if (capEl) { capEl.textContent = data.caption; capEl.hidden = !data.caption; }
      var C = 251.33, run = 0, segHtml = '', keyHtml = '';
      for (var i = 0; i < parts.length; i++) {
        var pt = parts[i];
        var seg = pt.num * (C / 100);
        var dash = ' stroke-dasharray="' + seg.toFixed(2) + ' ' + (C - seg).toFixed(2) + '"' +
                   ' stroke-dashoffset="' + (-run).toFixed(2) + '"';
        segHtml += '<circle class="wbp__donut-seg wbp__alloy-seg--' + pt.slug + '" cx="50" cy="50" r="40"' + dash + ' data-wbp-segview="' + i + '"></circle>' +
                   '<circle class="wbp__donut-hit" cx="50" cy="50" r="40"' + dash + ' data-wbp-seg="' + i + '">' +
                   '<title>' + pt.comp + ' ' + pt.share + '</title></circle>';
        keyHtml += '<li class="wbp__alloy-item" data-wbp-key="' + i + '">' +
                   '<span class="wbp__alloy-dot wbp__alloy-seg--' + pt.slug + '" aria-hidden="true"></span>' +
                   '<strong class="wbp__alloy-share">' + pt.share + '</strong>' +
                   '<span class="wbp__alloy-comp">' + pt.comp + '</span></li>';
        run += seg;
      }
      donut.innerHTML = '<circle class="wbp__donut-track" cx="50" cy="50" r="40" />' + segHtml;
      key.innerHTML = keyHtml;
    }

    // Hovering a ribbon segment or a key row isolates that component in both.
    var alloyWrap = root.querySelector('.wbp__kyb-metal');
    if (alloyWrap) {
      function probe(idx) {
        var on = idx !== null;
        alloyWrap.classList.toggle('is-probing', on);
        alloyWrap.querySelectorAll('[data-wbp-seg], [data-wbp-segview], [data-wbp-key]').forEach(function (el) {
          var i = el.getAttribute('data-wbp-seg') || el.getAttribute('data-wbp-segview') || el.getAttribute('data-wbp-key');
          el.classList.toggle('is-hot', on && String(idx) === i);
        });
      }
      alloyWrap.addEventListener('pointerover', function (e) {
        var el = e.target.closest('[data-wbp-seg], [data-wbp-key]');
        probe(el ? (el.getAttribute('data-wbp-seg') || el.getAttribute('data-wbp-key')) : null);
      });
      alloyWrap.addEventListener('pointerleave', function () { probe(null); });
    }

    // Photos are keyed "<metal>~<weight>". Same fallback chain as the Liquid:
    // this metal at this weight, this metal's shared set, yellow at this weight,
    // then anything the product has.
    function urlsFor(metalSlugName, carat) {
      var out = [];
      var entries = String(imageData.map || '').split('|');
      for (var i = 0; i < entries.length; i++) {
        var b = entries[i].split('~');
        if (b.length < 3) continue;
        if (b[0] === metalSlugName && b[1] === carat) out.push(b[2]);
      }
      return out;
    }

    function applyImages() {
      var slug = metalSlug(state.metal);
      var urls = urlsFor(slug, state.carat);
      if (!urls.length) urls = urlsFor(slug, 'all');
      if (!urls.length) urls = urlsFor('yellow', state.carat);
      if (!urls.length) urls = String(imageData.all || '').split('|').filter(Boolean);
      var cells = root.querySelectorAll('[data-wbp-slot]');
      var none = urls.length === 0;
      for (var i = 0; i < cells.length; i++) {
        var cell = cells[i].closest('.wbp__cell');
        // No photography at all -> keep the dashed placeholders. Otherwise a cell
        // with nothing to show is removed from the grid entirely.
        if (cell) cell.classList.toggle('wbp__cell--hidden', !none && !urls[i]);
        setSlot(cells[i], urls[i] || '');
      }
      if (typeof buildDots === 'function') buildDots();
    }

    function update() {
      var v = findVariant();
      if (v) {
        if (priceEl) priceEl.textContent = v.price;
        if (idInput) idInput.value = v.id;
        if (addBtn) addBtn.disabled = !v.available;
      }
      // Unit first: both the inline value and the spec card below need it.
      var unitTxt = root.getAttribute('data-axis-unit') || '';
      var caratWithUnit = state.carat + (unitTxt ? ' ' + unitTxt : '');
      var alloyName = root.querySelector('[data-wbp-alloy-name]');
      if (metalLabel) metalLabel.textContent = state.metal;
      if (caratLabel) caratLabel.textContent = caratWithUnit;
      var widthEl = root.querySelector('[data-wbp-width]');
      if (widthEl) {
        var wraw = root.getAttribute('data-widths') || '';
        if (wraw.indexOf('|') !== -1) {
          var wl = wraw.split('\n');
          for (var wi = 0; wi < wl.length; wi++) {
            var wc = wl[wi].split('|');
            if (wc[0] && wc[0].trim() === state.carat) { widthEl.textContent = (wc[1] || '').trim(); break; }
          }
        }
      }
      var skuEl = root.querySelector('[data-wbp-sku]');
      if (skuEl && v && v.sku) skuEl.textContent = v.sku;

      var tcwEl = root.querySelector('[data-wbp-tcw]');
      if (tcwEl) {
        var n = parseFloat(state.carat);
        tcwEl.textContent = (isNaN(n) ? state.carat : n.toFixed(1)) + ' ct';
      }
      // mm-sized bands: the width card follows the selected option directly.
      var mmEl = root.querySelector('[data-wbp-mmwidth]');
      if (mmEl) mmEl.textContent = state.carat + ' mm';

      // Total carat weight varies by width on a stone-set mm band. Widths with no
      // trustworthy figure are absent from the map: show Profile there instead of
      // an empty card, so the row keeps two cards either way.
      var ctwCard = root.querySelector('[data-wbp-ctw-card]');
      if (ctwCard) {
        var found = '';
        (root.getAttribute('data-ctws') || '').split('\n').forEach(function (line) {
          var c = line.split('|');
          if (c[0] && c[0].trim() === state.carat) found = (c[1] || '').trim();
        });
        var ctwVal = root.querySelector('[data-wbp-mmctw]');
        if (ctwVal) ctwVal.textContent = found;
        ctwCard.hidden = !found;
        var profCard = root.querySelector('[data-wbp-profile-card]');
        if (profCard) profCard.hidden = !!found;
      }
      if (alloyName) alloyName.textContent = state.metal;
      applyAlloy();
      applyImages();
      buildDots();
    }

    root.querySelectorAll('.wbp-metal').forEach(function (b) {
      b.addEventListener('click', function () {
        state.metal = b.getAttribute('data-wbp-metal');
        root.querySelectorAll('.wbp-metal').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-active'); b.setAttribute('aria-checked', 'true');
        update();
      });
    });
    root.querySelectorAll('.wbp-carat').forEach(function (b) {
      b.addEventListener('click', function () {
        state.carat = b.getAttribute('data-wbp-carat');
        root.querySelectorAll('.wbp-carat').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-active'); b.setAttribute('aria-checked', 'true');
        update();
      });
    });

    // Ring size: quarter sizes 3 to 11, same list the ring builder offers.
    // The select carries name="properties[Ring size]" and its option values are
    // the finished label ("US 7"), so the property submits with the form and no
    // mirror input is needed.
    var sizeSel = root.querySelector('[data-wbp-size]');
    if (sizeSel) {
      var quarters = ['', '\u00bc', '\u00bd', '\u00be'];
      for (var q = 12; q <= 44; q += 1) {
        var label = String(Math.floor(q / 4)) + quarters[q % 4];
        var opt = document.createElement('option');
        opt.value = 'US ' + label; opt.textContent = 'US ' + label;
        sizeSel.appendChild(opt);
      }
      var sizeErr = root.querySelector('[data-wbp-size-err]');
      var rsWrap = root.querySelector('[data-wbp-rs]');
      var rsBtn = root.querySelector('[data-wbp-rs-btn]');
      function showSizeError(on) {
        if (sizeErr) sizeErr.hidden = !on;
        sizeSel.setAttribute('aria-invalid', on ? 'true' : 'false');
        if (rsWrap) rsWrap.classList.toggle('is-invalid', !!on);
      }

      sizeSel.addEventListener('change', function () {
        if (sizeSel.value) showSizeError(false);
      });

      // Custom face for the select. The select above stays the source of truth,
      // so the form still submits properties[Ring size] exactly as before.
      (function () {
        var pop = root.querySelector('[data-wbp-rs-pop]');
        var list = root.querySelector('[data-wbp-rs-list]');
        var val = root.querySelector('[data-wbp-rs-val]');
        if (!rsWrap || !rsBtn || !pop || !list || !val) return;

        var items = [];
        for (var i = 0; i < sizeSel.options.length; i++) {
          var o = sizeSel.options[i];
          if (!o.value) continue;
          var li = document.createElement('li');
          li.setAttribute('role', 'option');
          li.setAttribute('data-val', o.value);
          li.textContent = o.textContent;
          list.appendChild(li);
          items.push(li);
        }

        var focusIdx = -1;
        function paint() {
          for (var i = 0; i < items.length; i++) {
            var on = items[i].getAttribute('data-val') === sizeSel.value;
            items[i].classList.toggle('is-sel', on);
            items[i].setAttribute('aria-selected', on ? 'true' : 'false');
            items[i].classList.toggle('is-focus', i === focusIdx);
          }
          val.textContent = sizeSel.value || 'Select your size';
          rsWrap.classList.toggle('is-set', !!sizeSel.value);
        }
        function open() {
          pop.hidden = false;
          rsBtn.setAttribute('aria-expanded', 'true');
          var sel = list.querySelector('.is-sel');
          focusIdx = sel ? items.indexOf(sel) : -1;
          paint();
          if (sel) sel.scrollIntoView({ block: 'nearest' });
        }
        function close() { pop.hidden = true; rsBtn.setAttribute('aria-expanded', 'false'); focusIdx = -1; paint(); }
        function choose(v) {
          sizeSel.value = v;
          sizeSel.dispatchEvent(new Event('change', { bubbles: true }));
          close();
          rsBtn.focus();
        }

        rsBtn.addEventListener('click', function () { if (pop.hidden) open(); else close(); });
        list.addEventListener('click', function (e) {
          var li = e.target.closest('li[data-val]');
          if (li) choose(li.getAttribute('data-val'));
        });
        document.addEventListener('click', function (e) {
          if (!pop.hidden && !rsWrap.contains(e.target)) close();
        });
        rsWrap.addEventListener('keydown', function (e) {
          if (pop.hidden) {
            if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
            return;
          }
          var step = { ArrowDown: 1, ArrowUp: -1 }[e.key];
          if (step) {
            e.preventDefault();
            focusIdx = Math.max(0, Math.min(items.length - 1, (focusIdx < 0 ? 0 : focusIdx + step)));
            paint();
            items[focusIdx].scrollIntoView({ block: 'nearest' });
          } else if (e.key === 'Enter' && focusIdx > -1) {
            e.preventDefault(); choose(items[focusIdx].getAttribute('data-val'));
          } else if (e.key === 'Escape') { e.preventDefault(); close(); rsBtn.focus(); }
        });
        sizeSel.addEventListener('change', paint);
        paint();
      })();

      // Every band is made to order, so an order without a size cannot be filled.
      // The button stays enabled on purpose: a dead button explains nothing,
      // whereas this says what is missing and moves focus to it.
      function blockWithoutSize(e) {
        if (sizeSel.value) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        showSizeError(true);
        // The select is visually hidden now, so focus the visible trigger.
        (rsBtn || sizeSel).focus();
        (rsBtn || sizeSel).scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      var atcBtn = root.querySelector('[data-wbp-add]');
      var atcForm = root.querySelector('form[data-type="add-to-cart-form"]');
      if (atcForm) atcForm.addEventListener('submit', blockWithoutSize, true);

      // Add over AJAX so a failure can be reported in place, then go to the cart.
      // If this listener never runs the browser submits the form itself and the
      // return_to field lands on the same page, so the button always works.
      if (atcForm) {
        atcForm.addEventListener('submit', function (e) {
          if (!sizeSel.value) return;               // blockWithoutSize already stopped it
          e.preventDefault();
          if (atcBtn) { atcBtn.disabled = true; atcBtn.setAttribute('aria-busy', 'true'); }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(atcForm)
          })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
            // Literal path on purpose: Liquid is not rendered inside {% javascript %},
            // so routes.cart_url would arrive as the unexpanded tag. Same as the
            // ring builder does at the end of its add.
            .then(function () { window.location.href = '/cart'; })
            .catch(function () {
              if (atcBtn) { atcBtn.disabled = false; atcBtn.removeAttribute('aria-busy'); }
              var live = root.querySelector('[data-wbp-live]');
              if (live) live.textContent = 'Sorry, we could not add that to your cart. Please try again.';
              window.alert('Sorry, we couldn’t add that to your cart. Please try again.');
            });
        });

        // Coming back to this page from the cart restores it from the back-forward
        // cache exactly as it was left, which means the button is still disabled
        // from the add that took the customer away. Hand it back.
        window.addEventListener('pageshow', function (event) {
          if (!event.persisted || !atcBtn) return;
          atcBtn.disabled = false;
          atcBtn.removeAttribute('aria-busy');
        });
      }
    }

    root.querySelectorAll('.wbp__acc-head').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.wbp__acc-item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Mobile gallery swipe dots — rebuilt whenever metal/carat changes which images show.
    var galleryGrid = root.querySelector('.wbp__grid');
    var dotsWrap = root.querySelector('[data-wbp-dots]');
    function visibleCells() { return galleryGrid ? galleryGrid.querySelectorAll('.wbp__cell:not(.wbp__cell--hidden)') : []; }
    function updateDots() {
      if (!galleryGrid || !dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.wbp__dot'); if (!dots.length) return;
      var cells = visibleCells();
      var center = galleryGrid.scrollLeft + galleryGrid.clientWidth / 2;
      var active = 0, best = Infinity;
      for (var i = 0; i < cells.length; i++) { var c = cells[i], cc = c.offsetLeft + c.offsetWidth / 2, dd = Math.abs(cc - center); if (dd < best) { best = dd; active = i; } }
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === active);
    }
    function buildDots() {
      if (!galleryGrid || !dotsWrap) return;
      var cells = visibleCells();
      dotsWrap.innerHTML = '';
      if (cells.length < 2) return;
      for (var i = 0; i < cells.length; i++) {
        var dot = document.createElement('span'); dot.className = 'wbp__dot';
        (function (idx) { dot.addEventListener('click', function () { visibleCells()[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); }); })(i);
        dotsWrap.appendChild(dot);
      }
      updateDots();
    }
    if (galleryGrid) galleryGrid.addEventListener('scroll', function () { window.requestAnimationFrame(updateDots); }, { passive: true });

    // ---- Lightbox: open full-size (same page), zoom + prev/next + thumbnail filmstrip
    // (matches the setting details page). ----
    var lb = root.querySelector('[data-wbp-lightbox]');
    var lbImg = root.querySelector('[data-wbp-lb-img]');
    var lbPrev = root.querySelector('[data-wbp-lb-prev]');
    var lbNext = root.querySelector('[data-wbp-lb-next]');
    var lbThumbs = root.querySelector('[data-wbp-lb-thumbs]');
    var lbList = [], lbIndex = 0, lbScale = 1;
    function lbSetZoom(scale, ox, oy) {
      lbScale = Math.max(1, Math.min(scale, 3));
      if (!lbImg) return;
      lbImg.style.transformOrigin = (ox != null) ? (ox + '% ' + oy + '%') : 'center';
      lbImg.style.transform = 'scale(' + lbScale + ')';
      lbImg.classList.toggle('is-zoomed', lbScale > 1);
    }
    function lbShow(i) {
      if (!lbList.length) return;
      lbIndex = (i % lbList.length + lbList.length) % lbList.length;
      if (lbImg) lbImg.src = lbList[lbIndex];
      lbSetZoom(1);
      var multi = lbList.length > 1;
      if (lbPrev) lbPrev.hidden = !multi;
      if (lbNext) lbNext.hidden = !multi;
      if (lbThumbs) { var t = lbThumbs.querySelectorAll('.wbp__lb-thumb'); for (var j = 0; j < t.length; j++) t[j].classList.toggle('is-active', j === lbIndex); }
    }
    function lbBuildThumbs() {
      if (!lbThumbs) return;
      lbThumbs.innerHTML = '';
      if (lbList.length < 2) { lbThumbs.hidden = true; return; }
      lbThumbs.hidden = false;
      lbList.forEach(function (src, i) {
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'wbp__lb-thumb';
        var im = document.createElement('img'); im.src = src; im.alt = ''; btn.appendChild(im);
        btn.addEventListener('click', function (e) { e.stopPropagation(); lbShow(i); });
        lbThumbs.appendChild(btn);
      });
    }
    function lbOpen(src) {
      lbList = [];
      var cells = visibleCells();
      for (var i = 0; i < cells.length; i++) {
        var im = cells[i].querySelector('.wbp__cell-img');
        if (im && im.getAttribute('src')) lbList.push(im.getAttribute('src'));
      }
      lbBuildThumbs();
      var start = lbList.indexOf(src);
      lbShow(start < 0 ? 0 : start);
      if (lb) { lb.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    }
    function lbClose() { if (lb) { lb.hidden = true; document.documentElement.style.overflow = ''; lbSetZoom(1); } }
    if (galleryGrid) {
      galleryGrid.addEventListener('click', function (e) {
        var cell = e.target.closest('.wbp__cell');
        if (!cell || cell.classList.contains('wbp__cell--hidden')) return;
        var im = cell.querySelector('.wbp__cell-img');
        if (im && im.getAttribute('src')) lbOpen(im.getAttribute('src'));
      });
    }
    if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
    if (lbImg) {
      lbImg.addEventListener('click', function (e) {
        e.stopPropagation();
        if (lbScale > 1) { lbSetZoom(1); return; }
        var r = lbImg.getBoundingClientRect();
        lbSetZoom(2, ((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
      });
      lbImg.addEventListener('mousemove', function (e) {
        if (lbScale <= 1) return;
        var r = lbImg.getBoundingClientRect();
        lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
      });
      lbImg.addEventListener('wheel', function (e) {
        e.preventDefault();
        var r = lbImg.getBoundingClientRect();
        lbSetZoom(lbScale + (e.deltaY < 0 ? 0.3 : -0.3), ((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
      }, { passive: false });
    }
    var lbCloseBtn = root.querySelector('[data-wbp-lb-close]');
    if (lbCloseBtn) lbCloseBtn.addEventListener('click', function (e) { e.stopPropagation(); lbClose(); });
    if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIndex - 1); });
    if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIndex + 1); });
    document.addEventListener('keydown', function (e) {
      if (!lb || lb.hidden) return;
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
      else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
    });

    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wedding-bands-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-wbg-grid]');
    if (!root) return;

    // Mobile image-swipe dots: light up the dot for the visible slide.
    root.querySelectorAll('.wbg-card').forEach(function (card) {
      var media = card.querySelector('.wbg-card__media');
      var dots = card.querySelectorAll('.wbg-card__dots i');
      if (!media || dots.length < 2) return;
      media.addEventListener('scroll', function () {
        var i = Math.round(media.scrollLeft / Math.max(1, media.clientWidth));
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }, { passive: true });
    });

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-wbg-item]'));
    if (!items.length) return;
    items.forEach(function (it, i) {
      it.__order = i;
      it.__mainImg = it.querySelector('[data-wbg-main]');
      it.__hoverImg = it.querySelector('[data-wbg-hover]');
      it.__defF = it.__mainImg ? it.__mainImg.getAttribute('src') : '';
      it.__defS = it.__hoverImg ? it.__hoverImg.getAttribute('src') : '';
      it.__defMetal = it.getAttribute('data-default-metal') || 'yellow';
    });

    var list = root.querySelector('[data-wbg-list]');
    var typeEls = Array.prototype.slice.call(root.querySelectorAll('[data-type]'));
    var shapeEls = Array.prototype.slice.call(root.querySelectorAll('[data-facet="shape"]'));
    var metalEls = Array.prototype.slice.call(root.querySelectorAll('[data-facet="metal"]'));
    var priceMinEl = root.querySelector('[data-price-min]');
    var priceMaxEl = root.querySelector('[data-price-max]');
    var sortSel = root.querySelector('[data-wbg-sort]');
    var drawer = root.querySelector('[data-wbg-drawer]');
    var activeWrap = root.querySelector('[data-wbg-active]');
    var resultsEl = root.querySelector('[data-wbg-results]');
    var applyEl = root.querySelector('[data-wbg-apply]');
    var badgeEl = root.querySelector('[data-wbg-badge]');
    var emptyEl = root.querySelector('[data-wbg-empty]');
    var activeTypes = [], activeShapes = [], activeMetals = [];

    function tokens(v) { return (v || '').split(/\s+/).filter(Boolean); }

    // Facet arrays are passed in rather than read from the closure, so the same
    // predicate can answer "what matches now?" and "what would match if this
    // unselected facet were clicked?" — the second is what greys out dead ends.
    function matchesWith(it, types, shapes, metals) {
      if (types.length) {
        var et = tokens(it.getAttribute('data-etype'));
        if (!types.some(function (t) { return et.indexOf(t) !== -1; })) return false;
      }
      if (shapes.length && shapes.indexOf(it.getAttribute('data-shape')) === -1) return false;
      if (metals.length) {
        var mt = tokens(it.getAttribute('data-metals'));
        if (!metals.some(function (m) { return mt.indexOf(m) !== -1; })) return false;
      }
      var pr = parseInt(it.getAttribute('data-price'), 10) || 0;
      var mn = parseFloat(priceMinEl && priceMinEl.value) || 0;
      var mx = parseFloat(priceMaxEl && priceMaxEl.value);
      if (mn > 0 && pr < mn * 100) return false;
      if (!isNaN(mx) && mx > 0 && pr > mx * 100) return false;
      return true;
    }
    function matches(it) { return matchesWith(it, activeTypes, activeShapes, activeMetals); }

    // Result count if `value` were added to the `kind` facet, holding the others.
    function countIf(kind, value) {
      var t = activeTypes.slice(), s = activeShapes.slice(), m = activeMetals.slice();
      var arr = kind === 'type' ? t : kind === 'shape' ? s : m;
      if (arr.indexOf(value) === -1) arr.push(value);
      var n = 0;
      items.forEach(function (it) { if (matchesWith(it, t, s, m)) n++; });
      return n;
    }

    // Grey out any facet that would return nothing. Active facets are never
    // disabled, or you could select one and then be unable to clear it.
    function markDeadEnds(els, kind, attr) {
      els.forEach(function (e) {
        var on = e.classList.contains('is-active');
        var dead = !on && countIf(kind, e.getAttribute(attr)) === 0;
        e.classList.toggle('is-unavailable', dead);
        if (e.tagName === 'BUTTON') e.disabled = dead;
      });
    }

    function sortNow() {
      if (!list) return;
      var mode = sortSel ? sortSel.value : 'featured';
      items.filter(function (it) { return !it.hidden; }).sort(function (a, b) {
        if (mode === 'price-asc') return (parseInt(a.getAttribute('data-price'), 10) || 0) - (parseInt(b.getAttribute('data-price'), 10) || 0);
        if (mode === 'price-desc') return (parseInt(b.getAttribute('data-price'), 10) || 0) - (parseInt(a.getAttribute('data-price'), 10) || 0);
        if (mode === 'carat-asc') return (parseFloat(a.getAttribute('data-carat')) || 0) - (parseFloat(b.getAttribute('data-carat')) || 0);
        if (mode === 'carat-desc') return (parseFloat(b.getAttribute('data-carat')) || 0) - (parseFloat(a.getAttribute('data-carat')) || 0);
        if (mode === 'name') return (a.getAttribute('data-name') || '').localeCompare(b.getAttribute('data-name') || '');
        return a.__order - b.__order;
      }).forEach(function (it) { list.appendChild(it); });
    }

    // Swap each visible card's photo to the last-selected metal (revert to default when cleared).
    function applyDisplay() {
      var dm = activeMetals.length ? activeMetals[activeMetals.length - 1] : null;
      items.forEach(function (it) {
        if (it.hidden || !it.__mainImg) return;
        if (dm) {
          var sw = it.querySelector('.wbg-card__swatch--' + dm + '[data-wbg-img]');
          if (sw) {
            it.__mainImg.setAttribute('src', sw.getAttribute('data-wbg-img'));
            if (it.__hoverImg) it.__hoverImg.setAttribute('src', sw.getAttribute('data-wbg-pair') || sw.getAttribute('data-wbg-img'));
          }
        } else {
          it.__mainImg.setAttribute('src', it.__defF);
          if (it.__hoverImg) it.__hoverImg.setAttribute('src', it.__defS);
        }
        Array.prototype.forEach.call(it.querySelectorAll('.wbg-card__swatch'), function (s) {
          s.classList.toggle('is-active', s.classList.contains('wbg-card__swatch--' + (dm || it.__defMetal)));
        });
      });
    }

    function apply() {
      items.forEach(function (it) { it.hidden = !matches(it); });
      sortNow();
      applyDisplay();
      renderChips();
      reportCounts();
      markDeadEnds(typeEls, 'type', 'data-type');
      markDeadEnds(shapeEls, 'shape', 'data-value');
      markDeadEnds(metalEls, 'metal', 'data-value');
    }

    // The grid sits behind the drawer overlay, so without a running total you
    // cannot see what a facet did until you close the drawer.
    function reportCounts() {
      var n = 0;
      items.forEach(function (it) { if (!it.hidden) n++; });
      var word = n === 1 ? 'band' : 'bands';
      if (resultsEl) resultsEl.textContent = n + ' ' + word;
      if (applyEl) applyEl.textContent = n ? 'View ' + n + ' ' + word : 'No matches';
      if (applyEl) applyEl.disabled = n === 0;
      var active = activeTypes.length + activeShapes.length + activeMetals.length
        + (priceMinEl && priceMinEl.value ? 1 : 0) + (priceMaxEl && priceMaxEl.value ? 1 : 0);
      if (badgeEl) { badgeEl.textContent = active; badgeEl.hidden = active === 0; }
      if (emptyEl) emptyEl.hidden = n !== 0;
    }

    function labelFor(type, value) {
      var sel;
      if (type === 'type') sel = root.querySelector('.wbg-stile[data-type="' + value + '"] .wbg-tile__label') || root.querySelector('.wbg-cat[data-type="' + value + '"] .wbg-cat__label');
      else if (type === 'shape') sel = root.querySelector('.wbg-stile[data-facet="shape"][data-value="' + value + '"] .wbg-tile__label');
      else if (type === 'metal') sel = root.querySelector('.wbg-mtile[data-value="' + value + '"] .wbg-tile__label');
      return sel ? sel.textContent.trim() : value;
    }
    function deselect(kind, value) {
      var i;
      if (kind === 'type') { i = activeTypes.indexOf(value); if (i > -1) activeTypes.splice(i, 1); root.querySelectorAll('[data-type="' + value + '"]').forEach(function (e) { e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); }); }
      else if (kind === 'shape') { i = activeShapes.indexOf(value); if (i > -1) activeShapes.splice(i, 1); root.querySelectorAll('[data-facet="shape"][data-value="' + value + '"]').forEach(function (e) { e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); }); }
      else if (kind === 'metal') { i = activeMetals.indexOf(value); if (i > -1) activeMetals.splice(i, 1); root.querySelectorAll('[data-facet="metal"][data-value="' + value + '"]').forEach(function (e) { e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); }); }
      else if (kind === 'pmin') { if (priceMinEl) priceMinEl.value = ''; }
      else if (kind === 'pmax') { if (priceMaxEl) priceMaxEl.value = ''; }
      apply();
    }
    function clearAll() {
      activeTypes.length = 0; activeShapes.length = 0; activeMetals.length = 0;
      root.querySelectorAll('[data-type].is-active, [data-facet].is-active').forEach(function (e) { e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); });
      if (priceMinEl) priceMinEl.value = '';
      if (priceMaxEl) priceMaxEl.value = '';
      apply();
    }
    function renderChips() {
      if (!activeWrap) return;
      var chips = [];
      activeTypes.forEach(function (v) { chips.push(['type', v, labelFor('type', v)]); });
      activeShapes.forEach(function (v) { chips.push(['shape', v, labelFor('shape', v)]); });
      activeMetals.forEach(function (v) { chips.push(['metal', v, labelFor('metal', v)]); });
      if (priceMinEl && priceMinEl.value) chips.push(['pmin', '', 'Min $' + priceMinEl.value]);
      if (priceMaxEl && priceMaxEl.value) chips.push(['pmax', '', 'Max $' + priceMaxEl.value]);
      activeWrap.innerHTML = '';
      if (!chips.length) { activeWrap.hidden = true; return; }
      activeWrap.hidden = false;
      chips.forEach(function (c) {
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'wbg-chip'; btn.setAttribute('aria-label', 'Remove ' + c[2]);
        btn.appendChild(document.createTextNode(c[2] + ' '));
        var x = document.createElement('span'); x.className = 'wbg-chip__x'; x.setAttribute('aria-hidden', 'true'); x.textContent = '×';
        btn.appendChild(x);
        btn.addEventListener('click', function () { deselect(c[0], c[1]); });
        activeWrap.appendChild(btn);
      });
      var clr = document.createElement('button'); clr.type = 'button'; clr.className = 'wbg-chip wbg-chip--clear'; clr.textContent = 'Clear all';
      clr.addEventListener('click', clearAll);
      activeWrap.appendChild(clr);
    }

    // Style type: the top bar buttons and drawer tiles share data-type, so toggle both.
    // (Unstocked types are plain links to the listing, so they're not in typeEls.)
    function toggleType(key) {
      var i = activeTypes.indexOf(key);
      if (i === -1) activeTypes.push(key); else activeTypes.splice(i, 1);
      var on = activeTypes.indexOf(key) !== -1;
      root.querySelectorAll('[data-type="' + key + '"]').forEach(function (e) { e.classList.toggle('is-active', on); e.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      apply();
    }
    typeEls.forEach(function (e) { e.addEventListener('click', function () { toggleType(e.getAttribute('data-type')); }); });

    function bindFacet(els, arr) {
      els.forEach(function (e) {
        e.addEventListener('click', function () {
          var v = e.getAttribute('data-value'), i = arr.indexOf(v);
          if (i === -1) { arr.push(v); e.classList.add('is-active'); e.setAttribute('aria-pressed', 'true'); }
          else { arr.splice(i, 1); e.classList.remove('is-active'); e.setAttribute('aria-pressed', 'false'); }
          apply();
        });
      });
    }
    bindFacet(shapeEls, activeShapes);
    bindFacet(metalEls, activeMetals);
    if (priceMinEl) priceMinEl.addEventListener('input', apply);
    if (priceMaxEl) priceMaxEl.addEventListener('input', apply);
    if (sortSel) sortSel.addEventListener('change', sortNow);

    // Card metal swatches → swap that card's photos to the chosen metal.
    // Delegated on the grid so it survives re-ordering, and preventDefault stops
    // the click from bubbling into a scroll jump.
    if (list) list.addEventListener('click', function (e) {
      var sw = e.target.closest('.wbg-card__swatch');
      if (!sw || !list.contains(sw)) return;
      e.preventDefault();
      e.stopPropagation();
      var main = sw.getAttribute('data-wbg-img');
      var it = sw.closest('[data-wbg-item]');
      if (!main || !it) return;
      var mimg = it.querySelector('[data-wbg-main]');
      var himg = it.querySelector('[data-wbg-hover]');
      if (mimg) mimg.setAttribute('src', main);
      if (himg) himg.setAttribute('src', sw.getAttribute('data-wbg-pair') || main);
      Array.prototype.forEach.call(it.querySelectorAll('.wbg-card__swatch'), function (s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');
    });

    var openBtn = root.querySelector('[data-wbg-open]');
    function closeDrawer() { if (drawer) { drawer.hidden = true; document.body.style.overflow = ''; } }
    if (openBtn && drawer) {
      openBtn.addEventListener('click', function () { drawer.hidden = false; document.body.style.overflow = 'hidden'; });
      root.querySelectorAll('[data-wbg-close]').forEach(function (c) { c.addEventListener('click', closeDrawer); });
    }
    // Two of these now: the drawer footer and the filtered-to-zero empty state.
    root.querySelectorAll('[data-wbg-clear]').forEach(function (b) { b.addEventListener('click', clearAll); });

    // Pre-select a metal from the URL (mega-menu "Shop by metal").
    try {
      var mp = (new URLSearchParams(window.location.search).get('metal') || '').toLowerCase();
      var key = mp.indexOf('rose') !== -1 ? 'rose' : (mp.indexOf('white') !== -1 || mp.indexOf('platinum') !== -1) ? 'white' : mp.indexOf('yellow') !== -1 ? 'yellow' : '';
      if (key) { var mel = root.querySelector('[data-facet="metal"][data-value="' + key + '"]'); if (mel) mel.click(); }
    } catch (e) {}

    // Pre-select a style category from the URL (mega-menu "Earrings" links).
    try {
      var tp = (new URLSearchParams(window.location.search).get('type') || '').toLowerCase();
      if (tp) { var tel = root.querySelector('.wbg-cat[data-type="' + tp + '"]') || root.querySelector('.wbg-stile[data-type="' + tp + '"]'); if (tel) tel.click(); }
    } catch (e) {}

    apply();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wedding-bands-seo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-wbseo].wbseo--collapsible').forEach(function (root) {
      var toggle = root.querySelector('[data-wbseo-toggle]');
      var label = root.querySelector('[data-wbseo-toggle-label]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var expanded = root.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (label) label.textContent = expanded ? 'Read less' : 'Read more';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-lab-grown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-wl]');
    if (!root) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = root.querySelectorAll('.wl__reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();
})();
